import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instance104q5opgivhr8 as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance2dy62s6vvg5md as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  ArrayList3it5z8td81qkl as ArrayList,
  toList383f556t1dixk as toList,
  toMutableList20rdgwi7d3cwi as toMutableList,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  lazy2hsh8ze7j6ikd as lazy,
  toList3jhuyej2anx2q as toList_0,
  retainAll1hufpctl19y6u as retainAll,
  toSet2orjxp16sotqu as toSet,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  CancellationException3b36o9qz53rgr as CancellationException,
  numberToDouble210hrknaofnhf as numberToDouble,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  Duration5ynfiptaqcrg as Duration,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  returnIfSuspended1qp7gd6asibpv as returnIfSuspended,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  getOrNull1go7ef9ldk0df as getOrNull,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Enum3alwj03lh1n41 as Enum,
  contains1tccixv8iwdcq as contains,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  firstOrNull1982767dljvdy as firstOrNull,
  compareValues1n2ayl87ihzfk as compareValues,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  removeAll3o43e67jmwdpc as removeAll,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getOrNull1d60i0672n7ns as getOrNull_0,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs2ntz2k8jdtq63 as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_0,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
  Level_TRACE_getInstance3v3hjwgnnbwb6 as Level_TRACE_getInstance,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  Level_DEBUG_getInstance2cjwrm9110zsz as Level_DEBUG_getInstance,
} from './korlibs-korlibs-logger.mjs';
import {
  Companion_getInstance15h5aaybcsdep as Companion_getInstance_1,
  invoke2sf88d1xeuyqh as invoke,
  Signal3nnez3346azzf as Signal,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
} from './korlibs-korlibs-concurrent.mjs';
import {
  withContext2i47m7ae4v1sd as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScopesisx8kbb9f8x as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance3o7pj7ik1b183 as Key_instance,
  Job13y4jkazwjho0 as Job,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout3hvfy7xgqgnvm as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance1qvds1isfbag2 as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2cnrrhh9rakoc as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf63jsbsnnrny7w3 as RGBA__hashCode_impl_h59qf6,
  readBitmap1dn2o52mvbpv4 as readBitmap,
  Bitmaps_instancebct336c8d0m7 as Bitmaps_instance,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance7pcf1jiur1zr as EmptyShape_instance,
  readBitmapSlice1mxfjm5uys58e as readBitmapSlice,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  readFont45tmpsdawgck as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfwwtut2j2hfgv as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y61hxbkot1sg4z0 as VerticalAlign__getOffsetY_impl_iso0y6,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstance2fl1toxz5lf8a as Companion_getInstance_2,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Font2bg7nte760csr as Font,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke_0,
  LineInfo27uw564y6w2d2 as LineInfo,
  _VerticalAlign___get_ratioFake__impl__1h2fwv3b9t7y5yljykc as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance1rfeljt05xntw as Companion_getInstance_3,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmzp2nzhttcejz as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqt1opkd4mw5vm2z as _RGBA___get_rgb__impl__tijaqt,
  TileMapRepeat_NONE_getInstance1rwcpdxdrcp50 as TileMapRepeat_NONE_getInstance,
  _Tile___get_isInvalid__impl__yfg9ed173l8j2a3h38e as _Tile___get_isInvalid__impl__yfg9ed,
  _Tile___get_tile__impl__nfq1aw343zt1qckjepn as _Tile___get_tile__impl__nfq1aw,
  _Tile___get_flipX__impl__jobqpfe9cgmzzfemed as _Tile___get_flipX__impl__jobqpf,
  _Tile___get_flipY__impl__95aqcseyyd2ly5g92f as _Tile___get_flipY__impl__95aqcs,
  _Tile___get_rotate__impl__5kjdv91g1hqxlteoxnf as _Tile___get_rotate__impl__5kjdv9,
  _Tile___get_offsetX__impl__qwhdsd2u0qshojurkrv as _Tile___get_offsetX__impl__qwhdsd,
  _Tile___get_offsetY__impl__1x539um3hkx58tbqvt as _Tile___get_offsetY__impl__1x539u,
  TileMapData285v3okd3krdh as TileMapData,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqcbb8bnh8j0y24 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hyhrkrjwkiqj0l as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-korlibs-image.mjs';
import {
  Companion_instance2bvf2vakw640b as Companion_instance_0,
  Companion_instance2mxqoacslm62w as Companion_instance_1,
  Companion_getInstance3moaeo8p2fvjj as Companion_getInstance_4,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__times_impl_h6amcp25vm4d6obfh9l as FastDuration__times_impl_h6amcp,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  FastDuration__compareTo_impl_4fhnj71uadlvoozsr50 as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_fastMilliseconds__impl__pe68va279q35r54j5bc as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__compareTo_impl_4fhnj71anf17lkhs1by as FastDuration__compareTo_impl_4fhnj7_0,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__toString_impl_c9xohb3cvph1y7s95v4 as FastDuration__toString_impl_c9xohb,
  FastDuration__plus_impl_q1enab3lvjsvnxno7fk as FastDuration__plus_impl_q1enab,
  _FastDuration___get_fastSeconds__impl__amo4s3p9zx52w3o39j as _FastDuration___get_fastSeconds__impl__amo4s3,
  FastDuration__minus_impl_evs2371fjveki3j5gyc as FastDuration__minus_impl_evs237,
  get_slowaqovrrnrezzv as get_slow,
  get_fast37cu8s8qwnuyi as get_fast,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  FastDuration__div_impl_rlslck1plvf7n5rb7aa as FastDuration__div_impl_rlslck,
  _FastDuration___get_nanoseconds__impl__pxizcb3qjtomx85900t as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g13hz45luccu2o2 as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck15f8mt5g6dyds as FastDuration__div_impl_rlslck_0,
  DateTime__minus_impl_10njw81nqbgaa48pgq4 as DateTime__minus_impl_10njw8,
  _FastDuration___get_milliseconds__impl__ffr17uhz706a3hbxx1 as _FastDuration___get_milliseconds__impl__ffr17u,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
} from './korlibs-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injector13ltfovoybm52 as injector,
} from './korlibs-korlibs-inject.mjs';
import {
  Companion_getInstance12gtxroo40wno as Companion_getInstance_5,
  DefaultViewport_getInstance3j3s2jy6zu9ca as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2im0li1v0jac6 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1i7uio6gustu7 as KorgeReload_getInstance,
  configureLoggerFromProperties1t3glidkjwd17 as configureLoggerFromProperties,
  CoroutineKey_getInstance3nlh6pc2noqhi as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance1x6f2nb0du729 as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstancegn6n8lkvuoxm as Type_START_getInstance,
  Status_ADD_getInstance2ikhpw2btzfzo as Status_ADD_getInstance,
  Type_END_getInstance331lr99r7xh7i as Type_END_getInstance,
  Status_REMOVE_getInstance21rl9vf9qjrb0 as Status_REMOVE_getInstance,
  Type_MOVE_getInstance2g4jkr289s1a8 as Type_MOVE_getInstance,
  Status_KEEP_getInstance3p1s7ste35m5y as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2dunhocwmk9pi as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance3nknmoqnyfvel as Type_DRAG_getInstance,
  Type_UP_getInstance3cbsyzwl1abw4 as Type_UP_getInstance,
  Type_DOWN_getInstance20slx18g3n9iw as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstance2sn5bsju340al as Companion_getInstance_6,
  Companion_getInstancezx9mtebwpbyq as Companion_getInstance_7,
  Companion_getInstancex1pk9m73g9c6 as Companion_getInstance_8,
  Companion_getInstance35vn8xpzue606 as Companion_getInstance_9,
  Companion_instance2kf6v2is0lhhr as Companion_instance_2,
  Companion_instancelgkpg07onuw2 as Companion_instance_3,
  Companion_instance2ffiktwt5nfeb as Companion_instance_4,
  Companion_instance3nf2h14fw03zr as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance18fciagsd02o3 as Companion_getInstance_10,
  Companion_getInstancenz8ykkb6phk0 as Companion_getInstance_11,
  Companion_instanceozmuwjcmdf52 as Companion_instance_6,
  Companion_instancez9q7819xwnc1 as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instancekrhj1pqvxv6j as Companion_instance_8,
  incrvqd3aj0o2965 as incr,
  V22su20mpwty0v0 as V2,
  _interpolateFloat22vwsp58cwzfw as _interpolateFloat,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Type_TYPE_getInstanceae1nnzr8xwbc as Type_TYPE_getInstance,
  Type_DOWN_getInstance313b56cnb7a70 as Type_DOWN_getInstance_0,
  Type_UP_getInstance14prrhxnriw3z as Type_UP_getInstance_0,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance27u34u1y8yo31 as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  Companion_instance18k7zco3357fp as Companion_instance_9,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance2hvv939x49crx as Companion_getInstance_12,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance24kbqbtea649t as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance3jgth1v8sehkm as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  Companion_getInstance29r688krv3c4g as Companion_getInstance_14,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont119k9qsj5fsyz as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance3iwen1o4s4mlo as Key_F12_getInstance,
  Key_F7_getInstance1rgyn6mno38yl as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
  TEXTURED_ARRAY_quadIndices1vrv67jygypre as TEXTURED_ARRAY_quadIndices,
  ShrinkableTexturedVertexArray2dp7296cmttgp as ShrinkableTexturedVertexArray,
  Companion_getInstance1r9b3td34f16o as Companion_getInstance_15,
  Companion_getInstancer6z1nlxalqx7 as Companion_getInstance_16,
  Companion_getInstancey5u5n7g62xvk as Companion_getInstance_17,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai83dsldtujda2h7 as _AGColorMask___init__impl__j38ai8,
  Companion_getInstance2v5l7b83xykmk as Companion_getInstance_18,
  AGStencilOpFunc__withEnabled_impl_mpcwmrtmo0h8rbfy7w as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv5p5tszphd23r as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance19lgm19ipf6do as Companion_getInstance_19,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo33l2pvqtfq9yj as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b43mm4w8krkt3ep as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance2sk7vs29gnik3 as Companion_getInstance_20,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at30n6rjhwnoxep as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx1g2sfp701cvyr as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m26xkfw1943nj2 as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0v232x7ttx8ekye as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai814mo4mz42teo7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance18pjxyoy9tzln as Companion_getInstance_21,
  AGDrawType__toString_impl_eonaeb25w5br3wcp5j8 as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqg2gcs1m2a75488 as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy5ckch3y49o93 as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8sbb7dfey0kemg as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891wpots1bgmosc2 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylauryzr6i7tjdryw8 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fi7509ibyna3k as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb7w0dexbvx0dj as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx2wwwwyq5gfu31 as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5ur1en9y9rx0mxgq as AGCullFace__hashCode_impl_t4e5ur,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  DefaultShaders_getInstance11xvl6rr8iso as DefaultShaders_getInstance,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance26tgtz9tkdb0r as VarType_Float2_getInstance,
  If1av5krmfyt44s as If,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance2yyqoe6yly9a9 as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstance45g8detuxjnt as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  VertexShader26kcg39ndf3s1 as VertexShader,
  Program1hnygp9hph4ry as Program,
  Companion_instance3jw50k8jil3sx as Companion_instance_10,
  Companion_getInstance2milgz47dwnlh as Companion_getInstance_22,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance19z3k1g06rka6 as Companion_getInstance_23,
  Companion_getInstance21plr7f541fx9 as Companion_getInstance_24,
  Companion_getInstancew949xxob44bw as Companion_getInstance_25,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_26,
  Rectangle3q03woyn9k8x1 as Rectangle,
  place35kwuvwdaw5nl as place,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_27,
  Scale2cm697xlulcp5 as Scale,
  Companion_getInstance3om7tc9mg7edv as Companion_getInstance_28,
  BoundsBuilder__plus_impl_cz7f7x3pz0lxdivao0o as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx3cti8ahdxq1b5 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_29,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance1ygiwm9bgjia3 as Companion_getInstance_30,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw1zqnfrqkp8did as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv3gpdj6wpeuir3 as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  Companion_getInstance9hqru60m2833 as Companion_getInstance_31,
  BoundsBuilder__plus_impl_cz7f7x11d6y0i85df0y as BoundsBuilder__plus_impl_cz7f7x_0,
  _BoundsBuilder___get_xmax__impl__gsz0km3izaxmrwq1yh1 as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib014moqt3x1cfln as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2y6v142m2imsu as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8jlouwj806h8ky as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-korlibs-math-vector.mjs';
import {
  Companion_getInstancech3bi94cc2ym as Companion_getInstance_32,
  convertRange1a6ancvyn151r as convertRange,
  clamp011ml7wx1d2b7sp as clamp01,
  toRatio1hooqit5gulhr as toRatio,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance_33,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2hpoo0nu4cwhr as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2ienc1iwi3w3dhe1b7 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup5294anfb3s41c1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toLongRound7crzegvo2qbo as toLongRound,
  toIntCeil3h286vm49zgwd as toIntCeil,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange_0,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  insert2fz5125p2hdyd as insert,
  minhi4sj3tfj9ww as min,
  max329dnql9l08bp as max,
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
} from './korlibs-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_EASElq2v0gsk9fz7 as get_EASE,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  get_immutablepxpdoj6e54ll as get_immutable,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance8e3pzrc8s6ce as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance2zsru2lm79i6x as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2502q1le8nox0 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstanceb57ygh36gdst as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance3doesgezxmixn as LineJoin_MITER_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
} from './korlibs-korlibs-math.mjs';
import {
  Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_34,
  cancel1n0qjc93h2v6w as cancel_0,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Closeable2m9yv0b0gma2l as Closeable,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance21jklwk36y3dn as Companion_instance_11,
} from './korlibs-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance23wo5gavc7ilf as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x37zmlsrxcrsca as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance1fqld9q4wfq20 as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  launchUnscopedAndWait6v8yfjb8olf5 as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instance3ckwvxznkwud8 as StandardPaths_instance,
} from './korlibs-korlibs-io.mjs';
import {
  Companion_instance3c5rz779n238s as Companion_instance_13,
  Dyn__set_impl_2ozvx82r2n5zj0vrm3z as Dyn__set_impl_2ozvx8,
} from './korlibs-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-korlibs-audio.mjs';
import {
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
  Mixin3lmkm5hum2vdj as Mixin,
  getExtra307y0o9pd6mp3 as getExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
} from './korlibs-korlibs-datastructure-core.mjs';
import {
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  get2pw1zlgv5zypd as get,
  set2vuztm9k7ubgo as set,
  FastIdentityCacheMap3fegd59qa1ixp as FastIdentityCacheMap,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m37epj48967hb0 as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9x3g4pb23dnjw1t as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.x8d_1 = Companion_getInstance_0().us('Korge');
    this.y8d_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  z8d(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  pd(p1, $completion) {
    return this.z8d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.m8c_1 = this$0;
    this.n8c_1 = $entry;
  }
  e1k($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$withContext, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.e1k((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit) {
    Companion_getInstance_35();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_35().y8d_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_5().f7p_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().r7m_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_36().b3g() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().l3n_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().k3n_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    unit = unit === VOID ? Unit_instance : unit;
    this.o8c_1 = args;
    this.p8c_1 = imageFormats;
    this.q8c_1 = gameWindow;
    this.r8c_1 = mainSceneClass;
    this.s8c_1 = timeProvider;
    this.t8c_1 = injector;
    this.u8c_1 = configInjector;
    this.v8c_1 = debug;
    this.w8c_1 = trace;
    this.x8c_1 = context;
    this.y8c_1 = fullscreen;
    this.z8c_1 = blocking;
    this.a8d_1 = gameId;
    this.b8d_1 = settingsFolder;
    this.c8d_1 = batchMaxQuads;
    this.d8d_1 = windowSize;
    this.e8d_1 = virtualSize;
    this.f8d_1 = displayMode;
    this.g8d_1 = title;
    this.h8d_1 = backgroundColor;
    this.i8d_1 = quality;
    this.j8d_1 = icon;
    this.k8d_1 = multithreaded;
    this.l8d_1 = forceRenderEveryFrame;
    this.m8d_1 = windowCreationConfig;
    this.n8d_1 = main;
    this.o8d_1 = debugAg;
    this.p8d_1 = debugFontExtraScale;
    this.q8d_1 = debugFontColor;
    this.r8d_1 = stageBuilder;
    this.s8d_1 = targetFps;
    this.t8d_1 = preferSyncIo;
    this.u8d_1 = unit;
  }
  u8g(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu(this, entry, $completion), $completion);
  }
  v8g(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit);
  }
  v8d(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit, $super) {
    args = args === VOID ? this.o8c_1 : args;
    imageFormats = imageFormats === VOID ? this.p8c_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.q8c_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.r8c_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.s8c_1 : timeProvider;
    injector = injector === VOID ? this.t8c_1 : injector;
    configInjector = configInjector === VOID ? this.u8c_1 : configInjector;
    debug = debug === VOID ? this.v8c_1 : debug;
    trace = trace === VOID ? this.w8c_1 : trace;
    context = context === VOID ? this.x8c_1 : context;
    fullscreen = fullscreen === VOID ? this.y8c_1 : fullscreen;
    blocking = blocking === VOID ? this.z8c_1 : blocking;
    gameId = gameId === VOID ? this.a8d_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.b8d_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.c8d_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.d8d_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.e8d_1 : virtualSize;
    displayMode = displayMode === VOID ? this.f8d_1 : displayMode;
    title = title === VOID ? this.g8d_1 : title;
    backgroundColor = backgroundColor === VOID ? this.h8d_1 : backgroundColor;
    quality = quality === VOID ? this.i8d_1 : quality;
    icon = icon === VOID ? this.j8d_1 : icon;
    multithreaded = multithreaded === VOID ? this.k8d_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.l8d_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.m8d_1 : windowCreationConfig;
    main = main === VOID ? this.n8d_1 : main;
    debugAg = debugAg === VOID ? this.o8d_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.p8d_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.q8d_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.r8d_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.s8d_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.t8d_1 : preferSyncIo;
    unit = unit === VOID ? this.u8d_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.v8g(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit);
    } else {
      var tmp_0 = $super.v8g;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.o8c_1);
    var tmp_0 = this.p8c_1.toString();
    var tmp_1 = toString_0(this.q8c_1);
    var tmp_2 = toString_0(this.r8c_1);
    var tmp_3 = toString(this.s8c_1);
    var tmp_4 = this.t8c_1.toString();
    var tmp_5 = toString(this.u8c_1);
    var tmp_6 = toString_0(this.x8c_1);
    var tmp_7 = this.d8d_1.toString();
    var tmp_8 = this.e8d_1.toString();
    var tmp_9 = this.f8d_1.toString();
    var tmp_10 = this.h8d_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.v8c_1 + ', trace=' + this.w8c_1 + ', context=' + tmp_6 + ', fullscreen=' + this.y8c_1 + ', blocking=' + this.z8c_1 + ', gameId=' + this.a8d_1 + ', settingsFolder=' + this.b8d_1 + ', batchMaxQuads=' + this.c8d_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.g8d_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.i8d_1) + ', icon=' + this.j8d_1 + ', multithreaded=' + this.k8d_1 + ', forceRenderEveryFrame=' + this.l8d_1 + ', windowCreationConfig=' + this.m8d_1.toString() + ', main=' + toString(this.n8d_1) + ', debugAg=' + this.o8d_1 + ', debugFontExtraScale=' + this.p8d_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.q8d_1) + ', stageBuilder=' + toString(this.r8d_1) + ', targetFps=' + this.s8d_1 + ', preferSyncIo=' + this.t8d_1 + ', unit=' + this.u8d_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.o8c_1);
    result = imul(result, 31) + hashCode(this.p8c_1) | 0;
    result = imul(result, 31) + (this.q8c_1 == null ? 0 : hashCode(this.q8c_1)) | 0;
    result = imul(result, 31) + (this.r8c_1 == null ? 0 : this.r8c_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.s8c_1) | 0;
    result = imul(result, 31) + hashCode(this.t8c_1) | 0;
    result = imul(result, 31) + hashCode(this.u8c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v8c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w8c_1) | 0;
    result = imul(result, 31) + (this.x8c_1 == null ? 0 : hashCode(this.x8c_1)) | 0;
    result = imul(result, 31) + (this.y8c_1 == null ? 0 : getBooleanHashCode(this.y8c_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z8c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a8d_1) | 0;
    result = imul(result, 31) + (this.b8d_1 == null ? 0 : getStringHashCode(this.b8d_1)) | 0;
    result = imul(result, 31) + this.c8d_1 | 0;
    result = imul(result, 31) + this.d8d_1.hashCode() | 0;
    result = imul(result, 31) + this.e8d_1.hashCode() | 0;
    result = imul(result, 31) + this.f8d_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g8d_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.h8d_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.h8d_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.i8d_1.hashCode() | 0;
    result = imul(result, 31) + (this.j8d_1 == null ? 0 : getStringHashCode(this.j8d_1)) | 0;
    result = imul(result, 31) + (this.k8d_1 == null ? 0 : getBooleanHashCode(this.k8d_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l8d_1) | 0;
    result = imul(result, 31) + this.m8d_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o8d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p8d_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.q8d_1) | 0;
    result = imul(result, 31) + hashCode(this.r8d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s8d_1) | 0;
    result = imul(result, 31) + (this.t8d_1 == null ? 0 : getBooleanHashCode(this.t8d_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.o8c_1, tmp0_other_with_cast.o8c_1))
      return false;
    if (!equals(this.p8c_1, tmp0_other_with_cast.p8c_1))
      return false;
    if (!equals(this.q8c_1, tmp0_other_with_cast.q8c_1))
      return false;
    if (!equals(this.r8c_1, tmp0_other_with_cast.r8c_1))
      return false;
    if (!equals(this.s8c_1, tmp0_other_with_cast.s8c_1))
      return false;
    if (!equals(this.t8c_1, tmp0_other_with_cast.t8c_1))
      return false;
    if (!equals(this.u8c_1, tmp0_other_with_cast.u8c_1))
      return false;
    if (!(this.v8c_1 === tmp0_other_with_cast.v8c_1))
      return false;
    if (!(this.w8c_1 === tmp0_other_with_cast.w8c_1))
      return false;
    if (!equals(this.x8c_1, tmp0_other_with_cast.x8c_1))
      return false;
    if (!(this.y8c_1 == tmp0_other_with_cast.y8c_1))
      return false;
    if (!(this.z8c_1 === tmp0_other_with_cast.z8c_1))
      return false;
    if (!(this.a8d_1 === tmp0_other_with_cast.a8d_1))
      return false;
    if (!(this.b8d_1 == tmp0_other_with_cast.b8d_1))
      return false;
    if (!(this.c8d_1 === tmp0_other_with_cast.c8d_1))
      return false;
    if (!this.d8d_1.equals(tmp0_other_with_cast.d8d_1))
      return false;
    if (!this.e8d_1.equals(tmp0_other_with_cast.e8d_1))
      return false;
    if (!this.f8d_1.equals(tmp0_other_with_cast.f8d_1))
      return false;
    if (!(this.g8d_1 === tmp0_other_with_cast.g8d_1))
      return false;
    var tmp = this.h8d_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.h8d_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.i8d_1.equals(tmp0_other_with_cast.i8d_1))
      return false;
    if (!(this.j8d_1 == tmp0_other_with_cast.j8d_1))
      return false;
    if (!(this.k8d_1 == tmp0_other_with_cast.k8d_1))
      return false;
    if (!(this.l8d_1 === tmp0_other_with_cast.l8d_1))
      return false;
    if (!this.m8d_1.equals(tmp0_other_with_cast.m8d_1))
      return false;
    if (!equals(this.n8d_1, tmp0_other_with_cast.n8d_1))
      return false;
    if (!(this.o8d_1 === tmp0_other_with_cast.o8d_1))
      return false;
    if (!equals(this.p8d_1, tmp0_other_with_cast.p8d_1))
      return false;
    if (!(this.q8d_1 === tmp0_other_with_cast.q8d_1))
      return false;
    if (!equals(this.r8d_1, tmp0_other_with_cast.r8d_1))
      return false;
    if (!equals(this.s8d_1, tmp0_other_with_cast.s8d_1))
      return false;
    if (!(this.t8d_1 == tmp0_other_with_cast.t8d_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.q8g_1 = new KorgeDisplayMode(Companion_getInstance_23().o2b_1, Companion_getInstance_24().e21(), true);
    this.r8g_1 = new KorgeDisplayMode(Companion_getInstance_23().o2b_1, Companion_getInstance_24().e21(), false);
    this.s8g_1 = new KorgeDisplayMode(Companion_getInstance_23().o2b_1, Companion_getInstance_24().s20_1, false);
    this.t8g_1 = new KorgeDisplayMode(Companion_getInstance_23().q2b_1, Companion_getInstance_24().s20_1, false);
  }
  b3g() {
    return this.q8g_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_36();
    this.w8g_1 = scaleMode;
    this.x8g_1 = scaleAnchor;
    this.y8g_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.w8g_1.toString() + ', scaleAnchor=' + this.x8g_1.toString() + ', clipBorders=' + this.y8g_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.w8g_1);
    result = imul(result, 31) + this.x8g_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y8g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.w8g_1, tmp0_other_with_cast.w8g_1))
      return false;
    if (!this.x8g_1.equals(tmp0_other_with_cast.x8g_1))
      return false;
    if (!(this.y8g_1 === tmp0_other_with_cast.y8g_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.n8j_1 = $config;
    this.o8j_1 = $views;
    this.p8j_1 = $entry;
    this.q8j_1 = $gameWindow;
  }
  e1k($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $this$coroutineScope, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.e1k((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.t8o_1 = $config;
    this.u8o_1 = $views;
    this.v8o_1 = $entry;
    this.w8o_1 = $gameWindow;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1(this, $completion), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.x8o_1 = $realGameWindow;
    this.y8o_1 = $windowSize;
    this.z8o_1 = $config;
    this.a8p_1 = $iconPath;
    this.b8p_1 = $imageFormats;
    this.c8p_1 = $entry;
  }
  k8p($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2(this, $this$loop, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.k8p(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.l8p_1 = $views;
  }
  od($completion) {
    this.l8p_1.z5();
  }
}
class KorgeRunner {
  w8d(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3(this, config, $completion), $completion);
  }
  g8p(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.g8h_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.q5n(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.f8h_1;
    injector.q5n(getKClass(AG), instance);
    injector.q5n(getKClass(Resources), views.n8p());
    var tmp = getKClass(ResourcesRoot);
    injector.t5n(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.h8h_1;
    injector.q5n(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.j8h_1;
    injector.q5n(getKClass(Stats), instance_1);
    injector.q5n(getKClass(CoroutineContext), views.e8h_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.u5n(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.q5n(getKClass(TimeProvider), views.i8h_1);
    configInjector(injector);
    var input = views.h8h_1;
    var ag = views.f8h_1;
    var downPos = {_v: Companion_getInstance_26().v21_1};
    var upPos = {_v: Companion_getInstance_26().v21_1};
    var downTime = {_v: new DateTime(Companion_getInstance_4().s1n_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_4().s1n_1)};
    var upTime = Companion_getInstance_4().s1n_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.o8p(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_6().m5s_1.slice();
    eventDispatcher.y5q(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_7().y5r_1.slice();
    eventDispatcher.y5q(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_8().l5t_1.slice();
    eventDispatcher.y5q(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_9().s5t_1.slice();
    eventDispatcher.y5q(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.m5q(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.m5q(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.m5q(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.m5q(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_10().h5u_1.slice();
    eventDispatcher.y5q(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_11().m5w_1.slice();
    eventDispatcher.y5q(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.m5q(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.m5q(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.x5q(new ReshapeEvent(0, 0, views.p8p(), views.q8p()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.m5q(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.e8i_1 = clearEachFrame;
    views.f8i_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.k8h_1.g81(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  z8d(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  pd(p1, $completion) {
    return this.z8d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  z8d(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  pd(p1, $completion) {
    return this.z8d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.a8q_1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    this.b8q_1 = 128.0;
    this.c8q_1 = get_EASE(Companion_getInstance_32());
    this.d8q_1 = true;
  }
}
class RootAnimationNode {
  constructor($outer) {
    this.y8q_1 = $outer;
    this.w8q_1 = null;
    this.x8q_1 = fastArrayListOf([]);
  }
  e2h() {
    this.w8q_1 = null;
  }
  z8q(dt) {
    var dt_0 = !(this.y8q_1.q8q_1 === 1.0) ? FastDuration__times_impl_h6amcp(dt, this.y8q_1.q8q_1) : dt;
    ensureInit(this.y8q_1);
    if (this.y8q_1.i8q_1) {
      var completedTime = get_fastSeconds(0);
      this.x8q_1.j3();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = this.y8q_1.p8q_1.z();
      while (tmp0_iterator.a1()) {
        var item = tmp0_iterator.b1();
        // Inline function 'korlibs.korge.animate.RootAnimationNode.update.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var result = item.z8q(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7(result, get_fastSeconds(0)) >= 0) {
          this.x8q_1.f(item);
        }
        var tmp;
        if (index_0 === 0) {
          tmp = result;
        } else {
          // Inline function 'kotlin.math.min' call
          var a = _FastDuration___get_fastMilliseconds__impl__pe68va(completedTime);
          var b = _FastDuration___get_fastMilliseconds__impl__pe68va(result);
          var tmp$ret$0 = Math.min(a, b);
          tmp = get_fastMilliseconds(tmp$ret$0);
        }
        completedTime = tmp;
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.x8q_1.f1()) {
        this.y8q_1.p8q_1.z2h(this.x8q_1);
      }
      this.x8q_1.j3();
      this.y8q_1.t8q_1 = true;
      return completedTime;
    }
    $l$loop: while (true) {
      if (this.w8q_1 == null) {
        var tmp_0 = this;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.y8q_1.p8q_1.f1()) {
          tmp_1 = this.y8q_1.p8q_1.xj();
        } else {
          tmp_1 = null;
        }
        tmp_0.w8q_1 = tmp_1;
        var tmp19_safe_receiver = this.w8q_1;
        if (tmp19_safe_receiver == null)
          null;
        else {
          tmp19_safe_receiver.e2h();
        }
        if (this.y8q_1.j8q_1) {
          var tmp20_safe_receiver = this.w8q_1;
          if (tmp20_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this.y8q_1.p8q_1.q2h(tmp20_safe_receiver);
          }
        }
      }
      if (!(this.w8q_1 == null)) {
        var node = ensureNotNull(this.w8q_1);
        var extraTime = node.z8q(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().vi_1) >= 0) {
          this.w8q_1 = null;
          dt_0 = extraTime;
        }
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().vi_1) > 0) {
          continue $l$loop;
        }
      }
      var tmp_2;
      var tmp_3;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.y8q_1.p8q_1.f1()) {
        tmp_3 = true;
      } else {
        tmp_3 = !(this.w8q_1 == null);
      }
      if (tmp_3) {
        tmp_2 = get_fastSeconds(-1);
      } else {
        tmp_2 = Companion_instance_1.b1o();
      }
      return tmp_2;
    }
  }
  toString() {
    return 'RootAnimationNode(' + toString(this.y8q_1) + ')';
  }
}
class TweenNode {
  constructor(vs, lazyVs, time, lazyTime, easing, name) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? get_fastMilliseconds_0(1000) : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    name = name === VOID ? null : name;
    this.r8p_1 = vs;
    this.s8p_1 = lazyVs;
    this.t8p_1 = time;
    this.u8p_1 = lazyTime;
    this.v8p_1 = easing;
    this.w8p_1 = name;
    var tmp = this;
    tmp.x8p_1 = lazy(Animator$TweenNode$computedVs$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.y8p_1 = lazy(Animator$TweenNode$totalTime$delegate$lambda(this));
    this.z8p_1 = Companion_instance_1.b1o();
  }
  a8r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x8p_1;
    computedVs$factory();
    return this_0.t1();
  }
  toString() {
    return 'TweenNode(totalTime=' + FastDuration__toString_impl_c9xohb(_get_totalTime__xgts5c(this)) + ', name=' + this.w8p_1 + ', ' + toString(toList_0(this.a8r())) + ')';
  }
  e2h() {
    this.z8p_1 = Companion_instance_1.b1o();
  }
  z8q(dt) {
    if (equals(this.z8p_1, Companion_instance_1.b1o())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.a8r();
      var n = 0;
      while (n < this_0.d1()) {
        // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.c1(_unary__edvuaz).b2z();
      }
    }
    this.z8p_1 = FastDuration__plus_impl_q1enab(this.z8p_1, dt);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.a8r();
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_1.c1(_unary__edvuaz_0);
      var ratio = equals(_get_totalTime__xgts5c(this), Companion_instance_1.b1o()) ? 1.0 : convertRange(_FastDuration___get_fastSeconds__impl__amo4s3(this.z8p_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.v7w_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.b7x(_get_totalTime__xgts5c(this))), 0.0, 1.0);
      if (ratio >= 0.0) {
        it.c7x(toRatio(this.v8p_1.mt(clamp01(ratio))));
      }
    }
    return FastDuration__minus_impl_evs237(this.z8p_1, _get_totalTime__xgts5c(this));
  }
}
class BlockNode {
  constructor(name, callback) {
    name = name === VOID ? null : name;
    this.b8r_1 = name;
    this.c8r_1 = callback;
    this.d8r_1 = false;
  }
  toString() {
    return 'BlockNode(name=' + this.b8r_1 + ')';
  }
  e2h() {
    this.d8r_1 = false;
  }
  z8q(dt) {
    this.e8r();
    return dt;
  }
  e8r() {
    if (this.d8r_1)
      return Unit_instance;
    this.d8r_1 = true;
    this.c8r_1();
  }
}
class Animator {
  constructor(root, fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, parent, lazyInit, level, startImmediately) {
    Companion_getInstance_37();
    parallel = parallel === VOID ? false : parallel;
    looped = looped === VOID ? false : looped;
    lazyInit = lazyInit === VOID ? null : lazyInit;
    this.e8q_1 = root;
    this.f8q_1 = fastDefaultTime;
    this.g8q_1 = defaultSpeed;
    this.h8q_1 = defaultEasing;
    this.i8q_1 = parallel;
    this.j8q_1 = looped;
    this.k8q_1 = parent;
    this.l8q_1 = lazyInit;
    this.m8q_1 = level;
    this.n8q_1 = startImmediately;
    this.o8q_1 = new Signal();
    this.p8q_1 = TGenDeque.p2h();
    this.q8q_1 = 1.0;
    this.r8q_1 = null;
    this.s8q_1 = false;
    this.t8q_1 = false;
    this.u8q_1 = new RootAnimationNode(this);
  }
  h8r() {
    return get_slow(this.f8q_1);
  }
  v8q() {
    var tmp4_safe_receiver = this.k8q_1;
    var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.v8q();
    return tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
  }
  i8r(props) {
    var _iterator__ex2g4s = this.p8q_1.z();
    while (_iterator__ex2g4s.a1()) {
      var node = _iterator__ex2g4s.b1();
      if (node instanceof TweenNode) {
        var tmp = node.a8r();
        retainAll(tmp, Animator$removeProps$lambda(props));
      }
    }
  }
  j8r(node) {
    this.p8q_1.w2h(node);
    ensure(this);
  }
  z5() {
    this.g8r();
  }
  lo(e) {
    this.g8r();
  }
  g8r() {
    this.u8q_1.e2h();
    this.p8q_1.j3();
    var tmp6_safe_receiver = this.v8q().r8q_1;
    if (tmp6_safe_receiver == null)
      null;
    else {
      cancel_0(tmp6_safe_receiver);
    }
    this.v8q().r8q_1 = null;
    this.t8q_1 = false;
    invoke(this.o8q_1);
    return this;
  }
  k8r(vs, lazyVs, time, lazyTime, easing, name, replace) {
    if (replace && this.i8q_1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(vs.length);
      var inductionVariable = 0;
      var last = vs.length;
      while (inductionVariable < last) {
        var item = vs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.Animator.__tween.<anonymous>' call
        var tmp$ret$0 = item.q7w_1;
        destination.f(tmp$ret$0);
      }
      this.i8r(toSet(destination));
    }
    this.j8r(new TweenNode(vs.slice(), lazyVs, time, lazyTime, easing, name));
  }
  l8r(vs, lazyVs, time, lazyTime, easing, name, replace, $super) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? this.f8q_1 : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    easing = easing === VOID ? this.h8q_1 : easing;
    replace = replace === VOID ? true : replace;
    var tmp;
    if ($super === VOID) {
      this.k8r(vs, lazyVs, time, lazyTime, easing, name, replace);
      tmp = Unit_instance;
    } else {
      tmp = $super.k8r.call(this, vs, lazyVs, new FastDuration(time), lazyTime, easing, name, replace);
    }
    return tmp;
  }
}
class KeysEvents$down$slambda {
  constructor($callback) {
    this.q8r_1 = $callback;
  }
  f8s(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4(this, it, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$down$slambda_0 {
  constructor($key, $callback) {
    this.r8r_1 = $key;
    this.s8r_1 = $callback;
  }
  f8s(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5(this, it, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.z8r_1 = this$0;
    this.a8s_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6(this, $completion), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.b8s_1 = this$0;
    this.c8s_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7(this, $completion), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.d8s_1 = this$0;
    this.e8s_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8(this, $completion), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.t8r_1 = view;
    this.v8r_1 = new AsyncSignal();
    this.w8r_1 = new AsyncSignal();
    this.x8r_1 = new AsyncSignal();
    this.y8r_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.t8r_1.m5q(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.t8r_1.m5q(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.t8r_1.m5q(tmp_1, KeysEvents$lambda_1(this));
  }
  g8s() {
    var tmp = this.u8r_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  h8s(callback) {
    return this.v8r_1.r1p(KeysEvents$down$slambda_1(callback));
  }
  i8s(key, callback) {
    return this.v8r_1.r1p(KeysEvents$down$slambda_2(key, callback));
  }
  z5() {
    this.y8r_1.z5();
  }
}
class Scene {
  constructor() {
    this.j8s_1 = new Mixin();
    this.o8s_1 = Container.h8v();
    this.p8s_1 = new CancellableGroup();
    var tmp = this;
    tmp.q8s_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r8s_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.s8s_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  tw(_set____db54di) {
    this.j8s_1.tw(_set____db54di);
  }
  uw() {
    return this.j8s_1.uw();
  }
  v8s() {
    var tmp = this.k8s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  i8v(_set____db54di) {
    this.l8s_1 = _set____db54di;
  }
  u8s() {
    var tmp = this.l8s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  w8s() {
    var tmp = this.m8s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  fy() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q8s_1;
    coroutineContext$factory();
    return this_0.t1();
  }
  j8v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r8s_1;
    sceneView$factory();
    return this_0.t1();
  }
  x8s(size) {
    return SContainer.v8x(size);
  }
  b5o(injector) {
    this.k8s_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.z5n(getKClass(Views));
    this.i8v(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.m8s_1 = injector.z5n(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.n8s_1 = injector.z5n(getKClass(ResourcesRoot));
  }
  w8x(_this__u8e3s4, $completion) {
  }
  x8x(_this__u8e3s4, $completion) {
  }
  y8x($completion) {
  }
  z8x($completion) {
  }
  a8y($completion) {
  }
  b8y($completion) {
    cancel_0(this.p8s_1);
    this.v8s().c5o();
  }
  t8s($completion) {
  }
  c8y($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219(this, $completion), $completion);
  }
  d8y(size) {
    size_0(this.j8v(), size);
  }
}
class EmptyScene extends Scene {
  x8x(_this__u8e3s4, $completion) {
  }
}
class ScaledScene extends Scene {
  constructor(sceneWidth, sceneHeight, sceneScaleMode, sceneAnchor, sceneSmoothing) {
    sceneScaleMode = sceneScaleMode === VOID ? Companion_getInstance_23().o2b_1 : sceneScaleMode;
    sceneAnchor = sceneAnchor === VOID ? Companion_getInstance_24().e21() : sceneAnchor;
    sceneSmoothing = sceneSmoothing === VOID ? true : sceneSmoothing;
    super();
    this.y8y_1 = sceneWidth;
    this.z8y_1 = sceneHeight;
    this.a8z_1 = sceneScaleMode;
    this.b8z_1 = sceneAnchor;
    this.c8z_1 = sceneSmoothing;
  }
  d8z() {
    return this.y8y_1;
  }
  e8z() {
    return this.z8y_1;
  }
  d8y(size) {
    onSizeChanged(this, this.j8v(), size);
  }
  x8s(size) {
    // Inline function 'kotlin.also' call
    var this_0 = SContainer.v8x(size);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.ScaledScene.createSceneView.<anonymous>' call
    onSizeChanged(this, this_0, size);
    return this_0;
  }
}
class PixelatedScene extends ScaledScene {
  constructor(sceneWidth, sceneHeight, sceneScaleMode, sceneAnchor, sceneSmoothing) {
    sceneScaleMode = sceneScaleMode === VOID ? Companion_getInstance_23().o2b_1 : sceneScaleMode;
    sceneAnchor = sceneAnchor === VOID ? Companion_getInstance_24().e21() : sceneAnchor;
    sceneSmoothing = sceneSmoothing === VOID ? false : sceneSmoothing;
    super(sceneWidth, sceneHeight, sceneScaleMode, sceneAnchor, sceneSmoothing);
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.m92_1 = clazz;
    this.n92_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.m92_1) + ', injects=' + toString(this.n92_1) + ')';
  }
  hashCode() {
    var result = this.m92_1.hashCode();
    result = imul(result, 31) + hashCode(this.n92_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.m92_1.equals(tmp0_other_with_cast.m92_1))
      return false;
    if (!equals(this.n92_1, tmp0_other_with_cast.n92_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_17 = this;
    this.p8z_1 = Companion_getInstance_0().us('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.q8z_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.f8z_1 = this$0;
    this.g8z_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.t8z_1 = $newScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.u8z_1 = $newScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.v8z_1 = $oldScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.w8z_1 = $oldScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.x8z_1 = $oldScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.y8z_1 = $newScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15(this, $completion), $completion);
  }
}
class BaseView extends BaseEventListener {
  static g9p() {
    return this.k5q();
  }
  f8r() {
  }
}
class View extends BaseView {
  static a9s(isContainer) {
    var $this = this.g9p();
    $this.v8j_1 = isContainer;
    var tmp = $this;
    tmp.w8j_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.x8j_1 = true;
    $this.y8j_1 = null;
    $this.z8j_1 = null;
    $this.a8k_1 = null;
    $this.b8k_1 = 0;
    $this.c8k_1 = null;
    $this.d8k_1 = 1.0;
    $this.e8k_1 = null;
    $this.f8k_1 = null;
    $this.g8k_1 = null;
    $this.h8k_1 = Companion_getInstance_13().i7h_1;
    $this.i8k_1 = 0.0;
    $this.j8k_1 = 0.0;
    $this.k8k_1 = 1.0;
    $this.l8k_1 = 1.0;
    $this.m8k_1 = Companion_getInstance_30().m21_1;
    $this.n8k_1 = Companion_getInstance_30().m21_1;
    $this.o8k_1 = Companion_getInstance_30().m21_1;
    $this.p8k_1 = 0.0;
    $this.q8k_1 = scale$factory($this);
    $this.r8k_1 = false;
    $this.s8k_1 = true;
    $this.t8k_1 = true;
    $this.u8k_1 = true;
    $this.v8k_1 = true;
    $this.w8k_1 = Companion_getInstance_29().a25_1;
    $this.x8k_1 = Companion_getInstance_29().a25_1;
    $this.y8k_1 = -1;
    $this.z8k_1 = Companion_getInstance_29().a25_1;
    $this.a8l_1 = -1;
    $this.b8l_1 = new ColorTransformMul();
    $this.c8l_1 = new ColorTransformMul();
    $this.d8l_1 = -1;
    $this.e8l_1 = Companion_getInstance_13().i7h_1;
    $this.f8l_1 = -1;
    $this.g8l_1 = true;
    $this.h8l_1 = 0;
    $this.i8l_1 = 0;
    $this.j8l_1 = false;
    $this.k8l_1 = false;
    $this.l8l_1 = null;
    $this.m8l_1 = false;
    $this.n8l_1 = null;
    $this.o8l_1 = 0;
    $this.p8l_1 = true;
    $this.q8l_1 = null;
    return $this;
  }
  static s9x() {
    return this.a9s(false);
  }
  e99() {
    return 0.0;
  }
  f99() {
    return 0.0;
  }
  l98() {
    return null;
  }
  f9p(_set____db54di) {
    this.z8j_1 = _set____db54di;
  }
  g99(value) {
    this.b8k_1 = value;
  }
  x5w() {
    return this.b8k_1;
  }
  h99(value) {
    if (this.e8k_1 === value)
      return Unit_instance;
    this.e8k_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp337_safe_receiver = this.l98();
    var tmp;
    if (tmp337_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp337_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp337_safe_receiver.c1(_unary__edvuaz).h99(value);
      }
      tmp = Unit_instance;
    }
    this.i99();
  }
  i99() {
  }
  j99(value) {
    if (this.f8k_1 === value)
      return Unit_instance;
    this.f8k_1 = value;
    var parent = this.j98();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp337_safe_receiver = this.l98();
    var tmp;
    if (tmp337_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp337_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp337_safe_receiver.c1(_unary__edvuaz).j99(parent);
      }
      tmp = Unit_instance;
    }
  }
  j98() {
    return this.f8k_1;
  }
  k99() {
    var tmp345_safe_receiver = this.c8k_1;
    this.j99(tmp345_safe_receiver == null ? null : tmp345_safe_receiver.j98());
  }
  l99(value) {
    if (this.c8k_1 === value)
      return Unit_instance;
    this.c8k_1 = value;
    var tmp346_safe_receiver = this.c8k_1;
    this.h99(tmp346_safe_receiver == null ? null : tmp346_safe_receiver.e8k_1);
    this.k99();
    this.r9a();
    this.l5q(value);
  }
  m1s() {
    return this.c8k_1;
  }
  m99() {
    return !(this.m1s() == null) ? ensureNotNull(this.m1s()).m99() * this.d8k_1 : this.d8k_1;
  }
  n99(x, y) {
    this.g9a();
    if (!(this.i8k_1 === x) || !(this.j8k_1 === y)) {
      this.i8k_1 = x;
      this.j8k_1 = y;
      this.p9a();
    }
  }
  f4h(value) {
    return this.n99(value.h21_1, value.i21_1);
  }
  m8r(v) {
    this.n99(v, this.n4y());
  }
  m4y() {
    this.g9a();
    return this.i8k_1;
  }
  n8r(v) {
    this.n99(this.m4y(), v);
  }
  n4y() {
    this.g9a();
    return this.j8k_1;
  }
  o99() {
    return this.p8k_1;
  }
  p99(v) {
    this.v99(Scale.j29(v, v));
  }
  q99() {
    return this.w99().l27();
  }
  r99(v) {
    this.g9a();
    if (!(this.k8k_1 === v)) {
      this.k8k_1 = v;
      this.p9a();
    }
  }
  s99() {
    this.g9a();
    return this.k8k_1;
  }
  t99(v) {
    this.g9a();
    if (!(this.l8k_1 === v)) {
      this.l8k_1 = v;
      this.p9a();
    }
  }
  u99() {
    this.g9a();
    return this.l8k_1;
  }
  v99(value) {
    this.r99(value.h29_1);
    this.t99(value.i29_1);
  }
  w99() {
    return Scale.j29(this.s99(), this.u99());
  }
  x99() {
    this.g9a();
    return this.m8k_1;
  }
  y99() {
    this.g9a();
    return this.n8k_1;
  }
  wa6(v) {
    this.g9a();
    if (!equals(this.o8k_1, v)) {
      this.o8k_1 = v;
      this.p9a();
    }
  }
  z99() {
    this.g9a();
    return this.o8k_1;
  }
  a9a() {
    var tmp348_safe_receiver = this.m1s();
    var tmp0_elvis_lhs = tmp348_safe_receiver == null ? null : tmp348_safe_receiver.y9a(Vector2D.j21(this.m4y(), this.n4y()));
    return tmp0_elvis_lhs == null ? Vector2D.j21(this.m4y(), this.n4y()) : tmp0_elvis_lhs;
  }
  b9a(value) {
    this.n95(value);
  }
  d1() {
    return this.o95();
  }
  n95(value) {
    var size = this.d1();
    this.v99(Scale.j29((this.s99() === 0.0 ? 1.0 : this.s99()) * (value.y22_1 / size.y22_1), (this.u99() === 0.0 ? 1.0 : this.u99()) * (value.z22_1 / size.z22_1)));
  }
  o95() {
    return this.p9b().d1();
  }
  c9a() {
    return this.o95().y22_1;
  }
  d9a() {
    return this.o95().z22_1;
  }
  e9a() {
    return this.c9a() * this.s99();
  }
  f9a() {
    return this.d9a() * this.u99();
  }
  n2d() {
    return this.c9a();
  }
  o2d() {
    return this.d9a();
  }
  d44(v) {
    if (!(v === this.b8l_1.f44())) {
      this.b8l_1.d44(v);
      this.n98();
    }
  }
  f44() {
    return this.b8l_1.f44();
  }
  ya6(v) {
    this.p8r(v);
  }
  za6() {
    return this.o8r();
  }
  p8r(v) {
    if (!(this.b8l_1.c44() === v)) {
      this.b8l_1.b44(v);
      this.n98();
    }
  }
  o8r() {
    return this.b8l_1.c44();
  }
  g9a() {
    if (this.u8k_1)
      return Unit_instance;
    this.u8k_1 = true;
    var t = this.w8k_1.n26();
    this.i8k_1 = t.z26_1;
    this.j8k_1 = t.a27_1;
    this.k8k_1 = t.b27_1;
    this.l8k_1 = t.c27_1;
    this.m8k_1 = t.d27_1;
    this.n8k_1 = t.e27_1;
    this.o8k_1 = t.f27_1;
  }
  g1s() {
    var tmp350_safe_receiver = this.m1s();
    var tmp0_elvis_lhs = tmp350_safe_receiver == null ? null : tmp350_safe_receiver.g1s();
    return tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
  }
  h9a() {
    return this.e8k_1;
  }
  m81(value) {
    if (!(this.t8k_1 === value)) {
      this.t8k_1 = value;
      this.m98();
    }
  }
  i9a() {
    return this.t8k_1;
  }
  j9a() {
    if (!this.v8k_1) {
      this.v8k_1 = true;
      this.j8l_1 = true;
      this.w8k_1 = Companion_getInstance_29().m25(this.m4y(), this.n4y(), this.z99(), this.s99(), this.u99(), this.x99(), this.y99(), 0.0, 0.0);
    }
    return this.w8k_1;
  }
  k9a() {
    if (!(this.y8k_1 === this.h8l_1)) {
      this.y8k_1 = this.h8l_1;
      this.j8l_1 = true;
      this.x8k_1 = !(this.m1s() == null) ? this.j9a().o25(ensureNotNull(this.m1s()).k9a()) : this.j9a();
    }
    return this.x8k_1;
  }
  l9a() {
    if (!(this.a8l_1 === this.h8l_1)) {
      this.a8l_1 = this.h8l_1;
      this.j8l_1 = true;
      this.z8k_1 = this.k9a().m26();
    }
    return this.z8k_1;
  }
  m9a() {
    updateRenderColorTransformIfRequired(this);
    return this.c8l_1;
  }
  n9a() {
    updateRenderBlendModeIfRequired(this);
    return this.e8l_1;
  }
  o9a() {
    updateRenderColorTransformIfRequired(this);
    return this.c8l_1.f44();
  }
  p9a() {
    this.v8k_1 = false;
    this.m98();
  }
  m98() {
    this.h8l_1 = this.h8l_1 + 1 | 0;
    this.j8l_1 = false;
    this.g8l_1 = true;
    this.f8r();
  }
  q9a() {
    if (!(this.l8l_1 == null)) {
      this.l8l_1 = null;
      var tmp354_safe_receiver = this.m1s();
      if (tmp354_safe_receiver == null)
        null;
      else {
        tmp354_safe_receiver.q9a();
      }
    }
  }
  r9a() {
    this.r95();
  }
  s9a() {
    this.r95();
  }
  r95() {
  }
  f8r() {
    var tmp355_safe_receiver = this.f8k_1;
    if (tmp355_safe_receiver == null)
      null;
    else {
      tmp355_safe_receiver.k98(this);
    }
    this.q9a();
  }
  n98() {
    this.i8l_1 = this.i8l_1 + 1 | 0;
    this.k8l_1 = false;
    this.g8l_1 = true;
    this.f8r();
  }
  t9a(phase) {
    if (this.n8l_1 == null)
      this.n8l_1 = fastArrayListOf([]);
    var tmp358_safe_receiver = this.n8l_1;
    if (tmp358_safe_receiver == null)
      null;
    else
      tmp358_safe_receiver.f(phase);
    var tmp359_safe_receiver = this.n8l_1;
    if (tmp359_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.sortBy' call
      if (tmp359_safe_receiver.d1() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = View$addRenderPhase$lambda;
        var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
        sortWith(tmp359_safe_receiver, tmp$ret$0);
      }
    }
  }
  p95(ctx) {
    if (!this.i9a())
      return Unit_instance;
    var tmp361_safe_receiver = this.n8l_1;
    if (tmp361_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp361_safe_receiver.jx_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].xad(this, ctx);
      }
    }
    try {
      this.u9a(ctx);
    }finally {
      var tmp362_safe_receiver = this.n8l_1;
      if (tmp362_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp362_safe_receiver.jx_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp362_safe_receiver.d1() - n_0 | 0) - 1 | 0].yad(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  u9a(ctx) {
    var oldPhase = this.o8l_1;
    try {
      this.o8l_1 = 0;
      this.v9a(ctx);
    }finally {
      this.o8l_1 = oldPhase;
    }
  }
  v9a(ctx) {
    var stages = this.n8l_1;
    if (!(stages == null) && this.o8l_1 < stages.d1()) {
      var _unary__edvuaz = this.o8l_1;
      this.o8l_1 = _unary__edvuaz + 1 | 0;
      stages.c1(_unary__edvuaz).zad(this, ctx);
    } else {
      var tmp = this.o8l_1;
      var tmp0_elvis_lhs = stages == null ? null : stages.d1();
      if (equals(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs)) {
        this.t95(ctx);
        this.o8l_1 = this.o8l_1 + 1 | 0;
      }
    }
  }
  x98(ctx) {
    if (this.m8l_1 || this === get_debugAnnotateView(ctx)) {
      this.w9a(ctx);
    }
  }
  w9a(ctx) {
    var local = this.p9b();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.g7s_1;
    if (!(this_1.e7j_1 === this_0)) {
      this_1.e7j_1 = this_0;
      this_1.o7k();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.s7s_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().r7h_1;
          var doUpdate = !(this_0.r7s_1 === blending);
          var old = this_0.r7s_1;
          try {
            if (doUpdate) {
              this_0.g7s_1.o7k();
              this_0.r7s_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().m3n_1;
            var m = this_0.s7s_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.j7s_1;
            this_0.j7s_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.s3f(this.g9b());
              this_0.y7s(this_3, m);
            }finally {
              this_0.j7s_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.g7s_1.o7k();
            }
            this_0.r7s_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().m3n_1;
        var m_0 = this_0.s7s_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.j7s_1;
        this_0.j7s_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.n36(this.y9a(Vector2D.j21(local.k22(), local.m22())));
          this_4.a37(this.y9a(Vector2D.j21(local.l22(), local.m22())));
          this_4.a37(this.y9a(Vector2D.j21(local.l22(), local.n22())));
          this_4.a37(this.y9a(Vector2D.j21(local.k22(), local.n22())));
          this_4.z5();
          this_0.y7s(this_4, m_0);
        }finally {
          this_0.j7s_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().a3t_1;
        var m_1 = this_0.s7s_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.j7s_1;
        this_0.j7s_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).z7r();
          this_5.x3f(this.y9a(local.c23()), anchorSize);
          this_5.x3f(this.y9a(local.x29()), anchorSize);
          this_5.x3f(this.y9a(local.e23()), anchorSize);
          this_5.x3f(this.y9a(local.y29()), anchorSize);
          this_5.x3f(this.y9a(interpolate(Companion_getInstance_33().ut_1, local.c23(), local.x29())), anchorSize);
          this_5.x3f(this.y9a(interpolate(Companion_getInstance_33().ut_1, local.x29(), local.e23())), anchorSize);
          this_5.x3f(this.y9a(interpolate(Companion_getInstance_33().ut_1, local.e23(), local.y29())), anchorSize);
          this_5.x3f(this.y9a(interpolate(Companion_getInstance_33().ut_1, local.y29(), local.c23())), anchorSize);
          this_0.y7s(this_5, m_1);
        }finally {
          this_0.j7s_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().o3n_1;
        var m_2 = this_0.s7s_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.j7s_1;
        this_0.j7s_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.a9a();
          this_6.r3f(Vector2D.j21(center.h21_1, center.i21_1 - 5), Vector2D.j21(center.h21_1, center.i21_1 + 5));
          this_6.r3f(Vector2D.j21(center.h21_1 - 5, center.i21_1), Vector2D.j21(center.h21_1 + 5, center.i21_1));
          this_0.y7s(this_6, m_2);
        }finally {
          this_0.j7s_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.m4y() === 0.0) || !(this.n4y() === 0.0))
      out = out + (':pos=(' + this.x9a(this.m4y()) + ',' + this.x9a(this.n4y()) + ')');
    if (!(this.s99() === 1.0) || !(this.u99() === 1.0))
      out = out + (':scale=(' + this.x9a(this.s99()) + ',' + this.x9a(this.u99()) + ')');
    if (!equals(this.x99(), Companion_getInstance_30().m21_1) || !equals(this.y99(), Companion_getInstance_30().m21_1))
      out = out + (':skew=(' + this.x9a(_Angle___get_degrees__impl__qg56vw(this.x99())) + ',' + this.x9a(_Angle___get_degrees__impl__qg56vw(this.y99())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.z99()), Companion_getInstance_30().m21_1))
      out = out + (':rotation=(' + this.x9a(_Angle___get_degrees__impl__qg56vw(this.z99())) + '\xBA)');
    if (!(this.g8k_1 == null))
      out = out + (':name=(' + this.g8k_1 + ')');
    if (!this.h8k_1.equals(Companion_getInstance_13().i7h_1))
      out = out + (':blendMode=(' + this.h8k_1.toString() + ')');
    if (!this.i9a())
      out = out + (':visible=' + this.i9a());
    if (!(this.o8r() === 1.0))
      out = out + (':alpha=' + niceStr(this.o8r(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.f44()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().k3n_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.f44()));
    return out;
  }
  x9a(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  aae(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.l9a();
      if (this_0.i22()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.j21(this_0.s25(p.h21_1, p.i21_1), this_0.v25(p.h21_1, p.i21_1));
    }
    return tmp$ret$0;
  }
  y9a(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.k9a();
      if (this_0.i22()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.j21(this_0.s25(p.h21_1, p.i21_1), this_0.v25(p.h21_1, p.i21_1));
    }
    return tmp$ret$0;
  }
  z9a() {
    var tmp375_safe_receiver = this.m1s();
    if (tmp375_safe_receiver == null)
      null;
    else
      tmp375_safe_receiver.d99(this);
  }
  a9b(target, inclusive) {
    var tmp;
    if (target === this.m1s()) {
      tmp = this.j9a();
    } else if (target === this) {
      tmp = Companion_getInstance_29().a25_1;
    } else {
      var commonAncestor = Companion_instance_23.uad(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.m1s() == null && inclusive) {
          return this.k9a();
        }
        tmp_0 = this.k9a().o25(target.l9a());
      } else {
        tmp_0 = Companion_getInstance_29().a25_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.o25(target.j9a());
    }
    return out;
  }
  b9b() {
    var tmp0_elvis_lhs = this.c9b();
    return tmp0_elvis_lhs == null ? this.i9b() : tmp0_elvis_lhs;
  }
  c9b() {
    var stage = this.g1s();
    if (!(stage instanceof Stage))
      return null;
    return this.d9b(stage);
  }
  d9b(bp) {
    return this.i9b().m2a(bp.q7r());
  }
  e9b(ctx) {
    return ctx.j7t() ? this.d9b(ctx) : this.i9b();
  }
  f9b(ctx) {
    return this.e9b(ctx);
  }
  g9b() {
    return this.i9b();
  }
  h9b(includeFilters) {
    return this.n9b(this.g1s(), VOID, true, includeFilters);
  }
  i9b(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.h9b(includeFilters) : $super.h9b.call(this, includeFilters);
  }
  j9b(target, inclusive, includeFilters) {
    return this.m9b(target, false, inclusive, includeFilters);
  }
  k9b(target, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.j9b(target, inclusive, includeFilters) : $super.j9b.call(this, target, inclusive, includeFilters);
  }
  l9b(concat, doAnchoring, includeFilters) {
    var out = this.o9b(doAnchoring, includeFilters);
    if (concat.j22() && !concat.p25()) {
      var tmp = Companion_getInstance_28();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.c23();
        if (concat.i22()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.j21(concat.s25(p.h21_1, p.i21_1), concat.v25(p.h21_1, p.i21_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.x29();
        if (concat.i22()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.j21(concat.s25(p_0.h21_1, p_0.i21_1), concat.v25(p_0.h21_1, p_0.i21_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.e23();
        if (concat.i22()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.j21(concat.s25(p_1.h21_1, p_1.i21_1), concat.v25(p_1.h21_1, p_1.i21_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.y29();
        if (concat.i22()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.j21(concat.s25(p_2.h21_1, p_2.i21_1), concat.v25(p_2.h21_1, p_2.i21_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.u22(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  m9b(target, doAnchoring, inclusive, includeFilters) {
    return this.l9b(this.a9b(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  n9b(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.m9b(target, doAnchoring, inclusive, includeFilters) : $super.m9b.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  o9b(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.l8l_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.q95();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.l8l_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.e26(Vector2D.j26(this.e99(), this.f99()));
    }
    if (includeFilters) {
      var tmp376_safe_receiver = get_filter(this);
      if (tmp376_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp376_safe_receiver, out);
      }
    }
    return out;
  }
  p9b(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.o9b(doAnchoring, includeFilters) : $super.o9b.call(this, doAnchoring, includeFilters);
  }
  q95() {
    return Companion_getInstance_27().s22();
  }
  t5q(type, event, result) {
    var tmp379_safe_receiver = this.m1s();
    if (tmp379_safe_receiver == null)
      null;
    else
      tmp379_safe_receiver.a5r(type, event, result);
  }
}
class Container extends View {
  static h8v(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.a9s(true);
    $this.y8u_1 = cull;
    $this.z8u_1 = FastArrayList.lx();
    $this.a8v_1 = new ContainerCollection($this, $this.z8u_1);
    $this.b8v_1 = null;
    $this.c8v_1 = new MMatrix();
    $this.d8v_1 = false;
    $this.e8v_1 = false;
    $this.f8v_1 = FastArrayList.lx();
    return $this;
  }
  l98() {
    return this.z8u_1;
  }
  m98() {
    super.m98();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a8v_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.c1(_unary__edvuaz);
      if (child.j8l_1) {
        child.m98();
      }
    }
  }
  n98() {
    super.n98();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a8v_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.c1(_unary__edvuaz);
      if (child.k8l_1) {
        child.n98();
      }
    }
  }
  o98() {
    return this.z8u_1.d1();
  }
  p98(view) {
  }
  q98(view) {
  }
  r95() {
    super.r95();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp337_safe_receiver = this.l98();
    var tmp;
    if (tmp337_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp337_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp337_safe_receiver.c1(_unary__edvuaz).s9a();
      }
      tmp = Unit_instance;
    }
  }
  r98(index) {
    return this.z8u_1.c1(index);
  }
  s98(index) {
    return getOrNull(this.z8u_1, index);
  }
  t98(index) {
    return this.d99(this.s98(index));
  }
  u98() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a8v_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.c1(_unary__edvuaz);
      child.l99(null);
      child.g99(-1);
    }
    this.z8u_1.j3();
    this.z98();
  }
  v98(view) {
    return this.c99(view, this.o98());
  }
  g8v(view) {
    this.c99(view, this.o98());
  }
  c1(index) {
    return this.r98(index);
  }
  t95(ctx) {
    if (!this.i9a())
      return Unit_instance;
    this.w98(ctx);
  }
  w98(ctx) {
    if (!this.y8u_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.d8v_1) {
        this.d8v_1 = true;
        this.f8v_1.j3();
        this.f8v_1.e1(this.a8v_1);
        if (this.y98())
          this.e8v_1 = false;
      }
      if (!this.e8v_1) {
        this.e8v_1 = true;
        sortWith(this.f8v_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.f8v_1.jx_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].p95(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp0_elvis_lhs = clippingContainer == null ? null : clippingContainer.i9b();
    var bounds = tmp0_elvis_lhs == null ? Companion_getInstance_27().s22() : tmp0_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.d8v_1) {
      this.d8v_1 = true;
      this.f8v_1.j3();
      this.f8v_1.e1(this.a8v_1);
      if (this.y98())
        this.e8v_1 = false;
    }
    if (!this.e8v_1) {
      this.e8v_1 = true;
      sortWith(this.f8v_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.f8v_1.jx_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.i22() || bounds.c2a(child.h9b(true))) {
        child.p95(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  x98(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.d8v_1) {
      this.d8v_1 = true;
      this.f8v_1.j3();
      this.f8v_1.e1(this.a8v_1);
      if (this.y98())
        this.e8v_1 = false;
    }
    if (!this.e8v_1) {
      this.e8v_1 = true;
      sortWith(this.f8v_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.f8v_1.jx_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].x98(ctx);
    }
    super.x98(ctx);
  }
  q95() {
    var bb = Companion_getInstance_28().t22();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a8v_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.c1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.n9b(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  y98() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.z8u_1.jx_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].o99() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  z98() {
    this.d8v_1 = false;
    this.a99();
  }
  a99() {
    var tmp227_safe_receiver = this.h9a();
    var tmp228_safe_receiver = tmp227_safe_receiver == null ? null : tmp227_safe_receiver.u8s();
    if (tmp228_safe_receiver == null)
      null;
    else {
      tmp228_safe_receiver.k98(this);
    }
  }
  b99(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  c99(view, index) {
    this.b99(view);
    var tmp229_safe_receiver = view.m1s();
    if (tmp229_safe_receiver == null)
      null;
    else {
      tmp229_safe_receiver.z98();
    }
    view.z9a();
    var aindex = clamp_1(index, 0, this.o98());
    view.g99(aindex);
    var children = this.z8u_1;
    children.u6(aindex, view);
    var inductionVariable = aindex + 1 | 0;
    var last = children.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.c1(n).g99(n);
      }
       while (inductionVariable < last);
    view.l99(this);
    view.m98();
    this.p98(view);
    this.z98();
    this.a99();
    this.q9a();
  }
  d99(view) {
    if (!((view == null ? null : view.m1s()) === this))
      return false;
    var inductionVariable = view.x5w() + 1 | 0;
    var last = this.o98();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _receiver__tnumb7 = this.z8u_1.c1(i);
        var _unary__edvuaz = _receiver__tnumb7.x5w();
        _receiver__tnumb7.g99(_unary__edvuaz - 1 | 0);
      }
       while (inductionVariable < last);
    this.z8u_1.f3(view.x5w());
    view.l99(null);
    view.g99(-1);
    this.z98();
    this.a99();
    this.q9a();
    return true;
  }
  q5q(type, event, result) {
    if (this.b8v_1 == null)
      this.b8v_1 = FastArrayList.kx(this.a8v_1.d1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.z8u_1;
    var temp = ensureNotNull(this.b8v_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.jx_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].z5q(type, event, result);
      }
    }finally {
      temp.j3();
    }
  }
}
class CachedContainer extends Container {
  static h9p(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.h8v();
    $this.c98_1 = cache;
    $this.d98_1 = renderQuality;
    $this.e98_1 = null;
    $this.f98_1 = true;
    $this.g98_1 = -1.0;
    $this.h98_1 = Companion_getInstance_27().d25();
    $this.i98_1 = Scale.i2b(1);
    return $this;
  }
  f8r() {
    super.f8r();
    this.f98_1 = true;
  }
  t95(ctx) {
    if (!this.i9a())
      return Unit_instance;
    if (!this.c98_1) {
      return super.t95(ctx);
    }
    if (this.e98_1 == null) {
      this.e98_1 = new CacheTexture(this, ctx);
      this.f98_1 = true;
    }
    var cache = ensureNotNull(this.e98_1);
    ctx.o7t(cache);
    var renderScale = ctx.e7t().m3_1 === 0 ? 1.0 : ctx.a7t();
    var tmp0_elvis_lhs = this.d98_1;
    var doExpensiveScaling = !get_isLow(tmp0_elvis_lhs == null ? ctx.e7t() : tmp0_elvis_lhs);
    if (this.f98_1 || !(this.g98_1 === renderScale)) {
      this.g98_1 = renderScale;
      this.h98_1 = this.p9b(VOID, false);
      this.i98_1 = doExpensiveScaling ? this.b9b().d1().k2b(this.h98_1.d1()) : Scale.i2b(1);
      this.f98_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.h98_1.f22_1 * renderScale * this.i98_1.h29_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.h98_1.g22_1 * renderScale * this.i98_1.i29_1), 1);
      cache.n9p(texWidth, texHeight);
      ctx.o7k();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.j9p_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.t7t(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.a7j_1;
        var this_1 = this_0.j7j_1;
        if (!(this_1.e7j_1 === this_0)) {
          this_1.e7j_1 = this_0;
          this_1.o7k();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.p69(0, 0, frameBuffer.s5y_1, frameBuffer.t5y_1);
          var temp = this_0.h7k_1;
          this_0.q7q();
          this_0.h7k_1 = scissor;
          try {
            if (true) {
              ctx.l7t(Colors_getInstance().p3n_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.l9a().g26(-this.h98_1.d22_1, -this.h98_1.e22_1).a26(renderScale * this.i98_1.h29_1, renderScale * this.i98_1.i29_1);
            ctx.o7k();
            var temp4 = ctx.p7i_1;
            var temp2d = ctx.q7i_1;
            ctx.q7i_1 = matrix;
            ctx.p7i_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.b66(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.q67();
              this_2.x6t(_unary__edvuaz + 1 | 0);
              this_2.y6t(this_2.q67() + 1 | 0);
              var blockSize = this_2.u65_1;
              var index0 = imul(this_2.q67() - 1 | 0, blockSize);
              var index1 = imul(this_2.q67(), blockSize);
              var texBlockSize = this_2.r65_1.q6d().d1();
              var texIndex0 = imul(this_2.q67() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.q67(), texBlockSize);
              if (this_2.q67() > 0) {
                arraycopy(this_2.w65_1, index0, this_2.w65_1, index1, blockSize);
              } else {
                arrayfill(this_2.w65_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.r65_1;
              this_2.x65_1.h6u($this$push.p6d(), ctx.p7i_1);
              if (true && this_2.q67() >= 1) {
                var equals = arrayequal(this_2.w65_1, index0, this_2.w65_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.q67();
                  this_2.x6t(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.t95(ctx);
            }finally {
              ctx.o7k();
              ctx.p7i_1 = temp4;
              ctx.q7i_1 = temp2d;
              ctx.b66(ProjViewUB_getInstance()).z6t();
            }
            break $l$block_0;
          }finally {
            this_0.q7q();
            this_0.h7k_1 = temp;
          }
        }
      }finally {
        ctx.u7t();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.a7j_1;
    var this_4 = this_3.j7j_1;
    if (!(this_4.e7j_1 === this_3)) {
      this_4.e7j_1 = this_3;
      this_4.o7k();
    }
    this_3.q7k(cache.l9p_1, VOID, VOID, VOID, VOID, this.k9a().k26(this.h98_1.d22_1, this.h98_1.e22_1).c26(1.0 / (renderScale * this.i98_1.h29_1), 1.0 / (renderScale * this.i98_1.i29_1)), VOID, this.o9a(), this.h8k_1);
  }
  j98() {
    return this;
  }
  k98(view) {
    this.f98_1 = true;
    var tmp218_safe_receiver = this.m1s();
    var tmp219_safe_receiver = tmp218_safe_receiver == null ? null : tmp218_safe_receiver.f8k_1;
    if (tmp219_safe_receiver == null)
      null;
    else {
      tmp219_safe_receiver.k98(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static r9g(size, cache, clip) {
    size = size === VOID ? Size2D.a23(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.h9p(cache);
    $this.o9g_1 = clip;
    $this.p9g_1 = size;
    $this.q9g_1 = Ref(false);
    return $this;
  }
  n95(_set____db54di) {
    this.p9g_1 = _set____db54di;
  }
  o95() {
    return this.p9g_1;
  }
  q95() {
    return new Rectangle(0.0, 0.0, this.n2d(), this.o2d());
  }
  t95(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.o9g_1;
      var renderingInternalRef = this.q9g_1;
      if (renderingInternalRef.t1()) {
        super.t95(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.k9a();
        var hasRotation = !(m.g25_1 === 0.0) || !(m.h25_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.t1();
          try {
            renderingInternalRef.s2m(true);
            renderFiltered(this, ctx, Companion_getInstance_48());
          }finally {
            renderingInternalRef.s2m(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.a7j_1;
        if (!(ctx.e7j_1 === batcher)) {
          ctx.e7j_1 = batcher;
          ctx.o7k();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.c7j_1;
        var bounds = this.f9b(ctx).m2a(ctx.q7i_1).n2a();
        var rect = c2d.x7t_1.a7q().x69();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.c2a(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_12().s69(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.x7t_1;
            var scissor_0 = c2d.f7u(scissor);
            var temp = this_0.h7k_1;
            this_0.q7q();
            this_0.h7k_1 = scissor_0;
            try {
              super.t95(ctx);
              break $l$block_1;
            }finally {
              this_0.q7q();
              this_0.h7k_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.t95(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.t95(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static i95(size, cache) {
    Companion_getInstance_39();
    size = size === VOID ? Companion_getInstance_39().y9d_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.r9g(size, cache, false);
    $this.g95_1 = size;
    $this.h95_1 = false;
    return $this;
  }
  n95(value) {
    if (!this.g95_1.equals(value)) {
      this.g95_1 = value;
      this.k95();
    }
  }
  o95() {
    return this.g95_1;
  }
  q95() {
    return new Rectangle(0.0, 0.0, this.n2d(), this.o2d());
  }
  k95() {
    var tmp160_safe_receiver = this.m1s();
    if (tmp160_safe_receiver == null)
      null;
    else {
      tmp160_safe_receiver.q98(this);
    }
  }
  r95() {
    super.r95();
    this.s95();
  }
  s95() {
    this.m98();
  }
  t95(ctx) {
    registerUISupportOnce(this);
    super.t95(ctx);
  }
}
class SceneContainer extends UIView {
  static r8o(views, defaultTransition, name, size) {
    Companion_getInstance_38();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_32())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.q8i_1.d1() : size;
    var $this = this.i95(size);
    $this.l8o_1 = views;
    $this.m8o_1 = defaultTransition;
    $this.g8k_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.j95();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.g8v(this_0);
    tmp.n8o_1 = this_0;
    $this.o8o_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.m5q(tmp_0, SceneContainer$lambda($this));
    $this.p8o_1 = arrayListOf([Companion_getInstance_38().q8z_1]);
    $this.q8o_1 = 0;
    return $this;
  }
  fy() {
    return this.l8o_1.e8h_1;
  }
  k95() {
    var tmp79_safe_receiver = this.o8o_1;
    if (tmp79_safe_receiver == null)
      null;
    else {
      tmp79_safe_receiver.d8y(Size2D.t29(this.n2d(), this.o2d()));
    }
  }
  l95(clazz, injects, time, transition, $completion) {
    this.m95(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  s8o(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.m8o_1 : transition;
    return $super === VOID ? this.l95(clazz, injects, time, transition, $completion) : $super.l95.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  r8z(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0(this, newScene, time, transition, $completion), $completion);
  }
  m95(entry) {
    while (this.p8o_1.d1() <= this.q8o_1) {
      this.p8o_1.f(Companion_getInstance_38().q8z_1);
    }
    this.p8o_1.e3(this.q8o_1, entry);
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static j95() {
    var $this = this.h8v();
    dummyView($this);
    dummyView($this);
    $this.h92_1 = Companion_getInstance_33().st_1;
    $this.i92_1 = get_AlphaTransition();
    return $this;
  }
  m1b() {
    return this.c1(0);
  }
  j1b() {
    return this.c1(1);
  }
  k92(next, transition) {
    this.i92_1 = transition;
    this.h92_1 = Companion_getInstance_33().st_1;
    this.j92_1 = transition.t9b();
    this.u9b(this.j1b(), next);
    _get_transitionProcess__5hlux5(this).q9b(this.m1b(), this.j1b());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.h92_1) + ':transition=' + toString(this.i92_1));
  }
  l92() {
    this.h92_1 = Companion_getInstance_33().vt_1;
    _get_transitionProcess__5hlux5(this).r9b(this.m1b(), this.j1b());
    this.u9b(dummyView(this), this.j1b());
  }
  u9b(prev, next) {
    this.u98();
    this.v98(prev);
    this.v98(next);
  }
  t95(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.h92_1, Companion_getInstance_33().st_1) <= 0) {
      this.m1b().p95(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.h92_1, Companion_getInstance_33().vt_1) >= 0) {
      this.j1b().p95(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).s9b(ctx, this.m1b(), this.j1b(), this.h92_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.v9b_1 = $render;
    this.w9b_1 = $name;
  }
  t9b() {
    return this;
  }
  s9b(ctx, prev, next, ratio) {
    return this.v9b_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.w9b_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.x9b_1 = $process;
    this.y9b_1 = $easing;
  }
  q9b(prev, next) {
    return this.x9b_1.q9b(prev, next);
  }
  r9b(prev, next) {
    return this.x9b_1.r9b(prev, next);
  }
  s9b(ctx, prev, next, ratio) {
    return this.x9b_1.s9b(ctx, prev, next, this.y9b_1.nt(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.z9b_1 = $this_withEasing;
    this.a9c_1 = $easing;
  }
  toString() {
    return toString(this.z9b_1) + '.withEasing';
  }
  t9b() {
    var process = this.z9b_1.t9b();
    return new withEasing$1$create$1(process, this.a9c_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.b9c_1 = this.f9c(true, VOID, false);
    this.c9c_1 = this.f9c(true, VOID, true);
    this.d9c_1 = this.g9c(false, 'r', false);
    this.e9c_1 = this.g9c(false, 'a', false);
  }
  g9c(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp292_$this = Companion_getInstance_5().m7p_1;
    var tmp293_name = name == null ? Companion_getInstance_5().m7p_1.n66_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.u6f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.k6h();
    var tmp_0 = this_0.k6h();
    var tmp_1 = this_0.k6h();
    var tmp_2 = this_0.k6h();
    var median$delegate = this_0.a6h(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).c6e(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_5().j7p_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.e6h(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.s6h(this_0.n6g());
    var alpha = this_0.t6h(this_0.n6g());
    this_0.z6f(this_0.c6g(), this_0.x6h(this_0.c6g(), this_0.g6g([this_0.f6g(0.5)])));
    if (msdf) {
      this_0.z6f(d, this_0.c6h(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.i6g(this_0.c6g(), 'r'), this_0.i6g(this_0.c6g(), 'g'), this_0.i6g(this_0.c6g(), 'b')));
    } else {
      this_0.z6f(d, this_0.i6g(this_0.c6g(), sdf));
    }
    this_0.z6f(alpha, this_0.b6h(SDFShaders_getInstance().h7v(), d));
    if (inverted) {
      this_0.z6f(alpha, this_0.x6h(this_0.f6g(1.0), alpha));
    }
    this_0.z6f(this_0.c6g(), this_0.d6g(this_0.a6g(), alpha));
    var tmp294_fragment = FragmentShader(this_0.h6g());
    return tmp292_$this.v72(VOID, tmp294_fragment, tmp293_name);
  }
  f9c(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.g9c(msdf, sdf, inverted) : $super.g9c.call(this, msdf, sdf, inverted);
  }
}
class TimerComponents {
  constructor(view) {
    this.h9c_1 = view;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.i9c_1 = ArrayList.p1();
    this.j9c_1 = IntArrayList.w2e();
    this.k9c_1 = IntArrayList.w2e();
    this.l9c_1 = null;
  }
  n9c(time, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v12();
    // Inline function 'korlibs.korge.time.TimerComponents.wait.<anonymous>' call
    this.o9c(time, TimerComponents$wait$lambda(cancellable));
    return cancellable.h10();
  }
  o9c(time, callback) {
    return this.p9c(get_fast(time), callback);
  }
  q9c(time, callback) {
    return this.r9c(get_fast(time), callback);
  }
  p9c(time, callback) {
    return _interval(this, time, false, callback);
  }
  r9c(time, callback) {
    return _interval(this, time, true, callback);
  }
}
class TimerRef {
  constructor(index) {
    this.m9c_1 = index;
  }
  toString() {
    return TimerRef__toString_impl_8hh2j7(this.m9c_1);
  }
  hashCode() {
    return TimerRef__hashCode_impl_d9ou9o(this.m9c_1);
  }
  equals(other) {
    return TimerRef__equals_impl_2fvpr4(this.m9c_1, other);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.c1o() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.c1o() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.s9c_1 = view;
    this.t9c_1 = vs;
    this.u9c_1 = fastTime;
    this.v9c_1 = easing;
    this.w9c_1 = callback;
    this.x9c_1 = c;
    this.y9c_1 = fastWaitTime;
    this.z9c_1 = autoInvalidate;
    this.a9d_1 = Companion_instance_1.b1o();
    var tmp = this;
    var tmp_0;
    if (!equals(this.u9c_1, Companion_instance_1.c1o())) {
      tmp_0 = this.u9c_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.t9c_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.z();
      while (tmp0_iterator.a1()) {
        var item = tmp0_iterator.b1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.y7w_1);
        destination.f(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.b9d_1 = tmp_0;
    this.c9d_1 = false;
    this.d9d_1 = false;
    this.e9d_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.f9d_1 = this.s9c_1.m5q(tmp_2, TweenComponent$updater$lambda(this));
    var tmp110_safe_receiver = this.x9c_1;
    if (tmp110_safe_receiver == null)
      null;
    else {
      tmp110_safe_receiver.d11(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.b1o());
  }
  m9d() {
    return get_slow(this.y9c_1);
  }
  n9d() {
    if (this.e9d_1)
      return Unit_instance;
    this.e9d_1 = true;
    var tmp111_safe_receiver = this.x9c_1;
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp111_safe_receiver.nc(tmp$ret$0);
    }
  }
  l9d() {
    if (this.d9d_1)
      return Unit_instance;
    this.d9d_1 = true;
    var tmp112_safe_receiver = this.f9d_1;
    if (tmp112_safe_receiver == null)
      null;
    else {
      tmp112_safe_receiver.z5();
    }
    this.f9d_1 = null;
    this.n9d();
  }
  g9d(elapsed) {
    if (equals(elapsed, Companion_instance_1.b1o())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.t9c_1;
      var n = 0;
      while (n < this_0.d1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.c1(_unary__edvuaz).b2z();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.t9c_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.c1(_unary__edvuaz_0);
      var durationInTween = equals(v.w7w_1, Companion_instance_1.c1o()) ? FastDuration__minus_impl_evs237(this.b9d_1, v.v7w_1) : v.w7w_1;
      var elapsedInTween = get_fastMilliseconds(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.v7w_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7_0(durationInTween, Companion_getInstance().vi_1) <= 0 || FastDuration__compareTo_impl_4fhnj7(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.v9c_1.mt(ratioInTween);
      v.c7x(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.s9c_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.o9d_1 = $this_tween;
    this.p9d_1 = $tc;
    this.q9d_1 = $vs;
    this.r9d_1 = $time;
    this.s9d_1 = $easing;
    this.t9d_1 = $callback;
    this.u9d_1 = $waitTime;
    this.v9d_1 = $autoInvalidate;
  }
  e1k($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16(this, $this$withTimeoutNullable, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.e1k((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.w9d_1 = 90.0;
    this.x9d_1 = 32.0;
    this.y9d_1 = Size2D.p29(90.0, 32.0);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.a9m_1 = 1.0;
    this.b9m_1 = 1.0;
    this.c9m_1 = 1.0;
    this.d9m_1 = 1.0;
    this.e9m_1 = 1.0;
    this.f9m_1 = MatrixTransform.j27();
  }
  g9m(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.f9m_1 = globalMatrix.n26();
      // Inline function 'kotlin.math.abs' call
      var x = this.f9m_1.b27_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.f9m_1.c27_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.c9m_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.d9m_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.c9m_1 = sx;
        this.d9m_1 = sy;
        this.e9m_1 = sxy;
        this.a9m_1 = 1.0 / sx;
        this.b9m_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.c9m_1 = 1.0;
      this.d9m_1 = 1.0;
      this.e9m_1 = 1.0;
      this.a9m_1 = 1.0;
      this.b9m_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static xa6(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_24().s20_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.s9x();
    $this.q9o_1 = smoothing;
    $this.f9p(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.r9o_1 = get_Bitmaps_white();
    $this.s9o_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_14();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.t9o_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.u9o_1 = null;
    $this.v9o_1 = null;
    return $this;
  }
  c9p(v) {
    if (!(this.r9o_1 === v)) {
      this.r9o_1 = v;
      this.g8l_1 = true;
      this.f8r();
    }
  }
  s9g(v) {
    if (!this.s9o_1.equals(v)) {
      this.s9o_1 = v;
      this.g8l_1 = true;
      this.f8r();
    }
  }
  w9o() {
    return this.s9o_1;
  }
  o9m() {
    return 0.0;
  }
  p9m() {
    return 0.0;
  }
  e99() {
    return this.w9o().b21_1 * this.o9m();
  }
  f99() {
    return this.w9o().c21_1 * this.p9m();
  }
  x9o() {
    return -this.e99();
  }
  y9o() {
    return -this.f99();
  }
  t95(ctx) {
    if (!this.i9a())
      return Unit_instance;
    var tmp = this.r9o_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.g8l_1) {
      this.g8l_1 = false;
      this.e9p();
    }
    this.d9p(ctx);
  }
  d9p(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a7j_1;
    var this_1 = this_0.j7j_1;
    if (!(this_1.e7j_1 === this_0)) {
      this_1.e7j_1 = this_0;
      this_1.o7k();
    }
    var tmp283_safe_receiver = this.v9o_1;
    if (tmp283_safe_receiver == null)
      null;
    else
      tmp283_safe_receiver(ctx);
    var array = this.t9o_1;
    var tex = ctx.m7t(this.r9o_1).t2g();
    var smoothing = this.q9o_1;
    var blendMode = this.n9a();
    var program = this.u9o_1;
    var vcount = array.k7q_1;
    var icount = array.l7q_1;
    var matrix = Companion_getInstance_29().b25_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.k7n_1;
      this_0.d7q(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_5().m7p_1 : program;
      if (this_0.s7q(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.u7p();
      if (!contains(this_0.z7j_1, tex_0)) {
        this_0.y7j_1 = 0;
        this_0.z7j_1[0] = tex_0;
      }
      this_0.a7k_1 = smoothing;
      this_0.b7k_1 = blendMode;
      this_0.c7k_1 = pprogram;
    }
    this_0.p7q(array, matrix, vcount, icount);
  }
  e9p() {
    this.t9o_1.t7v(0, this.x9o(), this.y9o(), this.o9m(), this.p9m(), this.k9a(), this.r9o_1, this.o9a());
  }
  q95() {
    return Companion_getInstance_27().o29(this.x9o(), this.y9o(), this.o9m(), this.p9m());
  }
  toString() {
    var out = super.toString();
    if (!this.w9o().equals(Companion_getInstance_24().s20_1))
      out = out + (':anchor=(' + this.x9a(this.w9o().b21_1) + ', ' + this.x9a(this.w9o().c21_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static oa6(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_24().s20_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.xa6(anchor, hitShape, smoothing);
    $this.x9l_1 = false;
    $this.y9l_1 = bitmap;
    $this.z9o();
    return $this;
  }
  static i9m(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_24().s20_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.oa6(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  n9m(value) {
    if (equals(this.r9o_1, value))
      return Unit_instance;
    this.x9l_1 = true;
    this.c9p(value);
  }
  p54() {
    return this.r9o_1;
  }
  z9o() {
    if (this.x9l_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  t95(ctx) {
    this.z9o();
    super.t95(ctx);
  }
  o9m() {
    return this.r9o_1.n2d();
  }
  p9m() {
    return this.r9o_1.o2d();
  }
  o3a() {
    return this.r9o_1.o3a();
  }
  p3a() {
    return this.r9o_1.p3a();
  }
  y39() {
    return this.r9o_1.y39();
  }
  z39() {
    return this.r9o_1.z39();
  }
  a9p() {
    return this.w9o().b21_1 * this.y39();
  }
  b9p() {
    return this.w9o().c21_1 * this.z39();
  }
  e99() {
    return this.a9p() - this.o3a();
  }
  f99() {
    return this.b9p() - this.p3a();
  }
  q95() {
    return Companion_getInstance_27().o29(-this.a9p(), -this.b9p(), this.y39(), this.z39());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.p54()));
  }
}
class BaseGraphics extends BaseImage {
  static h9m(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.i9m(tmp$ret$0);
    $this.b9j_1 = autoScaling;
    $this.c9j_1 = true;
    $this.d9j_1 = false;
    $this.e9j_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.f9j_1 = ArrayList.p1();
    $this.g9j_1 = new InternalViewAutoscaling();
    $this.h9j_1 = 1;
    $this.i9j_1 = true;
    $this.j9j_1 = true;
    $this.k9j_1 = null;
    $this.l9j_1 = 1.0;
    $this.m9j_1 = 1.0;
    $this.n9j_1 = true;
    $this.o9j_1 = true;
    $this.p9j_1 = Companion_getInstance_27().d25();
    $this.q9j_1 = Companion_getInstance_27().d25();
    return $this;
  }
  j9m(value) {
    this.c9j_1 = value;
    this.k9m();
  }
  k9m() {
    this.i9j_1 = true;
    this.j9j_1 = true;
    this.q9a();
  }
  r95() {
    super.r95();
    if (this.m1s() == null || this.h9a() == null) {
      var tmp = this.p54().t2g();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.f9j_1.f(this.p54().t2g());
      }
      clearBitmaps(this, true);
    }
  }
  t95(ctx) {
    this.k9j_1 = ctx;
    clearBitmaps(this, false);
    this.l9m();
    super.t95(ctx);
  }
  l9m() {
    if (this.g9j_1.g9m(this.b9j_1, this.d9j_1, this.k9a())) {
      this.i9j_1 = true;
    }
    if (!this.i9j_1)
      return false;
    this.i9j_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.f9j_1.f(this.p54().t2g());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.f22_1 * this.g9j_1.c9m_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.g22_1 * this.g9j_1.d9m_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.h9j_1 | 0, imageHeight + this.h9j_1 | 0, this.c9j_1, true);
    this.l9j_1 = this.g9j_1.c9m_1;
    this.m9j_1 = this.g9j_1.d9m_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.k3m_1;
    if (true) {
      image.l1o();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.c3u(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.u4x(this.l9j_1, this.m9j_1);
        ctx.z4g(-boundsWithShapes.d22_1, -boundsWithShapes.e22_1);
        this.m9m(ctx);
      }finally {
        ctx.p11();
      }
    }finally {
      result = true ? image.u3m(rect) : 0;
    }
    this.n9m(slice(image));
    return true;
  }
  o9m() {
    return _get_bitmapWidth__ndy7bu(this) / this.l9j_1;
  }
  p9m() {
    return _get_bitmapHeight__5t1vx1(this) / this.m9j_1;
  }
  y39() {
    return this.o9m();
  }
  z39() {
    return this.p9m();
  }
  e99() {
    return this.w9o().b21_1 * this.o9m();
  }
  f99() {
    return this.w9o().c21_1 * this.p9m();
  }
  x9o() {
    return _getLocalBoundsInternal(this, this.n9j_1).d22_1;
  }
  y9o() {
    return _getLocalBoundsInternal(this, this.n9j_1).e22_1;
  }
  q95() {
    return _getLocalBoundsInternal$default(this);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.m9p_1 = $outer;
    this.i9p_1 = ctx;
    this.j9p_1 = this.i9p_1.r7t(16, 16, VOID, VOID, VOID, false);
    this.k9p_1 = TextureBase.n7n(this.j9p_1.q63(), 16, 16);
    this.l9p_1 = Texture(this.k9p_1);
  }
  n9p(width, height) {
    this.j9p_1.s63(0, 0, width, height);
    this.k9p_1.o7n(width);
    this.k9p_1.p7n(height);
    this.l9p_1 = Texture(this.k9p_1);
  }
  z5() {
    this.m9p_1.e98_1 = null;
    this.i9p_1.s7t(this.j9p_1);
  }
}
class ZIndexComparator {
  o9p(a, b) {
    return compareTo(a.o99(), b.o99());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.o9p(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.e9s_1 = this$0;
    this.d9s_1 = 0;
  }
  a1() {
    return this.d9s_1 < this.e9s_1.c9s_1.o98();
  }
  b1() {
    var _unary__edvuaz = this.d9s_1;
    this.d9s_1 = _unary__edvuaz + 1 | 0;
    return this.e9s_1.c9s_1.r98(_unary__edvuaz);
  }
  d6() {
    this.d9s_1 = this.d9s_1 - 1 | 0;
    this.e9s_1.c9s_1.t98(this.d9s_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.b9s_1 = children;
    this.c9s_1 = container;
  }
  c1(index) {
    return this.b9s_1.c1(index);
  }
  y2() {
    return this.b9s_1.y2();
  }
  o1(index) {
    return this.b9s_1.o1(index);
  }
  m1(fromIndex, toIndex) {
    return this.b9s_1.m1(fromIndex, toIndex);
  }
  d1() {
    return this.c9s_1.o98();
  }
  f9s(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.f1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.m1s() === this.c9s_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  x2(elements) {
    return this.f9s(elements);
  }
  f1() {
    return this.c9s_1.o98() === 0;
  }
  g9s(element) {
    this.c9s_1.v98(element);
    return true;
  }
  f(element) {
    return this.g9s(element instanceof View ? element : THROW_CCE());
  }
  h9s(elements) {
    if (elements.f1())
      return false;
    var _iterator__ex2g4s = elements.z();
    while (_iterator__ex2g4s.a1()) {
      var element = _iterator__ex2g4s.b1();
      this.c9s_1.v98(element);
    }
    return true;
  }
  e1(elements) {
    return this.h9s(elements);
  }
  z() {
    return new ContainerCollection$iterator$1(this);
  }
  i9s(element) {
    return this.c9s_1.d99(element);
  }
  d3(element) {
    if (!(element instanceof View))
      return false;
    return this.i9s(element instanceof View ? element : THROW_CCE());
  }
}
class CpuGraphics extends BaseGraphics {
  static p9v(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.h9m(autoScaling);
    $this.h9v_1 = 0;
    $this.i9v_1 = null;
    $this.j9v_1 = true;
    $this.k9v_1 = -1;
    $this.l9v_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.m9v_1 = ArrayList.p1();
    $this.n9v_1 = null;
    $this.o9v_1 = null;
    $this.q8l_1 = true;
    return $this;
  }
  q9v(value) {
    this.i9v_1 = value;
    this.h9v_1 = this.h9v_1 + 1 | 0;
    this.k9m();
  }
  f9p(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.o9v_1 = tmp_0;
  }
  m9m(ctx) {
    var tmp237_safe_receiver = this.i9v_1;
    if (tmp237_safe_receiver == null)
      null;
    else {
      tmp237_safe_receiver.s4h(ctx);
    }
  }
  z9l(includeStrokes) {
    var tmp238_safe_receiver = this.i9v_1;
    var tmp0_elvis_lhs = tmp238_safe_receiver == null ? null : tmp238_safe_receiver.o5i(includeStrokes);
    return tmp0_elvis_lhs == null ? Companion_getInstance_27().p22_1 : tmp0_elvis_lhs;
  }
}
class DummyView extends View {
  static r9x() {
    return this.s9x();
  }
  t95(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class FixedSizeContainer extends Container {
  static t9x(size, clip) {
    size = size === VOID ? Size2D.a23(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.h8v();
    $this.x9r_1 = clip;
    $this.y9r_1 = size;
    $this.z9r_1 = Ref(false);
    return $this;
  }
  w5i() {
    return this.x9r_1;
  }
  n95(_set____db54di) {
    this.y9r_1 = _set____db54di;
  }
  o95() {
    return this.y9r_1;
  }
  q95() {
    return new Rectangle(0.0, 0.0, this.n2d(), this.o2d());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.n2d()) + 'x' + get_niceStr(this.o2d()) + ')');
    return out;
  }
  t95(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.w5i();
      var renderingInternalRef = this.z9r_1;
      if (renderingInternalRef.t1()) {
        super.t95(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.k9a();
        var hasRotation = !(m.g25_1 === 0.0) || !(m.h25_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.t1();
          try {
            renderingInternalRef.s2m(true);
            renderFiltered(this, ctx, Companion_getInstance_48());
          }finally {
            renderingInternalRef.s2m(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.a7j_1;
        if (!(ctx.e7j_1 === batcher)) {
          ctx.e7j_1 = batcher;
          ctx.o7k();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.c7j_1;
        var bounds = this.f9b(ctx).m2a(ctx.q7i_1).n2a();
        var rect = c2d.x7t_1.a7q().x69();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.c2a(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_12().s69(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.x7t_1;
            var scissor_0 = c2d.f7u(scissor);
            var temp = this_0.h7k_1;
            this_0.q7q();
            this_0.h7k_1 = scissor_0;
            try {
              super.t95(ctx);
              break $l$block_1;
            }finally {
              this_0.q7q();
              this_0.h7k_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.t95(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.t95(ctx);
      }
    }
  }
}
class SContainer extends FixedSizeContainer {
  static v8x(size, clip) {
    size = size === VOID ? Size2D.a23(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.t9x(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.v9x_1 = capacity;
    this.w9x_1 = IntDeque.h2i(this.v9x_1);
    this.x9x_1 = 0;
  }
  d1() {
    return this.w9x_1.d1();
  }
  y9x() {
    return this.w9x_1.d1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.x9x_1 / this.w9x_1.d1());
  }
  z9x() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.y9x());
  }
  a9y(index) {
    return get_fastMicroseconds_0(this.w9x_1.c1(index));
  }
  b9y(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.w9x_1.m2i(intValue);
    this.x9x_1 = this.x9x_1 + intValue | 0;
    if (this.w9x_1.d1() > this.v9x_1) {
      this.x9x_1 = this.x9x_1 - this.w9x_1.xj() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static va3(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.h8v();
    $this.la0_1 = null;
    $this.ma0_1 = null;
    $this.na0_1 = true;
    $this.oa0_1 = false;
    $this.pa0_1 = true;
    $this.qa0_1 = true;
    $this.ra0_1 = EmptyShape_instance;
    $this.sa0_1 = renderer;
    $this.ta3(shape);
    return $this;
  }
  wa3() {
    var tmp0_elvis_lhs = this.la0_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.ma0_1 : tmp0_elvis_lhs);
  }
  s9g(value) {
    _get_anchorable__ebfoik(this).s9g(value);
    this.f8r();
  }
  e99() {
    return this.wa3().e99();
  }
  f99() {
    return this.wa3().f99();
  }
  xa3(value) {
    if (this.pa0_1 === value)
      return Unit_instance;
    this.pa0_1 = value;
    var tmp251_safe_receiver = this.la0_1;
    if (tmp251_safe_receiver == null)
      null;
    else {
      tmp251_safe_receiver.q9o_1 = value;
    }
    var tmp252_safe_receiver = this.ma0_1;
    if (tmp252_safe_receiver == null)
      null;
    else {
      tmp252_safe_receiver.va2_1 = value;
    }
    this.f8r();
  }
  ya3(value) {
    if (this.qa0_1 === value)
      return Unit_instance;
    this.qa0_1 = value;
    var tmp253_safe_receiver = this.la0_1;
    if (tmp253_safe_receiver == null)
      null;
    else {
      tmp253_safe_receiver.b9j_1 = value;
    }
    var tmp254_safe_receiver = this.ma0_1;
    if (tmp254_safe_receiver == null)
      null;
    else {
      tmp254_safe_receiver.ta2_1 = value;
    }
    this.f8r();
  }
  ta3(value) {
    if (this.ra0_1 === value)
      return Unit_instance;
    this.ra0_1 = value;
    ensure_0(this);
    var tmp255_safe_receiver = this.la0_1;
    if (tmp255_safe_receiver == null)
      null;
    else {
      tmp255_safe_receiver.q9v(value);
    }
    var tmp256_safe_receiver = this.ma0_1;
    if (tmp256_safe_receiver == null)
      null;
    else {
      tmp256_safe_receiver.ta3(value);
    }
    this.f8r();
  }
  za3() {
    ensure_0(this);
    var tmp257_safe_receiver = this.la0_1;
    if (tmp257_safe_receiver == null)
      null;
    else {
      tmp257_safe_receiver.k9m();
    }
    var tmp258_safe_receiver = this.la0_1;
    if (tmp258_safe_receiver == null)
      null;
    else
      tmp258_safe_receiver.l9m();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.b8i_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.ua6(views, currentVfs, sourceFile, $completion) : $super.ua6.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static na6(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_24().s20_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.oa6(bitmap, anchor, hitShape, smoothing);
    $this.ia6_1 = new Mixin_0();
    $this.ja6_1 = sourceFile$factory($this);
    return $this;
  }
  ma6(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, this, views, currentVfs, sourceFile, $completion), $completion);
  }
  pa6(ctx, view) {
    this.ia6_1.pa6(ctx, view);
  }
  qa6(_set____db54di) {
    this.ia6_1.ka6_1 = _set____db54di;
  }
  ra6(_set____db54di) {
    this.ia6_1.ra6(_set____db54di);
  }
  sa6() {
    return this.ia6_1.la6_1;
  }
  static ta6(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_24().s20_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.na6(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  t95(ctx) {
    this.pa6(ctx, this);
    super.t95(ctx);
  }
  ua6(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos(this, views, currentVfs, sourceFile, $completion), $completion);
  }
}
class Companion_5 {}
class Companion_6 {}
class SolidRect extends RectBase {
  static ha9(size, color) {
    color = color === VOID ? Colors_getInstance().k3n_1 : color;
    var $this = this.xa6();
    $this.ga9_1 = size;
    $this.d44(color);
    return $this;
  }
  n95(value) {
    if (this.ga9_1.equals(value))
      return Unit_instance;
    this.ga9_1 = value;
    this.g8l_1 = true;
    this.f8r();
  }
  o95() {
    return this.ga9_1;
  }
  o9m() {
    return this.n2d();
  }
  p9m() {
    return this.o2d();
  }
}
class Stage extends FixedSizeContainer {
  static p8g(views) {
    var $this = this.t9x();
    $this.l8g_1 = views.o8h_1;
    $this.m8g_1 = views;
    $this.n8g_1 = clipBorders$factory($this.u8s());
    $this.o8g_1 = virtualSizeDouble$factory($this.u8s());
    $this.h99($this);
    $this.j99($this);
    return $this;
  }
  b7s(pos) {
    return this.l8g_1.b7s(pos);
  }
  l7r(_set____db54di) {
    this.l8g_1.l7r(_set____db54di);
  }
  m7r() {
    return this.l8g_1.m7r();
  }
  n7r(_set____db54di) {
    this.l8g_1.n7r(_set____db54di);
  }
  o7r() {
    return this.l8g_1.o7r();
  }
  p7r(_set____db54di) {
    this.l8g_1.p7r(_set____db54di);
  }
  q7r() {
    return this.l8g_1.q7r();
  }
  r7r(_set____db54di) {
    this.l8g_1.r7r(_set____db54di);
  }
  s7r() {
    return this.l8g_1.s7r();
  }
  t7r(_set____db54di) {
    this.l8g_1.t7r(_set____db54di);
  }
  u7r() {
    return this.l8g_1.u7r();
  }
  v7r() {
    return this.l8g_1.v7r();
  }
  w7r() {
    return this.l8g_1.w7r();
  }
  x7r() {
    return this.l8g_1.x7r();
  }
  y7r() {
    return this.l8g_1.y7r();
  }
  z7r() {
    return this.l8g_1.z7r();
  }
  a7s() {
    return this.l8g_1.a7s();
  }
  u8s() {
    return this.m8g_1;
  }
  fy() {
    return this.m8g_1.e8h_1;
  }
  ia9(_set____db54di) {
    var this_0 = this.n8g_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  w5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n8g_1;
    clip$factory_0();
    return this_0.get();
  }
  n95(_set____db54di) {
    var this_0 = this.o8g_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  o95() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o8g_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  h9a() {
    return this;
  }
  j98() {
    return this;
  }
  k98(view) {
    this.u8s().k98(view);
  }
  toString() {
    return 'Stage';
  }
}
class Companion_7 {
  constructor() {
    this.kad_1 = 16.0;
    this.lad_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.la9_1 = this$0;
    this.ma9_1 = $ctx;
    this.na9_1 = $fontSource;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17(this, $completion), $completion);
  }
}
class Text extends Container {
  static pad(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_22.kad_1 : textSize;
    color = color === VOID ? Colors_getInstance().k3n_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_2().u4c_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_22.lad_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.h8v();
    $this.wab_1 = true;
    $this.xab_1 = -1;
    $this.yab_1 = -1;
    $this.zab_1 = 0;
    $this.aac_1 = 0;
    $this.bac_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.cac_1 = fill == null ? new RGBA(color) : fill;
    $this.dac_1 = stroke;
    $this.eac_1 = font;
    $this.fac_1 = numberToDouble(textSize);
    $this.gac_1 = textSize$factory($this);
    $this.hac_1 = 0;
    $this.iac_1 = 2147483647;
    $this.jac_1 = renderer;
    $this.kac_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.h8v(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.lac_1 = addTo(this_0, $this);
    $this.mac_1 = new Text2TextRendererActions();
    $this.nac_1 = false;
    $this.oac_1 = autoScaling;
    $this.pac_1 = false;
    $this.qac_1 = null;
    $this.rac_1 = Companion_getInstance_27().n29(0, 0, 2048, 2048);
    $this.sac_1 = true;
    $this.tac_1 = -1;
    $this.uac_1 = new MMatrix();
    $this.vac_1 = -1;
    $this.wac_1 = null;
    $this.xac_1 = new Entry();
    $this.yac_1 = new FontMetrics();
    $this.zac_1 = new TextMetrics();
    $this.aad_1 = null;
    $this.bad_1 = null;
    $this.cad_1 = null;
    $this.dad_1 = null;
    $this.ead_1 = new MMatrix();
    $this.fad_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.gad_1 = true;
    $this.had_1 = null;
    $this.iad_1 = fontSource$factory($this);
    return $this;
  }
  qad(value) {
    if (!(this.bac_1 === value)) {
      this.bac_1 = value;
      updateLineCount(this);
      this.m98();
      this.f8r();
    }
  }
  mad() {
    return this.bac_1;
  }
  p4u() {
    var tmp = this.cac_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.l44_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().k3n_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  oad(value) {
    if (!equals(this.eac_1, value)) {
      this.eac_1 = value;
      this.m98();
    }
  }
  rad(value) {
    if (!(this.fac_1 === value)) {
      this.fac_1 = value;
      this.m98();
    }
  }
  sad(_set____db54di) {
    var this_0 = this.gac_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  u45() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.gac_1;
    fontSize$factory_0();
    return this_0.get();
  }
  m98() {
    this.zab_1 = this.zab_1 + 1 | 0;
    super.m98();
  }
  i5c() {
    return this.kac_1.n4e_1;
  }
  nad(value) {
    this.qac_1 = value;
    this.nac_1 = false;
    this.m98();
  }
  jad(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09(this, currentVfs, sourceFile, $completion), $completion);
  }
  q95() {
    this.tad(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.q95();
    } else {
      return this.rac_1;
    }
  }
  t95(ctx) {
    this.tad(ctx);
    var tva = this.dad_1;
    if (!(tva == null)) {
      this.uac_1.k3h(this.k9a());
      this.uac_1.l3h(this.lac_1.m4y(), this.lac_1.n4y());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.a7j_1;
      var this_1 = this_0.j7j_1;
      if (!(this_1.e7j_1 === this_0)) {
        this_1.e7j_1 = this_0;
        this_1.o7k();
      }
      var tmp = this.eac_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.z45();
      this_0.u7q(tex, this.wab_1, this.n9a(), get_agProgram(bmpfont), tva.l7q_1, tva.k7q_1);
      this_0.p7q(tva, this.uac_1.i3h());
    } else {
      super.t95(ctx);
    }
  }
  tad(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.qac_1;
      if (!this.nac_1 && !(fontSource == null)) {
        this.nac_1 = true;
        launchImmediately_0(ctx.g7i_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.eac_1.xx();
    var tmp;
    var tmp_0;
    if (this.sac_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.tac_1 === this.zab_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.tac_1 = this.zab_1;
      var metrics = getTextBounds(font, this.fac_1, this.mad(), this.zac_1, this.jac_1, this.kac_1);
      this.rac_1 = new Rectangle(metrics.k22(), VerticalAlign__getOffsetY_impl_iso0y6(this.kac_1.n4e_1, metrics.o2d(), -metrics.u4e()), metrics.n2d(), font.d46(this.fac_1, this.yac_1).v45() * this.aac_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.jac_1.b5b();
        if (!(this.bad_1 === this.wab_1) || !(this.xab_1 === this.zab_1) || !(this.yab_1 === rversion)) {
          this.bad_1 = this.wab_1;
          this.yab_1 = rversion;
          this.xab_1 = this.zab_1;
          if (!(this.had_1 == null)) {
            this.had_1 = null;
            this.lac_1.u98();
          }
          this.mac_1.m5c();
          this.mac_1.z5b_1 = Companion_getInstance_2().y4c_1;
          invoke_0(this.jac_1, this.mac_1, this.mad(), this.fac_1, font);
          while (this.lac_1.o98() < this.mac_1.d1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.lac_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_24().s20_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.ta6(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.lac_1.o98() > this.mac_1.d1()) {
            this.lac_1.c1(this.lac_1.o98() - 1 | 0).z9a();
          }
          var bounds = this.mac_1.e33();
          var firstBounds = this.mac_1.k5c(0);
          var lineInfos = this.mac_1.j5c();
          var tmp0_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp0_elvis_lhs == null ? new LineInfo() : tmp0_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.z();
          while (tmp0_iterator.a1()) {
            var element = tmp0_iterator.b1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.i5b_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.f22_1;
          var textHeight = bounds.g22_1;
          var dx = this.rac_1.d22_1;
          var tmp306_subject = this.i5c();
          var dy = equals(tmp306_subject, Companion_getInstance_3().p5a_1) ? 0.0 : equals(tmp306_subject, Companion_getInstance_3().m5a_1) ? firstLineInfos.g5b_1 : firstLineInfos.g5b_1 - totalHeight * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.i5c());
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.mac_1.d1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.mac_1.l5c(n, this.xac_1);
              var tmp_2 = this.lac_1.c1(n);
              var it = tmp_2 instanceof Image ? tmp_2 : THROW_CCE();
              it.u9o_1 = program;
              it.d44(this.p4u());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.f21(numberToDouble(0), numberToDouble(0)));
              it.q9o_1 = this.wab_1;
              it.n9m(entry.j5b_1);
              it.f4h(Vector2D.j21(entry.k5b_1 + dx, entry.l5b_1 + dy));
              it.v99(Scale.j29(entry.m5b_1, entry.n5b_1));
              it.wa6(entry.o5b_1);
              var containsLower = this.hac_1;
              it.m81(n < this.iac_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.bad_1 === this.wab_1) || !(this.cad_1 === this.gad_1)) {
          this.zab_1 = this.zab_1 + 1 | 0;
          this.cad_1 = this.gad_1;
          this.aad_1 = this.oac_1;
          this.bad_1 = this.wab_1;
        }
        if (!(this.xab_1 === this.zab_1)) {
          this.xab_1 = this.zab_1;
          var realTextSize = this.fac_1;
          if (this.had_1 == null) {
            this.lac_1.u98();
            var tmp_3 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.lac_1;
            var renderer = this.fad_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.va3(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).w4b();
            this_3.ta3(tmp$ret$10);
            this_3.za3();
            tmp_3.had_1 = this_3;
            var tmp307_safe_receiver = this.had_1;
            if (tmp307_safe_receiver == null)
              null;
            else {
              tmp307_safe_receiver.ya3(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.had_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp308_text = this.mad();
          var tmp309_pos = Companion_getInstance_26().v21_1;
          var tmp310_paint = this.p4u();
          var tmp311_renderer = this.jac_1;
          var tmp312_align = this.kac_1;
          var tmp313_outMetrics = new TextMetricsResult();
          var tmp314_fillStyle = this.cac_1;
          var tmp315_stroke = this.dac_1;
          var tmp316_textRangeStart = this.hac_1;
          var tmp317_textRangeEnd = this.iac_1;
          result_0 = this_5.p5h(tmp308_text, tmp309_pos, VOID, new RGBA(tmp310_paint), font, realTextSize, tmp311_renderer, tmp312_align, tmp313_outMetrics, tmp314_fillStyle, tmp315_stroke, tmp316_textRangeStart, tmp317_textRangeEnd);
          var tmp$ret$16 = this_5.w4b();
          this_4.ta3(tmp$ret$16);
          var metrics_0 = result_0;
          this.vac_1 = this.zab_1;
          this.wac_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_26().v21_1, font.d46(this.u45(), this.yac_1).h46_1);
        }
        var tmp318_safe_receiver = this.had_1;
        if (tmp318_safe_receiver == null)
          null;
        else {
          tmp318_safe_receiver.xa3(this.wab_1);
        }
      }
    }
  }
}
class ColorReference {}
class Companion_8 {
  uad(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp343_safe_receiver = l;
        l = tmp343_safe_receiver == null ? null : tmp343_safe_receiver.m1s();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp344_safe_receiver = r;
        r = tmp344_safe_receiver == null ? null : tmp344_safe_receiver.m1s();
      }
    }
    return null;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.vad_1 = function_0;
  }
  ei(a, b) {
    return this.vad_1(a, b);
  }
  compare(a, b) {
    return this.ei(a, b);
  }
}
class ViewRenderPhase {}
function get_priority() {
  return 0;
}
function render_0(view, ctx) {
  return view.v9a(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.bae_1 = $view;
    this.cae_1 = $ctx;
    this.dae_1 = this$0;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18(this, $completion), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.ka6_1 = true;
    this.la6_1 = null;
  }
  qa6(_set____db54di) {
    this.ka6_1 = _set____db54di;
  }
  ra6(value) {
    this.ka6_1 = false;
    this.la6_1 = value;
  }
  ma6(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.ra6(sourceFile);
    _this__u8e3s4.qa6(true);
  }
  ua6(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  pa6(ctx, view) {
    if (this.ka6_1)
      return Unit_instance;
    this.eae(ctx, view);
  }
  eae(ctx, view) {
    if (!this.ka6_1 && !(this.la6_1 == null)) {
      this.ka6_1 = true;
      launchImmediately_0(ctx.g7i_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.fae_1 = this$0;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19(this, $completion), $completion);
  }
}
class Views extends BaseEventListener {
  static d8p(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_5().f7p_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.k5q();
    $this.d8h_1 = new Mixin();
    $this.e8h_1 = coroutineContext;
    $this.f8h_1 = ag;
    $this.g8h_1 = injector;
    $this.h8h_1 = input;
    $this.i8h_1 = timeProvider;
    $this.j8h_1 = stats;
    $this.k8h_1 = gameWindow;
    $this.l8h_1 = gameId;
    $this.m8h_1 = settingsFolder;
    $this.n8h_1 = batchMaxQuads;
    $this.o8h_1 = bp;
    $this.p8h_1 = stageBuilder;
    $this.q8h_1 = quality$factory($this.k8h_1);
    $this.r8h_1 = $this;
    $this.s8h_1 = false;
    $this.t8h_1 = continuousRenderMode$factory($this.k8h_1);
    $this.u8h_1 = new ReshapeEvent(0, 0);
    $this.v8h_1 = new UpdateEvent();
    $this.w8h_1 = new ViewsUpdateEvent($this);
    $this.x8h_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.y8h_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.a8i_1 = null;
    $this.b8i_1 = get_resourcesVfs();
    $this.c8i_1 = get_RegisteredImageFormats();
    $this.d8i_1 = new RenderContext($this.f8h_1, $this, $this.k8h_1, $this.j8h_1, $this.e8h_1, $this.n8h_1, $this.k8h_1);
    $this.e8i_1 = true;
    $this.f8i_1 = Colors_getInstance().l3n_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.g8i_1 = HashMap.f8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.h8i_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.i8i_1 = new Resources($this.e8h_1, $this.b8i_1);
    $this.j8i_1 = false;
    $this.k8i_1 = 1280;
    $this.l8i_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.m8i_1 = ArrayList.p1();
    $this.n8i_1 = Companion_getInstance_23().o2b_1;
    $this.o8i_1 = Companion_getInstance_24().w20_1;
    $this.p8i_1 = true;
    $this.q8i_1 = $this.p8h_1($this);
    $this.r8i_1 = $this.q8i_1;
    $this.s8i_1 = true;
    $this.t8i_1 = false;
    $this.u8i_1 = debugExtraFontScale$factory($this.d8i_1);
    $this.v8i_1 = debugExtraFontColor$factory($this.d8i_1);
    $this.w8i_1 = FastArrayList.lx();
    $this.x8i_1 = $this.i8h_1.w1n();
    var tmp_4 = $this;
    tmp_4.y8i_1 = Pool.l2l(VOID, Views$tempViewsPool$lambda);
    $this.z8i_1 = SizeInt.a2c();
    $this.a8j_1 = SizeInt.a2c();
    $this.b8j_1 = SizeInt.a2c();
    $this.c8j_1 = new Signal();
    $this.d8j_1 = new Signal();
    $this.e8j_1 = -1.0;
    $this.g8h_1.q5n(getKClass(CoroutineContext), $this.e8h_1);
    $this.g8h_1.q5n(getKClass(AG), $this.f8h_1);
    $this.g8h_1.q5n(getKClass(Views), $this);
    $this.d8j_1.h1p(Views$lambda($this));
    $this.c8j_1.h1p(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.f8j_1 = Companion_instance_11.lh('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.g8j_1 = new EventResult();
    $this.h8j_1 = new Signal();
    $this.i8j_1 = Companion_getInstance_0().us('debugHightlightView');
    $this.j8j_1 = new Signal();
    $this.k8j_1 = new Signal();
    $this.l8j_1 = ArrayList.p1();
    $this.m8j_1 = updatedSinceFrame$factory($this.k8h_1);
    return $this;
  }
  tw(_set____db54di) {
    this.d8h_1.tw(_set____db54di);
  }
  uw() {
    return this.d8h_1.uw();
  }
  fy() {
    return this.e8h_1;
  }
  a7t() {
    return this.k8h_1.a7t();
  }
  b7t() {
    return this.k8h_1.b7t();
  }
  c7t() {
    return this.k8h_1.c7t();
  }
  d7t() {
    return this.k8h_1.d7t();
  }
  b7s(pos) {
    return this.o8h_1.b7s(pos);
  }
  l7r(_set____db54di) {
    this.o8h_1.l7r(_set____db54di);
  }
  m7r() {
    return this.o8h_1.m7r();
  }
  n7r(_set____db54di) {
    this.o8h_1.n7r(_set____db54di);
  }
  o7r() {
    return this.o8h_1.o7r();
  }
  p7r(_set____db54di) {
    this.o8h_1.p7r(_set____db54di);
  }
  q7r() {
    return this.o8h_1.q7r();
  }
  r7r(_set____db54di) {
    this.o8h_1.r7r(_set____db54di);
  }
  s7r() {
    return this.o8h_1.s7r();
  }
  t7r(_set____db54di) {
    this.o8h_1.t7r(_set____db54di);
  }
  u7r() {
    return this.o8h_1.u7r();
  }
  v7r() {
    return this.o8h_1.v7r();
  }
  w7r() {
    return this.o8h_1.w7r();
  }
  x7r() {
    return this.o8h_1.x7r();
  }
  y7r() {
    return this.o8h_1.y7r();
  }
  z7r() {
    return this.o8h_1.z7r();
  }
  a7s() {
    return this.o8h_1.a7s();
  }
  u8s() {
    return this.r8h_1;
  }
  o8p(_set____db54di) {
    var this_0 = this.t8h_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  i8p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t8h_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  hae() {
    return replace(replace(replace(this.l8h_1, '\\', ''), '/', ''), '..', '');
  }
  c9y() {
    var tmp = this.z8h_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  v1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk(this, $completion), $completion);
  }
  n8p() {
    return this.i8i_1;
  }
  p8p() {
    return this.f8h_1.z5y().s5y_1;
  }
  q8p() {
    return this.f8h_1.z5y().t5y_1;
  }
  iae(value) {
    this.k8i_1 = numberToInt(value);
  }
  jae() {
    return this.k8i_1;
  }
  kae(value) {
    this.l8i_1 = numberToInt(value);
  }
  lae() {
    return this.l8i_1;
  }
  ka9(value) {
    this.iae(value.y22_1);
    this.kae(value.z22_1);
  }
  ja9() {
    return Size2D.t29(this.jae(), this.lae());
  }
  z5() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  gae($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw(this, $completion), $completion);
  }
  e8p(_set____db54di) {
    var this_0 = this.u8i_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  mae() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u8i_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  f8p(_set____db54di) {
    var this_0 = this.v8i_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  nae() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v8i_1;
    debugFontColor$factory_0();
    return this_0.get().l44_1;
  }
  u9x(block) {
    this.w8i_1.f(block);
  }
  o5q(type, event, result, up, down) {
    event.h5r(false);
    var result_0 = super.o5q(type, event, result, up, down);
    var e = event;
    e.g5r(this.r8h_1);
    if (e instanceof KeyEvent) {
      this.h8h_1.o7m(e);
      this.h8h_1.v7l_1.f7l(e);
      if (e.b5s_1.equals(Type_UP_getInstance_0()) && this.s8i_1 && (e.d5s_1.equals(Key_F12_getInstance()) || e.d5s_1.equals(Key_F7_getInstance()))) {
        this.t8i_1 = !this.t8i_1;
        this.k8h_1.q81(this.t8i_1);
        this.k98(this.q8i_1);
      }
    }
    try {
      return this.q8i_1.x5q(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  oae(frameBuffer) {
    this.d8i_1.f7j_1 = frameBuffer;
    if (this.e8i_1) {
      var tmp404_$this = this.d8i_1;
      var tmp405_color = this.f8i_1;
      tmp404_$this.l7t(tmp405_color, 1.0, 0, true, true, true);
    }
    this.c8j_1.i1p(this.d8i_1);
    this.d8i_1.o7k();
    this.q8i_1.p95(this.d8i_1);
    this.d8i_1.o7k();
    this.q8i_1.x98(this.d8i_1);
    if (this.t8i_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.w8i_1.jx_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.d8i_1);
      }
    }
    this.d8j_1.i1p(this.d8i_1);
    this.d8i_1.o7k();
  }
  pae(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.f8h_1.z5y() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.oae(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.oae.call(this, frameBuffer);
    }
    return tmp;
  }
  qae() {
    this.f8h_1.d5z();
    this.pae();
  }
  j8p(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.i8h_1.w1n();
    this.r8h_1.j8h_1.d5z();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_35().x8d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.x8i_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.r8h_1.h8i_1) > 0 ? this.r8h_1.h8i_1 : delta;
    this.x8i_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.c1o())) {
        this.sae(fixedSizeStep);
      } else {
        this.rae(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.tae() > 0);
    if (doRender2) {
      if (this.f8j_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_4().y1n().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.tae() + ']');
      }
      this.qae();
      this.d5z();
    }
  }
  rae(elapsed) {
    return this.sae(get_fast(elapsed));
  }
  sae(elapsed) {
    this.h8h_1.m7m(elapsed);
    this.g8j_1.e2h();
    updateSingleViewWithViewsAll(this.q8i_1, this, elapsed);
    this.h8h_1.n7m(elapsed);
  }
  h8p() {
  }
  m8p(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.a8j_1 = SizeInt.z2b(actualWidth, actualHeight);
    this.uae();
  }
  uae() {
    setBoundsInfo(this.o8h_1, Size2D.a23(this.k8i_1, this.l8i_1), toFloat(this.a8j_1), this.n8i_1, this.o8i_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.d8i_1.m7i_1 = this.o8h_1.q7r();
    this.d8i_1.n7i_1 = this.o8h_1.m7r();
    // Inline function 'kotlin.also' call
    var this_0 = this.u8h_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.w5r_1 = this.a8j_1.x2b_1;
    this_0.x5r_1 = this.a8j_1.y2b_1;
    this.x5q(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.x8h_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.yae_1 = this.z8i_1;
    this.x5q(this_1);
    this.q8i_1.m98();
  }
  zae(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.k8h_1.r81())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.i8j_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.h8j_1.i1p(viewToHightlight);
  }
  s8z(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.zae(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.zae.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  aaf(_set____db54di) {
    var this_0 = this.m8j_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  tae() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m8j_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  d5z() {
    this.k8h_1.d5z();
  }
  k98(view) {
    this.k8h_1.f82();
  }
}
class Companion_9 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.b1o() : fastDelta;
    super();
    this.daf_1 = views;
    this.eaf_1 = fastDelta;
  }
  q25() {
    return Companion_instance_24;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.eaf_1) + ')';
  }
}
class Companion_10 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.z2b(0, 0) : size;
    super();
    this.xae_1 = views;
    this.yae_1 = size;
  }
  q25() {
    return Companion_instance_25;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.yae_1.toString() + ')';
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.faf_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  gaf(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.faf_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_31().q24_1;
}
class RenderToTextureResult {
  constructor() {
    this.kaf_1 = null;
    this.laf_1 = 0;
    this.maf_1 = 0;
    this.naf_1 = 0;
    this.oaf_1 = 0;
    this.paf_1 = 1.0;
    this.qaf_1 = Companion_getInstance_29().a25_1;
    this.raf_1 = null;
    this.saf_1 = null;
    this.taf_1 = null;
    this.uaf_1 = null;
  }
  p11() {
    if (this.saf_1 == null || this.uaf_1 == null)
      return Unit_instance;
    var tmp450_safe_receiver = this.saf_1;
    if (tmp450_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp451_safe_receiver = this.uaf_1;
      var tmp;
      if (tmp451_safe_receiver == null) {
        tmp = null;
      } else {
        tmp451_safe_receiver.s7t(tmp450_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.kaf_1 = null;
    this.raf_1 = null;
    this.saf_1 = null;
    this.uaf_1 = null;
    this.taf_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_48();
    this.vaf_1 = smoothing;
  }
  jaf(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a7j_1;
    var this_1 = this_0.j7j_1;
    if (!(this_1.e7j_1 === this_0)) {
      this_1.e7j_1 = this_0;
      this_1.o7k();
    }
    this_0.q7k(texture, VOID, VOID, VOID, VOID, matrix, this.vaf_1, renderColorMul, blendMode, Companion_getInstance_5().m7p_1);
  }
}
class Companion_12 extends IdentityFilter {
  constructor() {
    Companion_instance_27 = null;
    super(true);
    Companion_instance_27 = this;
  }
}
class Linear extends IdentityFilter {
  constructor() {
    Linear_instance = null;
    super(true);
    Linear_instance = this;
  }
}
class Nearest extends IdentityFilter {
  constructor() {
    Nearest_instance = null;
    super(false);
    Nearest_instance = this;
  }
}
class ViewRenderPhaseBackdropFilter {}
class Companion_13 {
  constructor() {
    this.yaf_1 = -200;
  }
}
class ViewRenderPhaseFilter {
  constructor(filter) {
    filter = filter === VOID ? null : filter;
    this.xaf_1 = filter;
  }
  wad() {
    return -200;
  }
  zad(view, ctx) {
    if (!(this.xaf_1 == null)) {
      renderFiltered(view, ctx, ensureNotNull(this.xaf_1), false);
    } else {
      render_0.call(this, view, ctx);
    }
  }
}
class Info {
  constructor(tex, vertices) {
    this.zaf_1 = tex;
    this.aag_1 = vertices;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = FastArrayList.lx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.Info.verticesList.<anonymous>' call
    this_0.f(this.aag_1);
    tmp.bag_1 = this_0;
  }
  cag(vertices) {
    vertices.e2h();
    this.aag_1 = vertices;
    this.bag_1.f(vertices);
  }
  e2h() {
    this.aag_1.x7v_1 = 0;
    this.aag_1.w7v_1 = 0;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_29 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      var tmp_3 = Companion_getInstance_50();
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp_4 = !(((tmp_2 >>> 0 | 0) & 1) === 0);
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp_5 = !(((tmp_2 >>> 1 | 0) & 1) === 0);
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp$ret$6 = !(((tmp_2 >>> 2 | 0) & 1) === 0);
      tmp_1[tmp_2] = computeIndices$default(tmp_3, tmp_4, tmp_5, tmp$ret$6);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.dag_1 = tmp_1;
  }
}
class TileMap extends View {
  static daj(map, tileset, smoothing, tileSize) {
    Companion_getInstance_50();
    map = map === VOID ? TileMapData.g5d(1, 1) : map;
    tileset = tileset === VOID ? map.c5d_1 : tileset;
    smoothing = smoothing === VOID ? true : smoothing;
    tileSize = tileSize === VOID ? tileset.e5e() : tileSize;
    var $this = this.s9x();
    $this.eai_1 = map;
    $this.fai_1 = smoothing;
    $this.gai_1 = tileSize;
    $this.hai_1 = 0.0;
    $this.iai_1 = 0.0;
    $this.jai_1 = $this.eai_1.d5d_1;
    $this.kai_1 = $this.eai_1.e5d_1;
    $this.lai_1 = 0;
    $this.mai_1 = -1;
    $this.nai_1 = -1;
    $this.oai_1 = new FastIdentityCacheMap();
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.pai_1 = ArrayList.p1();
    var tmp_0 = $this;
    var tmp_1 = TileMap$infosPool$lambda;
    tmp_0.qai_1 = Pool.k2l(tmp_1, VOID, TileMap$infosPool$lambda_0);
    $this.rai_1 = Companion_getInstance_27().n29(-1, -1, -1, -1);
    $this.sai_1 = Companion_getInstance_27().n29(-1, -1, -1, -1);
    $this.tai_1 = new Float32Array(4);
    $this.uai_1 = new Float32Array(4);
    $this.vai_1 = 0;
    $this.wai_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.emptyArray' call
    tmp_2.xai_1 = [];
    $this.yai_1 = new Int32Array(0);
    $this.zai_1 = new Float64Array(0);
    $this.aaj_1 = tileset;
    updatedTileSet($this);
    addFastUpdater_0($this, TileMap$lambda(tileset));
    return $this;
  }
  t95(ctx) {
    if (!this.i9a())
      return Unit_instance;
    computeVertexIfRequired(this, ctx);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a7j_1;
    var this_1 = this_0.j7j_1;
    if (!(this_1.e7j_1 === this_0)) {
      this_1.e7j_1 = this_0;
      this_1.o7k();
    }
    var this_2 = this.pai_1;
    var n = 0;
    while (n < this_2.d1()) {
      // Inline function 'korlibs.korge.view.tiles.TileMap.renderInternal.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var info = this_2.c1(_unary__edvuaz);
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = info.bag_1.jx_1;
      var n_0 = 0;
      while (n_0 < array.length) {
        // Inline function 'korlibs.korge.view.tiles.TileMap.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var vertices = array[_unary__edvuaz_0];
        // Inline function 'korlibs.korge.render.BatchBuilder2D.drawVertices' call
        var array_0 = vertices.v7v_1;
        var tex = ctx.n7t(info.zaf_1);
        var smoothing = this.fai_1;
        var blendMode = this.n9a();
        var vcount = vertices.w7v_1;
        var icount = vertices.x7v_1;
        var matrix = Companion_getInstance_29().b25_1;
        $l$block: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
          var tex_0 = tex.k7n_1;
          this_0.d7q(icount, vcount);
          var pprogram = null == null ? Companion_getInstance_5().m7p_1 : null;
          if (this_0.s7q(tex_0, smoothing, blendMode, pprogram)) {
            break $l$block;
          }
          this_0.u7p();
          if (!contains(this_0.z7j_1, tex_0)) {
            this_0.y7j_1 = 0;
            this_0.z7j_1[0] = tex_0;
          }
          this_0.a7k_1 = smoothing;
          this_0.b7k_1 = blendMode;
          this_0.c7k_1 = pprogram;
        }
        this_0.p7q(array_0, matrix, vcount, icount);
      }
    }
  }
  q95() {
    return Companion_getInstance_27().o29(0.0, 0.0, this.hai_1 * this.eai_1.n2d(), this.iai_1 * this.eai_1.o2d());
  }
  eaj(repeatX, repeatY) {
    this.jai_1 = repeatX;
    this.kai_1 = repeatY;
    return this;
  }
}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.pak_1 = bounds;
    this.qak_1 = vertexCount;
    this.rak_1 = vertexStart;
    this.sak_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static sa3(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.s9x();
    $this.ta2_1 = autoScaling;
    $this.ua2_1 = true;
    $this.va2_1 = true;
    $this.wa2_1 = true;
    $this.xa2_1 = new GpuShapeViewCommands();
    $this.ya2_1 = 1000;
    $this.za2_1 = 1000;
    $this.aa3_1 = Companion_getInstance_24().s20_1;
    $this.ba3_1 = true;
    $this.ca3_1 = false;
    $this.da3_1 = antialiased;
    $this.ea3_1 = shape;
    $this.fa3_1 = false;
    $this.ga3_1 = false;
    $this.ha3_1 = false;
    $this.ia3_1 = 0;
    $this.ja3_1 = Companion_getInstance_27().d25();
    $this.ka3_1 = Companion_getInstance_27().d25();
    $this.la3_1 = false;
    $this.ma3_1 = 1.0;
    $this.na3_1 = NaN;
    $this.oa3_1 = Companion_getInstance_29().d25();
    $this.pa3_1 = 100000;
    $this.qa3_1 = false;
    $this.ra3_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  s9g(value) {
    this.aa3_1 = value;
    this.m98();
  }
  w9o() {
    return this.aa3_1;
  }
  ua3(value) {
    this.da3_1 = value;
    invalidateShape(this);
  }
  ta3(value) {
    this.ea3_1 = value;
    invalidateShape(this);
  }
  e99() {
    return _get_shapeBounds__actvvf(this).f22_1 * this.w9o().b21_1;
  }
  f99() {
    return _get_shapeBounds__actvvf(this).g22_1 * this.w9o().c21_1;
  }
  m98() {
    super.m98();
    invalidateShape(this);
  }
  q95() {
    return new Rectangle(_get_shapeBounds__actvvf(this).d22_1 - this.e99(), _get_shapeBounds__actvvf(this).e22_1 - this.f99(), _get_shapeBounds__actvvf(this).f22_1, _get_shapeBounds__actvvf(this).g22_1);
  }
  uak(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.b5j_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.f1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.z();
          while (tmp0_iterator.a1()) {
            var element = tmp0_iterator.b1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.uak(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.uak(_this__u8e3s4.u5j());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.z5i();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  t95(ctx) {
    this.ma3_1 = this.k9a().n26().l27() * ctx.d7i_1.a7s();
    if (!(this.na3_1 === this.ma3_1)) {
      invalidateShape(this);
    }
    ctx.o7k();
    var doRequireTexture = this.uak(this.ea3_1);
    // Inline function 'korlibs.time.measureTime' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.oi();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.c7i_1.z5y();
      this.ya2_1 = currentFrameBuffer.s5y_1;
      this.za2_1 = currentFrameBuffer.t5y_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.ya2_1;
      var height = this.za2_1;
      ctx.o7k();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.r7t(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.t7t(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.a7j_1;
          var this_1 = this_0.j7j_1;
          if (!(this_1.e7j_1 === this_0)) {
            this_1.e7j_1 = this_0;
            this_1.o7k();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.p69(0, 0, rb.s5y_1, rb.t5y_1);
            var temp = this_0.h7k_1;
            this_0.q7q();
            this_0.h7k_1 = scissor;
            try {
              if (true) {
                ctx.l7t(Colors_getInstance().p3n_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.q7q();
              this_0.h7k_1 = temp;
            }
          }
        }finally {
          ctx.u7t();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).d3a(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.a7j_1;
        var this_3 = this_2.j7j_1;
        if (!(this_3.e7j_1 === this_2)) {
          this_3.e7j_1 = this_2;
          this_3.o7k();
        }
        this_2.q7k(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.d7i_1.m7r()));
        ctx.o7k();
      }finally {
        ctx.s7t(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.vak_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.vak_1.toString() + ')';
  }
  hashCode() {
    return this.vak_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.vak_1.equals(tmp0_other_with_cast.vak_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.wak_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.wak_1 + ')';
  }
  hashCode() {
    return this.wak_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.wak_1 === tmp0_other_with_cast.wak_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_15().j68_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_21().c60_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_16().z5z_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_17().x5z_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_20().n60_1 : cullFace;
    this.xak_1 = drawType;
    this.yak_1 = vertexIndex;
    this.zak_1 = vertexEnd;
    this.aal_1 = paintShader;
    this.bal_1 = program;
    this.cal_1 = colorMask;
    this.dal_1 = stencilOpFunc;
    this.eal_1 = stencilRef;
    this.fal_1 = blendMode;
    this.gal_1 = cullFace;
  }
  y7p() {
    return this.zak_1 - this.yak_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.xak_1) + ', vertexIndex=' + this.yak_1 + ', vertexEnd=' + this.zak_1 + ', paintShader=' + toString_0(this.aal_1) + ', program=' + toString_0(this.bal_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.cal_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.dal_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.eal_1) + ', blendMode=' + toString_0(this.fal_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.gal_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.xak_1);
    result = imul(result, 31) + this.yak_1 | 0;
    result = imul(result, 31) + this.zak_1 | 0;
    result = imul(result, 31) + (this.aal_1 == null ? 0 : this.aal_1.hashCode()) | 0;
    result = imul(result, 31) + (this.bal_1 == null ? 0 : this.bal_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.cal_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.dal_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.eal_1) | 0;
    result = imul(result, 31) + (this.fal_1 == null ? 0 : this.fal_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.gal_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.xak_1 === tmp0_other_with_cast.xak_1))
      return false;
    if (!(this.yak_1 === tmp0_other_with_cast.yak_1))
      return false;
    if (!(this.zak_1 === tmp0_other_with_cast.zak_1))
      return false;
    if (!equals(this.aal_1, tmp0_other_with_cast.aal_1))
      return false;
    if (!equals(this.bal_1, tmp0_other_with_cast.bal_1))
      return false;
    if (!(this.cal_1 === tmp0_other_with_cast.cal_1))
      return false;
    if (!(this.dal_1 === tmp0_other_with_cast.dal_1))
      return false;
    if (!equals(this.eal_1, tmp0_other_with_cast.eal_1))
      return false;
    if (!equals(this.fal_1, tmp0_other_with_cast.fal_1))
      return false;
    if (!(this.gal_1 === tmp0_other_with_cast.gal_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.faj_1 = 0;
    this.gaj_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.haj_1 = ArrayList.p1();
    this.iaj_1 = null;
    this.jaj_1 = FastArrayList.lx();
    this.kaj_1 = 0;
    this.laj_1 = 0;
    this.maj_1 = MatrixTransform.j27();
    this.naj_1 = FastArrayList.lx();
    this.oaj_1 = AGTextureUnits.k62();
  }
  j3() {
    this.faj_1 = 0;
    this.gaj_1.j3();
    this.haj_1.j3();
  }
  taj(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.kaj_1;
      this.kaj_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.gaj_1.o2e(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.faj_1;
    this.faj_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  saj() {
    this.laj_1 = this.faj_1;
    return this.laj_1;
  }
  uaj() {
    return this.faj_1;
  }
  tak(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.haj_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.f(element);
  }
  oak(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_21().c60_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_16().z5z_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_17().x5z_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().h7h_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_20().n60_1 : cullFace;
    startIndex = startIndex === VOID ? this.laj_1 : startIndex;
    endIndex = endIndex === VOID ? this.faj_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.tak(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.tak.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  p6o(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.haj_1;
    var element = new ClearCommand(i);
    this_0.f(element);
  }
  paj(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.p6o(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.p6o.call(this, i);
    }
    return tmp;
  }
  qaj(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.haj_1;
    var element = new ScissorCommand(scissor);
    this_0.f(element);
  }
  b5z() {
    var tmp488_safe_receiver = this.iaj_1;
    if (tmp488_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.jaj_1.f(tmp488_safe_receiver);
    }
    this.iaj_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.gaj_1.t2e())));
  }
  raj(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.iaj_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.w7i_1.c7p(this.jaj_1);
    this.jaj_1.j3();
    ctx.o7k();
    var ag = ctx.c7i_1;
    var vao = AGVertexArrayObject.u67(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().eak_1, ctx.z7o(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a7j_1;
    var this_1 = this_0.j7j_1;
    if (!(this_1.e7j_1 === this_0)) {
      this_1.e7j_1 = this_0;
      this_1.o7k();
    }
    this_0.z7q();
    var tempMat = (doRequireTexture ? Companion_getInstance_29().a25_1 : this_0.w7p()).l26(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.j7j_1;
    this_2.o7k();
    var temp4 = this_2.p7i_1;
    var temp2d = this_2.q7i_1;
    this_2.q7i_1 = tempMat;
    this_2.p7i_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.b66(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.q67();
      this_3.x6t(_unary__edvuaz + 1 | 0);
      this_3.y6t(this_3.q67() + 1 | 0);
      var blockSize = this_3.u65_1;
      var index0 = imul(this_3.q67() - 1 | 0, blockSize);
      var index1 = imul(this_3.q67(), blockSize);
      var texBlockSize = this_3.r65_1.q6d().d1();
      var texIndex0 = imul(this_3.q67() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.q67(), texBlockSize);
      if (this_3.q67() > 0) {
        arraycopy(this_3.w65_1, index0, this_3.w65_1, index1, blockSize);
      } else {
        arrayfill(this_3.w65_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.r65_1;
      this_3.x65_1.h6u($this$push.p6d(), this_2.p7i_1);
      if (true && this_3.q67() >= 1) {
        var equals = arrayequal(this_3.w65_1, index0, this_3.w65_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.q67();
          this_3.x6t(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.maj_1 = globalMatrix.n26();
      var program = GpuShapeViewPrograms_getInstance().lak_1;
      var scissor = Companion_getInstance_12().l60_1;
      var this_4 = this.haj_1;
      var n = 0;
      while (n < this_4.d1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.c1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.vak_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp490_stencil = cmd.wak_1;
            ctx.l7t(VOID, VOID, tmp490_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.aal_1;
              this_0.f7r(cmd.y7p());
              var pixelScale = this.maj_1.l27() / ctx.d7i_1.a7s();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.j7j_1.b66(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.q67();
                  this_5.x6t(_unary__edvuaz_2 + 1 | 0);
                  this_5.y6t(this_5.q67() + 1 | 0);
                  var blockSize_0 = this_5.u65_1;
                  var index0_0 = imul(this_5.q67() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.q67(), blockSize_0);
                  var texBlockSize_0 = this_5.r65_1.q6d().d1();
                  var texIndex0_0 = imul(this_5.q67() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.q67(), texBlockSize_0);
                  if (this_5.q67() > 0) {
                    arraycopy(this_5.w65_1, index0_0, this_5.w65_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.w65_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.r65_1;
                  var it = this_5.x65_1;
                  it.b6u(paintShader.hal_1);
                  it.c6u($this$push_0.wal(), pixelScale);
                  it.e6u($this$push_0.xal(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.q67() >= 1) {
                    var equals_0 = arrayequal(this_5.w65_1, index0_0, this_5.w65_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.q67();
                      this_5.x6t(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.ial_1 == null)) {
                  var tex = ctx.s7i_1.n2l();
                  tex.i64(paintShader.ial_1);
                  this.oaj_1.b63(DefaultShaders_getInstance().j6g(), tex);
                  this.naj_1.f(tex);
                }
              }
              var tmp0_elvis_lhs_0 = cmd.bal_1;
              var _program = tmp0_elvis_lhs_0 == null ? program : tmp0_elvis_lhs_0;
              var tmp491_frameBuffer = ctx.f7j_1.l5y_1;
              var tmp492_frameBufferInfo = ctx.f7j_1.r60();
              var tmp493_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp494_uniformBlocks = ctx.z7s(_program);
              var tmp495_textureUnits = this.oaj_1.qw();
              var tmp496_stencilOpFunc = cmd.dal_1;
              var tmp497_stencilRef = cmd.eal_1;
              var tmp498_colorMask = cmd.cal_1;
              var tmp1_elvis_lhs = cmd.fal_1;
              var tmp499_blending = (tmp1_elvis_lhs == null ? Companion_getInstance_13().h7h_1 : tmp1_elvis_lhs).r7k_1;
              var tmp500_cullFace = cmd.gal_1;
              var tmp501_drawType = cmd.xak_1;
              var tmp502_drawOffset = cmd.yak_1;
              var tmp503_vertexCount = cmd.y7p();
              draw(ag, new AGBatch(tmp491_frameBuffer, tmp492_frameBufferInfo, vao, VOID, VOID, _program, tmp494_uniformBlocks, tmp495_textureUnits, tmp499_blending, tmp496_stencilOpFunc, tmp497_stencilRef, tmp498_colorMask, VOID, tmp493_scissor, tmp500_cullFace, tmp501_drawType, tmp502_drawOffset, tmp503_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.o7k();
      this_2.p7i_1 = temp4;
      this_2.q7i_1 = temp2d;
      this_2.b66(ProjViewUB_getInstance()).z6t();
    }
    var _iterator__ex2g4s = this.naj_1.z();
    while (_iterator__ex2g4s.a1()) {
      var tex_0 = _iterator__ex2g4s.b1();
      ctx.s7i_1.o2l(tex_0);
    }
    this.naj_1.j3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.oal_1 = this.v6d().n6d(this, u_ProgramType$factory());
    this.pal_1 = this.x6d().n6d(this, u_Color$factory());
    this.qal_1 = this.x6d().n6d(this, u_ColorMul$factory());
    this.ral_1 = this.v6d().n6d(this, u_GlobalAlpha$factory());
    this.sal_1 = this.v6d().n6d(this, u_GlobalPixelScale$factory());
    this.tal_1 = this.d6d().n6d(this, u_Transform$factory());
    this.ual_1 = this.x6d().n6d(this, u_Gradientp0$factory());
    this.val_1 = this.x6d().n6d(this, u_Gradientp1$factory());
  }
  yal() {
    return this.oal_1.am(this, u_ProgramType$factory_0());
  }
  zal() {
    return this.pal_1.am(this, u_Color$factory_0());
  }
  xal() {
    return this.qal_1.am(this, u_ColorMul$factory_0());
  }
  aam() {
    return this.ral_1.am(this, u_GlobalAlpha$factory_0());
  }
  wal() {
    return this.sal_1.am(this, u_GlobalPixelScale$factory_0());
  }
  bam() {
    return this.tal_1.am(this, u_Transform$factory_0());
  }
  cam() {
    return this.ual_1.am(this, u_Gradientp0$factory_0());
  }
  dam() {
    return this.val_1.am(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().lak_1 : program;
    this.hal_1 = uniforms;
    this.ial_1 = texture;
    this.jal_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.hal_1.toString() + ', texture=' + toString_0(this.ial_1) + ', program=' + this.jal_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.hal_1);
    result = imul(result, 31) + (this.ial_1 == null ? 0 : hashCode(this.ial_1)) | 0;
    result = imul(result, 31) + this.jal_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.hal_1, tmp0_other_with_cast.hal_1))
      return false;
    if (!equals(this.ial_1, tmp0_other_with_cast.ial_1))
      return false;
    if (!this.jal_1.equals(tmp0_other_with_cast.jal_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.vaj_1 = Attribute.t6e('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.waj_1 = Attribute.t6e('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.xaj_1 = Varying.f6f('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.yaj_1 = Varying.f6f('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.zaj_1 = ProgramLayout.e68([DefaultShaders_getInstance().o6b_1]);
    this.aak_1 = ProgramLayout.e68([DefaultShaders_getInstance().p6b_1]);
    this.bak_1 = ProgramLayout.e68([this.waj_1]);
    this.cak_1 = ProgramLayout.e68([DefaultShaders_getInstance().o6b_1, DefaultShaders_getInstance().p6b_1]);
    this.dak_1 = ProgramLayout.e68([DefaultShaders_getInstance().o6b_1, this.waj_1]);
    this.eak_1 = ProgramLayout.e68([DefaultShaders_getInstance().o6b_1, this.waj_1, this.vaj_1]);
    this.fak_1 = 0;
    this.gak_1 = 1;
    this.hak_1 = 2;
    this.iak_1 = 3;
    this.jak_1 = 4;
    this.kak_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.u6f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.z6f(this_0.c6g(), this_0.d6g(this_0.d6g(this_0.o6d(), this_0.p6d()), this_0.g6g([this_0.e6g(), this_0.f6g(0.0), this_0.f6g(1.0)])));
    this_0.z6f(this_0.v6f(), DefaultShaders_getInstance().o6b_1);
    this_0.z6f(GpuShapeViewPrograms_getInstance().yaj_1, GpuShapeViewPrograms_getInstance().waj_1);
    this_0.z6f(GpuShapeViewPrograms_getInstance().xaj_1, GpuShapeViewPrograms_getInstance().vaj_1);
    var tmp505_vertex = VertexShader(this_0.h6g());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.u6f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.z6h(GpuShapeViewPrograms_getInstance().yal(), this_1.f6g(5));
    var body = this_1.q6g();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.z6f(body.c6g(), body.g6g([body.f6g(1.0), body.f6g(0.0), body.f6g(0.0), body.f6g(1.0)]));
    body.i6h();
    var stmIf = new If(cond, body.s6g());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.y6f_1.f(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.c6i(this_1.o6h(GpuShapeViewPrograms_getInstance().yaj_1), GpuShapeViewPrograms_getInstance().xaj_1);
    var body_0 = this_1.q6g();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.g6h();
    var stmIf_0 = new If(cond_0, body_0.s6g());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.y6f_1.f(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().yal();
    this_1.f6h(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.x6h(this_1.f6g(1.0), this_1.q6h(this_1.x6h(this_1.d6g(GpuShapeViewPrograms_getInstance().xaj_1, GpuShapeViewPrograms_getInstance().wal()), this_1.f6g(1.5)), this_1.d6g(GpuShapeViewPrograms_getInstance().xaj_1, GpuShapeViewPrograms_getInstance().wal()), this_1.o6h(this_1.d6g(GpuShapeViewPrograms_getInstance().yaj_1, GpuShapeViewPrograms_getInstance().wal()))));
    this_1.z6f(this_1.c6g(), this_1.d6g(this_1.d6g(this_1.d6g(this_1.c6g(), GpuShapeViewPrograms_getInstance().xal()), GpuShapeViewPrograms_getInstance().aam()), aaAlpha));
    var tmp506_fragment = FragmentShader(this_1.h6g());
    tmp.lak_1 = new Program(tmp505_vertex, tmp506_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.e2h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.q67();
      this_2.x6t(_unary__edvuaz + 1 | 0);
      this_2.y6t(this_2.q67() + 1 | 0);
      var blockSize = this_2.u65_1;
      var index0 = imul(this_2.q67() - 1 | 0, blockSize);
      var index1 = imul(this_2.q67(), blockSize);
      var texBlockSize = this_2.r65_1.q6d().d1();
      var texIndex0 = imul(this_2.q67() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.q67(), texBlockSize);
      if (this_2.q67() > 0) {
        arraycopy(this_2.w65_1, index0, this_2.w65_1, index1, blockSize);
      } else {
        arrayfill(this_2.w65_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.r65_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.x65_1.d6u(ShapeViewUB_getInstance().yal(), 5);
      if (true && this_2.q67() >= 1) {
        var equals = arrayequal(this_2.w65_1, index0, this_2.w65_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.q67();
          this_2.x6t(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.mak_1 = new PaintShader(this_2, null);
  }
  yal() {
    return ShapeViewUB_getInstance().yal().k67_1;
  }
  zal() {
    return ShapeViewUB_getInstance().zal().k67_1;
  }
  xal() {
    return ShapeViewUB_getInstance().xal().k67_1;
  }
  aam() {
    return ShapeViewUB_getInstance().aam().k67_1;
  }
  wal() {
    return ShapeViewUB_getInstance().wal().k67_1;
  }
  bam() {
    return ShapeViewUB_getInstance().bam().k67_1;
  }
  cam() {
    return ShapeViewUB_getInstance().cam().k67_1;
  }
  dam() {
    return ShapeViewUB_getInstance().dam().k67_1;
  }
  eam(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_22().k70_1;
    return $this$ExpressionBuilder.m6h(_this__u8e3s4, $this$ExpressionBuilder.f6g(2.0));
  }
  nak(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.e2h();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.q67();
          this_0.x6t(_unary__edvuaz + 1 | 0);
          this_0.y6t(this_0.q67() + 1 | 0);
          var blockSize = this_0.u65_1;
          var index0 = imul(this_0.q67() - 1 | 0, blockSize);
          var index1 = imul(this_0.q67(), blockSize);
          var texBlockSize = this_0.r65_1.q6d().d1();
          var texIndex0 = imul(this_0.q67() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.q67(), texBlockSize);
          if (this_0.q67() > 0) {
            arraycopy(this_0.w65_1, index0, this_0.w65_1, index1, blockSize);
          } else {
            arrayfill(this_0.w65_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.r65_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.x65_1;
          it.d6u($this$push.yal(), 0);
          it.e6u($this$push.zal(), _RGBA___get_premultiplied__impl__3bulqc(paint.l44_1));
          it.d6u($this$push.aam(), globalAlpha);
          if (true && this_0.q67() >= 1) {
            var equals = arrayequal(this_0.w65_1, index0, this_0.w65_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.q67();
              this_0.x6t(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_29().a25_1.s26(paint.t59_1).s26(stateTransform).m26().a26(1.0 / paint.s59_1.n2d(), 1.0 / paint.s59_1.o2d());
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.e2h();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.q67();
            this_1.x6t(_unary__edvuaz_1 + 1 | 0);
            this_1.y6t(this_1.q67() + 1 | 0);
            var blockSize_0 = this_1.u65_1;
            var index0_0 = imul(this_1.q67() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.q67(), blockSize_0);
            var texBlockSize_0 = this_1.r65_1.q6d().d1();
            var texIndex0_0 = imul(this_1.q67() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.q67(), texBlockSize_0);
            if (this_1.q67() > 0) {
              arraycopy(this_1.w65_1, index0_0, this_1.w65_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.w65_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.r65_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.x65_1;
            it_0.d6u($this$push_0.yal(), 1);
            it_0.h6u($this$push_0.bam(), toMatrix4(mat));
            it_0.d6u($this$push_0.aam(), globalAlpha);
            if (true && this_1.q67() >= 1) {
              var equals_0 = arrayequal(this_1.w65_1, index0_0, this_1.w65_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.q67();
                this_1.x6t(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.s59_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.z3l(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.k3m_1;
            if (true) {
              gradientBitmap.l1o();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.e59(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.w3l_1));
            }finally {
              result = true ? gradientBitmap.u3m(rect) : 0;
            }
            var npaint = paint.f59(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_29().a25_1.s26(paint.d4t_1).s26(stateTransform));
            var mat_0 = paint.t4s_1.m3_1 === 0 ? npaint.j4t_1 : npaint.d4t_1.m26();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.e2h();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.q67();
              this_2.x6t(_unary__edvuaz_3 + 1 | 0);
              this_2.y6t(this_2.q67() + 1 | 0);
              var blockSize_1 = this_2.u65_1;
              var index0_1 = imul(this_2.q67() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.q67(), blockSize_1);
              var texBlockSize_1 = this_2.r65_1.q6d().d1();
              var texIndex0_1 = imul(this_2.q67() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.q67(), texBlockSize_1);
              if (this_2.q67() > 0) {
                arraycopy(this_2.w65_1, index0_1, this_2.w65_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.w65_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.r65_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.x65_1;
              var tmp_0 = $this$push_1.yal();
              var tmp0 = paint.t4s_1.m3_1;
              it_1.d6u(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.h6u($this$push_1.bam(), toMatrix4(mat_0));
              it_1.g6u($this$push_1.cam(), new Vector4F(paint.u4s_1, paint.v4s_1, paint.w4s_1, 1.0));
              it_1.g6u($this$push_1.dam(), new Vector4F(paint.x4s_1, paint.y4s_1, paint.z4s_1, 1.0));
              it_1.d6u($this$push_1.aam(), globalAlpha);
              if (true && this_2.q67() >= 1) {
                var equals_1 = arrayequal(this_2.w65_1, index0_1, this_2.w65_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.q67();
                  this_2.x6t(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.nd('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.w8d($this.m8c_1.v8d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.n8c_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_35() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().v1o($this.t8d_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.z8d(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.p8g(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.e1k($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_36() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.n8j_1.r8c_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.o8j_1.q8i_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_32()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_25().t2b_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.rk();
    var height = size.sk();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp0_elvis_lhs = base == null ? null : base.n2d();
      rwidth = tmp0_elvis_lhs == null ? views_0.q8i_1.n2d() : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = base == null ? null : base.o2d();
      rheight = tmp1_elvis_lhs == null ? views_0.q8i_1.o2d() : tmp1_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.r8o(views_0, defaultTransition, name, Size2D.t29(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).s8o($this.n8j_1.r8c_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.p8j_1($this.o8j_1.q8i_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.n8j_1.z8c_1) {
    var tmp_3 = $this.q8j_1.w81($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.t8o_1, $this.u8o_1, $this.v8o_1, $this.w8o_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.e1k($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_34().rq()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().k5o();
    try {
      var tmp0_elvis_lhs = $this.z8o_1.h8d_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().l3n_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.x8o_1, $this.y8o_1, $this.z8o_1.g8d_1, null, $this.z8o_1.y8c_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().k5o();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.i81(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().k5o();
    try {
      try {
        if (!($this.a8p_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().lh($this.a8p_1), $this.b8p_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.k81(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_35().x8d_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.m2q(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.n2q(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().k5o();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.i81('setIcon', tmp$ret$5);
    }
  }
  $this$loop.p81($this$loop.e7t());
  if (Companion_getInstance_34().rq()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.lc();
  var this_3 = Views.d8p(tmp$ret$6.ol(gameWindow.e81()).ol(new InjectorContext($this.z8o_1.t8c_1)).ol(SupervisorJob()), $this.z8o_1.o8d_1 ? new AGPrint() : $this$loop.d81(), $this.z8o_1.t8c_1, input, $this.z8o_1.s8c_1, stats, gameWindow, $this.z8o_1.a8d_1, $this.z8o_1.b8d_1, $this.z8o_1.c8d_1, VOID, $this.z8o_1.r8d_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.v1r($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_34().tq()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.v2q(), 'views', this_3);
  }
  var views = this_3;
  $this.z8o_1.t8c_1.q5n(getKClass(GameWindow), gameWindow);
  $this.z8o_1.t8c_1.q5n(getKClass(Korge), $this.z8o_1);
  views.t8i_1 = $this$loop.r81();
  views.e8p($this.z8o_1.p8d_1);
  views.f8p($this.z8o_1.q8d_1);
  views.k8i_1 = numberToInt($this.z8o_1.e8d_1.y22_1);
  views.l8i_1 = numberToInt($this.z8o_1.e8d_1.z22_1);
  views.o8i_1 = $this.z8o_1.f8d_1.x8g_1;
  views.n8i_1 = $this.z8o_1.f8d_1.w8g_1;
  views.p8i_1 = $this.z8o_1.f8d_1.y8g_1;
  views.e8j_1 = $this.z8o_1.s8d_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().k5o();
    try {
      KorgeReload_getInstance().f7h(gameWindow);
      var tmp_4 = KorgeRunner_instance.g8p(views, gameWindow, true, $this$loop.o81(), Companion_instance_1.c1o(), $this.z8o_1.l8d_1, $this.z8o_1.u8c_1).w10($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().k5o();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.i81(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().k5o();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().k5o();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.i81(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.z8o_1, views, $this.c8p_1, gameWindow));
  if ($this.z8o_1.z8c_1) {
    var tmp_5 = gameWindow.w81($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.u81();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.worker.Companion.init' call
    get_workerImpl().b2z();
    if (get_workerImpl().c2z()) {
      if (get_DEBUG_WORKER()) {
        println('INSIDE WORKER');
      }
      break $l$block;
    } else {
      if (get_DEBUG_WORKER()) {
        println('**NOT** INSIDE WORKER');
      }
    }
    // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
    get_nativeSoundProvider();
    get_RegisteredImageFormats().b56([config.p8c_1]);
    var iconPath = config.j8d_1;
    var imageFormats = config.p8c_1;
    var entry = config.n8d_1;
    var windowSize = config.d8d_1;
    if (!Companion_getInstance_34().tq()) {
      var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().lh('klogger.properties'), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    var tmp0_elvis_lhs = config.q8c_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      tmp_0 = $completion.lc().yc(CoroutineKey_getInstance());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.m8d_1) : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = config.h8d_1;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
      tmp_1 = Colors_getInstance().l3n_1;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    realGameWindow.n81(tmp_1);
    var tmp_3 = realGameWindow.x81(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.b7s(Vector2D.j21(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.j7m(button, true);
  input.i7m(p, false);
  input.i7m(p, true);
  $views.h8p();
  downPos._v = input.h7m();
  downTime._v = new DateTime(Companion_getInstance_4().w1n());
  input.t7l_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.j7m(button, false);
  input.i7m(p, false);
  $views.h8p();
  upPos._v = $views.h8h_1.h7m();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.h8h_1.i7m(p, false);
  $views.h8h_1.t7l_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.h8p();
  moveTime._v = new DateTime(Companion_getInstance_4().w1n());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.h8h_1.i7m(p, false);
  $views.h8p();
  moveTime._v = new DateTime(Companion_getInstance_4().w1n());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.m5u_1 = 0;
  mouseTouchEvent.p5u_1 = true;
  mouseTouchEvent.n5u_1 = Companion_getInstance_4().w1n();
  mouseTouchEvent.o5u_1 = false;
  mouseTouchEvent.x5u(type);
  mouseTouchEvent.c5v(button.d5y_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.y5u();
  $views.x5q(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.x5v_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.d7m_1[gamepad.y5v_1].g5w(gamepad);
  }
  input.k7m();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.j8p($fixedSizeStep, $views.i8p(), event.l5r_1, event.m5r_1);
    $views.h8h_1.s7l_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.h8h_1.s7l_1 = true;
      $views.h8h_1.t7l_1 = false;
      $views.h8p();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_35().x8d_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.m2q(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.n2q(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.s8h_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.k8p($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_35().x8d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.u5s_1, e.v5s_1, e.f5t_1);
    var tmp_0;
    switch (e.s5s_1.m3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.w5s_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.w5s_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.w5s_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.w5s_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.w5s_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_35().x8d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_35().x8d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.x5q(e);
    get_nativeSoundProvider().v2n(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.x5q(e);
    get_nativeSoundProvider().v2n(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.x5q(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_35().x8d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.g7m(e);
    var ee = $input.l7l_1;
    var _iterator__ex2g4s = ee.u5u().z();
    while (_iterator__ex2g4s.a1()) {
      var t = _iterator__ex2g4s.b1();
      t.b5u_1 = prepareViewsBase$getRealXY($views, t.m4y(), t.n4y(), e.o5u_1);
    }
    $views.x5q(ee);
    var tmp_0;
    if (ee.v5u() === 1) {
      var start = ee.f5v();
      var end = ee.g5v();
      var t_0 = first(ee.u5u());
      var p = t_0.b5u_1;
      var x = t_0.m4y();
      var y = t_0.n4y();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.t5s_1 = 0;
      this_1.w5s_1 = button;
      this_1.x5s_1 = end ? 0 : 1 << button.d5y_1;
      this_1.u5s_1 = numberToInt(x);
      this_1.v5s_1 = numberToInt(y);
      this_1.f5t_1 = false;
      this_1.g5t_1 = true;
      this_1.s5s_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.x5q(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_35().x8d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.x5q(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.m8p($ag.z5y().s5y_1, $ag.z5y().t5y_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.x5q(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.m5r_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.d8i_1;
      var frameBuffer = this_0.z5y();
      this_0.j7i_1.e2h();
      this_0.c7i_1.d5z();
      var tmp_0;
      try {
        this_0.t7t(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.n14(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.u7t();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.c7i_1.y5u();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_35().y8d_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_5().f7p_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().r7m_1.y22_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().r7m_1.z22_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.a23(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.y22_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.z22_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.a23(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_23().o2b_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_24().e21() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().l3n_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().k3n_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, Unit_instance)).u8g(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.z8d(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.p8g(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.z8d(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
var simpleAnimator$delegate;
function _get_totalTime__xgts5c($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.y8p_1;
  totalTime$factory();
  return this_0.t1().e1o_1;
}
function Animator$TweenNode$computedVs$delegate$lambda(this$0) {
  return function () {
    var tmp22_safe_receiver = this$0.s8p_1;
    var tmp;
    if (tmp22_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp22_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp22_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp22_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.TweenNode.computedVs$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item();
        destination.f(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp0_elvis_lhs = tmp;
    return toMutableList(tmp0_elvis_lhs == null ? toList(this$0.r8p_1) : tmp0_elvis_lhs);
  };
}
function Animator$TweenNode$totalTime$delegate$lambda(this$0) {
  return function () {
    var tmp23_safe_receiver = this$0.u8p_1;
    var tmp;
    if (tmp23_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = tmp23_safe_receiver();
      tmp = tmp_0 == null ? null : tmp_0.e1o_1;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new FastDuration(tmp_2)) == null) {
      tmp_1 = this$0.t8p_1;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    return new FastDuration(tmp_1);
  };
}
var Companion_instance_16;
function Companion_getInstance_37() {
  if (Companion_instance_16 === VOID)
    new Companion_1();
  return Companion_instance_16;
}
function ensure($this) {
  if (!($this.k8q_1 == null))
    return ensure($this.k8q_1);
  if (!($this.v8q().r8q_1 == null))
    return Unit_instance;
  var tmp = $this.v8q();
  var tmp_0 = $this.v8q().n8q_1;
  tmp.r8q_1 = addFastUpdater($this.e8q_1, tmp_0, VOID, Animator$ensure$lambda($this));
}
function ensureInit($this) {
  var tmp0_elvis_lhs = $this.l8q_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var linit = tmp;
  $this.l8q_1 = null;
  linit($this);
}
function Animator$removeProps$lambda($props) {
  return function (it) {
    return !$props.w2(it.q7w_1);
  };
}
function Animator$ensure$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var tmp;
    if (this$0.s8q_1) {
      this$0.e8q_1.f8r();
      tmp = Unit_instance;
    }
    var tmp_0;
    if (FastDuration__compareTo_impl_4fhnj7(this$0.u8q_1.z8q(dt.e1o_1), Companion_instance_1.b1o()) >= 0) {
      if (this$0.j8q_1) {
        invoke(this$0.o8q_1);
      } else {
        this$0.g8r();
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function animator(_this__u8e3s4, defaultTime, defaultSpeed, defaultEasing, parallel, looped, startImmediately, block) {
  defaultTime = defaultTime === VOID ? Companion_getInstance_37().a8q_1 : defaultTime;
  defaultSpeed = defaultSpeed === VOID ? Companion_getInstance_37().b8q_1 : defaultSpeed;
  defaultEasing = defaultEasing === VOID ? Companion_getInstance_37().c8q_1 : defaultEasing;
  parallel = parallel === VOID ? false : parallel;
  looped = looped === VOID ? false : looped;
  startImmediately = startImmediately === VOID ? Companion_getInstance_37().d8q_1 : startImmediately;
  var tmp;
  if (block === VOID) {
    tmp = animator$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.apply' call
  var tmp2_fastDefaultTime = get_fast(defaultTime);
  var this_0 = new Animator(_this__u8e3s4, tmp2_fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, null, VOID, 0, startImmediately);
  // Inline function 'kotlin.contracts.contract' call
  block(this_0);
  return this_0;
}
function block(_this__u8e3s4, name, callback) {
  name = name === VOID ? null : name;
  _init_properties_Animator_kt__gicf47();
  _this__u8e3s4.j8r(new BlockNode(name, callback));
}
function show(_this__u8e3s4, view, time, easing) {
  time = time === VOID ? _this__u8e3s4.h8r() : time;
  easing = easing === VOID ? _this__u8e3s4.h8q_1 : easing;
  _init_properties_Animator_kt__gicf47();
  return alpha(_this__u8e3s4, view, 1.0, time, easing);
}
function moveBy(_this__u8e3s4, view, x, y, time, easing) {
  x = x === VOID ? 0.0 : x;
  y = y === VOID ? 0.0 : y;
  time = time === VOID ? _this__u8e3s4.h8r() : time;
  easing = easing === VOID ? _this__u8e3s4.h8q_1 : easing;
  _init_properties_Animator_kt__gicf47();
  return _this__u8e3s4.l8r([incr(x$factory(view), x), incr(y$factory(view), y)], VOID, get_fast(time), VOID, easing, 'moveBy');
}
function hide(_this__u8e3s4, view, time, easing) {
  time = time === VOID ? _this__u8e3s4.h8r() : time;
  easing = easing === VOID ? _this__u8e3s4.h8q_1 : easing;
  _init_properties_Animator_kt__gicf47();
  return alpha(_this__u8e3s4, view, 0.0, time, easing);
}
function alpha(_this__u8e3s4, view, alpha, time, easing) {
  time = time === VOID ? _this__u8e3s4.h8r() : time;
  easing = easing === VOID ? _this__u8e3s4.h8q_1 : easing;
  _init_properties_Animator_kt__gicf47();
  return alpha_0(_this__u8e3s4, view, alpha, time, easing);
}
function alpha_0(_this__u8e3s4, view, alpha, time, easing) {
  time = time === VOID ? _this__u8e3s4.h8r() : time;
  easing = easing === VOID ? _this__u8e3s4.h8q_1 : easing;
  _init_properties_Animator_kt__gicf47();
  // Inline function 'korlibs.korge.tween.get' call
  var this_0 = alphaF$factory(view);
  var tmp = this_0.get();
  var tmp$ret$0 = new V2(this_0, tmp, alpha, _interpolateFloat$ref(), false);
  return _this__u8e3s4.l8r([tmp$ret$0], VOID, get_fast(time), VOID, easing, 'alpha');
}
function simpleAnimator$delegate$lambda($this$PropertyThis) {
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.also' call
  var this_0 = animator($this$PropertyThis, VOID, VOID, VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.animate.simpleAnimator$delegate.<anonymous>.<anonymous>' call
  this_0.s8q_1 = true;
  return this_0;
}
function animator$lambda(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  return Unit_instance;
}
function _interpolateFloat$ref() {
  var l = function (p0, p1, p2) {
    return _interpolateFloat(p0.rt_1, p1, p2);
  };
  l.callableName = '_interpolateFloat';
  return l;
}
function computedVs$factory() {
  return getPropertyCallableRef('computedVs', 1, KProperty1, function (receiver) {
    return receiver.a8r();
  }, null);
}
function totalTime$factory() {
  return getPropertyCallableRef('totalTime', 1, KProperty1, function (receiver) {
    return new FastDuration(_get_totalTime__xgts5c(receiver));
  }, null);
}
function x$factory($b0) {
  return getPropertyCallableRef('x', 0, KMutableProperty0, function () {
    return $b0.m4y();
  }, function (value) {
    return $b0.m8r(value);
  });
}
function y$factory($b0) {
  return getPropertyCallableRef('y', 0, KMutableProperty0, function () {
    return $b0.n4y();
  }, function (value) {
    return $b0.n8r(value);
  });
}
function alphaF$factory($b0) {
  return getPropertyCallableRef('alphaF', 0, KMutableProperty0, function () {
    return $b0.o8r();
  }, function (value) {
    return $b0.p8r(value);
  });
}
var properties_initialized_Animator_kt_opr5o7;
function _init_properties_Animator_kt__gicf47() {
  if (!properties_initialized_Animator_kt_opr5o7) {
    properties_initialized_Animator_kt_opr5o7 = true;
    simpleAnimator$delegate = new PropertyThis(VOID, simpleAnimator$delegate$lambda);
  }
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.xw_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.yw_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.xw_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  var tmp = $this.q8r_1(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  if (it.d5s_1.equals($this.r8r_1)) {
    var tmp = $this.s8r_1(it, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.z8r_1.x8r_1.s1p($this.a8s_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.b8s_1.v8r_1.s1p($this.c8s_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.d8s_1.w8r_1.s1p($this.e8s_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$down$slambda_1($callback) {
  var i = new KeysEvents$down$slambda($callback);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$down$slambda_2($key, $callback) {
  var i = new KeysEvents$down$slambda_0($key, $callback);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.e5r_1;
    tmp.u8r_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.g8s().e8h_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.e5r_1;
    tmp.u8r_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.g8s().e8h_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.e5r_1;
    tmp.u8r_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.g8s().e8h_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.vw_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.uw();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.vw_1;
      tmp_0 = tmp0_safe_receiver.b3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.ww_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.vw_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.vw_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.d7i_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.t8s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.fy());
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.u8s().e8h_1.ol(new InjectorContext(this$0.v8s())).ol(Job(this$0.u8s().e8h_1.yc(Key_instance)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.x8s(this$0.w8s().d1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.o8s_1.g8v(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.v8s().z5n(getKClass(Resources));
  };
}
function onSizeChanged($this, sceneView, size_0) {
  var width = size_0.rk();
  var height = size_0.sk();
  var out = place(new Rectangle(0.0, 0.0, width, height), Size2D.a23($this.d8z(), $this.e8z()), $this.b8z_1, $this.a8z_1);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.size' call
  var width_0 = $this.d8z();
  var height_0 = $this.e8z();
  var tmp$ret$0 = size(sceneView, numberToDouble(width_0), numberToDouble(height_0));
  var this_0 = scale(xy_0(tmp$ret$0, out.d22_1, out.e22_1), out.f22_1 / $this.d8z(), out.g22_1 / $this.e8z());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.ScaledScene.onSizeChanged.<anonymous>' call
  set_filter(this_0, $this.c8z_1 ? Linear_getInstance() : Nearest_getInstance());
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.fy();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.j8v();
  }, null);
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var scene = $this.f8z_1.o8o_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.f8z_1.o8o_1) + ' . doFullReload=' + $this.g8z_1.n8z());
    var tmp;
    if ($this.g8z_1.n8z()) {
      tmp = $this.g8z_1.o8z(getKClassFromExpression(scene), scene.v8s());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.f8z_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.m8o_1;
    var sceneInjector = this_0.l8o_1.g8h_1.s5n().q5n(getKClass(SceneContainer), this_0).q5n(getKClass(Resources), new Resources(this_0.fy(), this_0.l8o_1.n8p().a2x_1, this_0.l8o_1.n8p()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.q5n(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.z5n(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.g8z_1.z7g(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_38().p8z_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.m2q(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.n2q(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.b5o(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.l8o_1.g8h_1.u5n(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.g8z_1, scene));
    }
    var tmp_5 = this_0.r8z(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.u8s().s8z(scene_0.j8v());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.z5n($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.z7g($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.t8z_1.j8v();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.t8z_1.w8x(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.u8z_1.j8v();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.u8z_1.x8x(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = $this.v8z_1.z8x($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.w8z_1.a8y($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.w8z_1.b8y($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = $this.x8z_1.c8y($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.y8z_1.y8x($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.l8o_1.g8h_1.s5n().q5n(getKClass(SceneContainer), $this).q5n(getKClass(Resources), new Resources($this.fy(), $this.l8o_1.n8p().a2x_1, $this.l8o_1.n8p()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.q5n(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.z5n(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_38().p8z_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.m2q(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.n2q(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.b5o(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.l8o_1.g8h_1.u5n(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.r8z(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.o8o_1;
  $this.o8o_1 = newScene;
  $this.n8o_1.k92(newScene.o8s_1, transition);
  try {
    var tmp = newScene.fy();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.fy();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.n8o_1);
    var initial = Companion_getInstance_33().st_1;
    var end = Companion_getInstance_33().vt_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.n8o_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.n8o_1.h92_1 = Companion_getInstance_33().vt_1;
  }
  $this.n8o_1.l92();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.fy();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.fy();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_17;
function Companion_getInstance_38() {
  if (Companion_instance_17 === VOID)
    new Companion_2();
  return Companion_instance_17;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).f1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.o8o_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.z5n($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.rt_1, p1.rt_1, p2.rt_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.h92_1);
  }, function (value) {
    $b0.h92_1 = value.rt_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.j92_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.o8r();
  var nextAlpha = next.o8r();
  try {
    prev.p8r(1.0 - Ratio__toFloat_impl_1ftup5(ratio.rt_1));
    next.p8r(Ratio__toFloat_impl_1ftup5(ratio.rt_1));
    prev.p95(ctx);
    next.p95(ctx);
  }finally {
    prev.p8r(prevAlpha);
    next.p8r(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.am(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.h6h($this$FUNC.m71($this$FUNC.l71(a, b), $this$FUNC.l71($this$FUNC.m71(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.z6f($this$IF_ELSE_BINARY_LOOKUP.c6g(), $this$IF_ELSE_BINARY_LOOKUP.k6g(Companion_getInstance_5().d7p_1[n], $this$IF_ELSE_BINARY_LOOKUP.i6g($$this$buildShader.v6f(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_timers(_this__u8e3s4) {
  _init_properties_TimerComponents_kt__j84oeh();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = timers$delegate;
    var property = timers$factory();
    var tmp0_elvis_lhs = this_0.xw_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.yw_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.xw_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var timers$delegate;
function ensureUpdater($this) {
  if (!($this.l9c_1 == null))
    return Unit_instance;
  var tmp = $this;
  tmp.l9c_1 = addFastUpdater_0($this.h9c_1, TimerComponents$ensureUpdater$lambda($this));
}
function addTimer($this, autoRemove, callback) {
  if ($this.k9c_1.z23()) {
    var index = $this.k9c_1.f3($this.k9c_1.d1() - 1 | 0);
    $this.i9c_1.e3(index, callback);
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = autoRemove ? 1 : 0;
    $this.j9c_1.h2f(index, tmp$ret$0);
    ensureUpdater($this);
    return _TimerRef___init__impl__cysrar(index);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  $this.i9c_1.f(callback);
  // Inline function 'korlibs.math.toInt' call
  var tmp$ret$1 = autoRemove ? 1 : 0;
  $this.j9c_1.c2f(tmp$ret$1);
  ensureUpdater($this);
  return _TimerRef___init__impl__cysrar($this.i9c_1.d1() - 1 | 0);
}
function removeTimer($this, ref) {
  $this.i9c_1.e3(_TimerRef___get_index__impl__pnrx4q(ref), null);
  $this.j9c_1.h2f(_TimerRef___get_index__impl__pnrx4q(ref), 0);
  $this.k9c_1.c2f(_TimerRef___get_index__impl__pnrx4q(ref));
}
function _interval($this, time, repeat, callback) {
  var elapsed = {_v: new FastDuration(get_fastMilliseconds_0(0))};
  var ref = {_v: new TimerRef(_TimerRef___init__impl__cysrar(-1))};
  ref._v = new TimerRef(addTimer($this, false, TimerComponents$_interval$lambda(elapsed, time, repeat, $this, ref, callback)));
  return Closeable(TimerComponents$_interval$lambda_0($this, ref));
}
function TimerComponents$ensureUpdater$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var this_0 = this$0.i9c_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.time.TimerComponents.ensureUpdater.<anonymous>.<anonymous>' call
      var index = n;
      var tmp108_safe_receiver = this_0.c1(n);
      if (tmp108_safe_receiver == null)
        null;
      else
        tmp108_safe_receiver(dt);
      if (!(this$0.j9c_1.c1(index) === 0)) {
        removeTimer(this$0, _TimerRef___init__impl__cysrar(index));
      }
      n = n + 1 | 0;
    }
    var tmp;
    if (this$0.i9c_1.f1()) {
      var tmp109_safe_receiver = this$0.l9c_1;
      if (tmp109_safe_receiver == null)
        null;
      else {
        tmp109_safe_receiver.z5();
      }
      this$0.l9c_1 = null;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TimerComponents$wait$lambda($c) {
  return function () {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda($elapsed, $time, $repeat, this$0, $ref, $callback) {
  return function (dt) {
    $elapsed._v = new FastDuration(FastDuration__plus_impl_q1enab($elapsed._v.e1o_1, dt.e1o_1));
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7($elapsed._v.e1o_1, $time) >= 0) {
      if (!$repeat) {
        removeTimer(this$0, $ref._v.m9c_1);
      }
      $elapsed._v = new FastDuration(FastDuration__minus_impl_evs237($elapsed._v.e1o_1, $time));
      $callback();
      if (!$repeat)
        break $l$loop;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda_0(this$0, $ref) {
  return function () {
    removeTimer(this$0, $ref._v.m9c_1);
    return Unit_instance;
  };
}
function _TimerRef___init__impl__cysrar(index) {
  return index;
}
function _TimerRef___get_index__impl__pnrx4q($this) {
  return $this;
}
function TimerRef__toString_impl_8hh2j7($this) {
  return 'TimerRef(index=' + $this + ')';
}
function TimerRef__hashCode_impl_d9ou9o($this) {
  return $this;
}
function TimerRef__equals_impl_2fvpr4($this, other) {
  if (!(other instanceof TimerRef))
    return false;
  if (!($this === (other instanceof TimerRef ? other.m9c_1 : THROW_CCE())))
    return false;
  return true;
}
function interval(_this__u8e3s4, time, callback) {
  _init_properties_TimerComponents_kt__j84oeh();
  return get_timers(_this__u8e3s4).q9c(time, callback);
}
function delay(_this__u8e3s4, time, $completion) {
  return get_timers(_this__u8e3s4).n9c(time, $completion);
}
function timers$delegate$lambda($this$PropertyThis) {
  _init_properties_TimerComponents_kt__j84oeh();
  return new TimerComponents($this$PropertyThis);
}
function timers$factory() {
  return getPropertyCallableRef('timers', 1, KProperty1, function (receiver) {
    return get_timers(receiver);
  }, null);
}
var properties_initialized_TimerComponents_kt_v7ywzv;
function _init_properties_TimerComponents_kt__j84oeh() {
  if (!properties_initialized_TimerComponents_kt_v7ywzv) {
    properties_initialized_TimerComponents_kt_v7ywzv = true;
    timers$delegate = new PropertyThis('__ViewTimerComponents', timers$delegate$lambda);
  }
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.c1o() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds_0(300));
      } else {
        tmp_0 = Companion_instance_1.c1o();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp113_safe_receiver = tc._v;
        if (tmp113_safe_receiver == null)
          null;
        else {
          tmp113_safe_receiver.g9d(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.c1o() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion), $completion);
}
function _update($this, dt) {
  if ($this.z9c_1) {
    $this.s9c_1.f8r();
  }
  if ($this.c9d_1) {
    return $this.l9d();
  }
  $this.a9d_1 = FastDuration__plus_impl_q1enab($this.a9d_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.a9d_1, $this.b9d_1), 0.0, 1.0);
  $this.g9d($this.a9d_1);
  $this.w9c_1($this.v9c_1.lt(ratio));
  var tmp;
  var tmp_0 = $this.m9d();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7_0($this.a9d_1, $this.m9d()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.n9d();
  }
  if (ratio >= 1.0) {
    return $this.l9d();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.k83_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.c9d_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.c1o()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.lc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0(time, block, $completion), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.v12();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.o9d_1;
  $this.p9d_1._v = new TweenComponent(view, toList($this.q9d_1), $this.r9d_1, $this.s9d_1, $this.t9d_1, cancellable, $this.u9d_1, $this.v9d_1);
  var tmp$ret$0 = cancellable.h10();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.e1k($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_32());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.h95_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.h9a();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.h95_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_18;
function Companion_getInstance_39() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.s9g(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  if ($this.f9j_1.f1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.f9j_1;
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.c1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp214_safe_receiver = $this.k9j_1;
      var tmp215_safe_receiver = tmp214_safe_receiver == null ? null : tmp214_safe_receiver.v7i_1;
      if (tmp215_safe_receiver == null)
        null;
      else {
        tmp215_safe_receiver.r7o(it, 'BaseGraphics');
      }
    }
  }
  $this.f9j_1.j3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.p54().n2d();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.p54().o2d();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.d22_1 - $this.e99(), bounds.e22_1 - $this.f99(), bounds.f22_1, bounds.g22_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.o9j_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.j9j_1) {
    $this.j9j_1 = false;
    $this.q9j_1 = $this.z9l(false);
    $this.p9j_1 = $this.z9l(true);
  }
  return strokes ? $this.p9j_1 : $this.q9j_1;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.w5i();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.g8v(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.r9x();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.v98(this_0);
  return this_0;
}
var Companion_instance_19;
function Companion_getInstance_40() {
  return Companion_instance_19;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().m5o())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.u8s().c8j_1;
  tmp.h1p(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.u8s().d8i_1).h7s_1;
  tmp_0.h1p(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.u8s().d8i_1.a7j_1.i7k_1;
  tmp_1.h1p(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.u8s().d8i_1.a7j_1.j7k_1;
  tmp_2.h1p(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.u8s();
  tmp_3.u9x(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.p7s_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.y7p() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp239_font = $this_addDebugRenderer.c9y();
  var tmp240_colMul = $ctx.z7i_1;
  var tmp241_blendMode = Companion_getInstance_13().r7h_1;
  drawText($ctx, tmp239_font, fontSize, text, x, y, matrix, tmp240_colMul, tmp241_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.g7t();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().m5o();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.e1o_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, get_fastMilliseconds_0(4)) > 0) {
        $longWindow.b9y(elapsedTime);
        $shortWindow.b9y(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.r8h_1.m7r();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.z9x(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_34().qq() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.d8i_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.g7s_1;
    if (!(this_2.e7j_1 === this_1)) {
      this_2.e7j_1 = this_1;
      this_2.o7k();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.s7s_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().r7h_1;
          var doUpdate = !(this_1.r7s_1 === blending);
          var old = this_1.r7s_1;
          try {
            if (doUpdate) {
              this_1.g7s_1.o7k();
              this_1.r7s_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().a3t_1;
            var oldColor = this_1.j7s_1;
            this_1.j7s_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.x7s(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.x7s(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.j7s_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().k3n_1 : Colors_getInstance().l3n_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.j7s_1;
                this_1.j7s_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.d1() / $longWindow.v9x_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.d1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange_0(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.d1(), 1));
                        var p1 = convertRange_0(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.d1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds_0(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.d1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.a9y(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.a9y(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.x7s(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.j7s_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.g7s_1.o7k();
            }
            this_1.r7s_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.s7s_1;
  }, function (value) {
    $b0.s7s_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.la0_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.ma0_1 : tmp0_elvis_lhs);
}
function ensure_0($this) {
  if ($this.sa0_1.m3_1 === 2) {
    if (!($this.la0_1 == null)) {
      var tmp260_safe_receiver = $this.la0_1;
      if (tmp260_safe_receiver == null)
        null;
      else {
        tmp260_safe_receiver.z9a();
      }
      $this.la0_1 = null;
    }
    if ($this.ma0_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.sa3(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).w4b();
      this_0.ta3(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.ua3($this.na0_1);
      this_1.ta2_1 = $this.qa0_1;
      this_1.va2_1 = $this.pa0_1;
      this_1.ta3($this.ra0_1);
      tmp.ma0_1 = this_1;
    }
  } else {
    if (!($this.ma0_1 == null)) {
      var tmp261_safe_receiver = $this.ma0_1;
      if (tmp261_safe_receiver == null)
        null;
      else {
        tmp261_safe_receiver.z9a();
      }
      $this.ma0_1 = null;
    }
    if ($this.la0_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.p9v(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).w4b();
      this_2.q9v(tmp$ret$9);
      if (false) {
        this_2.l9m();
      }
      this_2.j9j_1 = true;
      this_2.q9a();
      this_2.l9m();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.j9v_1 = $this.na0_1;
      this_2.b9j_1 = $this.qa0_1;
      this_2.q9o_1 = $this.pa0_1;
      this_2.q9v($this.ra0_1);
      tmp_0.la0_1 = this_2;
    }
    var tmp262_safe_receiver = $this.la0_1;
    if (tmp262_safe_receiver == null)
      null;
    else {
      tmp262_safe_receiver.j9m($this.sa0_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.ia6_1.ma6(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.ma6($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.lh('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.n9m(tmp_0);
    $this.p99(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.n9m(tmp$ret$0);
      $this.p99(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.y9l_1.xx();
  if (!(source == null)) {
    $this.x9l_1 = true;
    $this.c9p(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.sa6();
  }, function (value) {
    return $b0.ra6(value);
  });
}
var Companion_instance_20;
function Companion_getInstance_41() {
  return Companion_instance_20;
}
var Companion_instance_21;
function Companion_getInstance_42() {
  return Companion_instance_21;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.p8i_1;
  }, function (value) {
    $b0.p8i_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.ja9();
  }, function (value) {
    return $b0.ka9(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.w5i();
  }, function (receiver, value) {
    return receiver.ia9(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.w5i();
  }, function (receiver, value) {
    return receiver.ia9(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.o95();
  }, function (receiver, value) {
    return receiver.n95(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.o95();
  }, function (receiver, value) {
    return receiver.n95(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.w45()) {
    case 'msdf':
      return MsdfRender_getInstance().b9c_1;
    case 'psdf':
      return MsdfRender_getInstance().e9c_1;
    case 'sdf':
      return MsdfRender_getInstance().e9c_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.la9_1.jad(ensureNotNull(get_views($this.ma9_1)).b8i_1, $this.na9_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_22;
function Companion_getInstance_43() {
  return Companion_instance_22;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.mad();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.aac_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.nad(sourceFile);
  $this.nac_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.lh('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.oad(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.rk();
  var y = pos.sk();
  if ($this.sac_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.kac_1.m4e_1, $this.rac_1.f22_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.kac_1.n4e_1, $this.rac_1.g22_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.lac_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.fac_1;
  }, function (value) {
    return $b0.rad(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.qac_1;
  }, function (value) {
    return $b0.nad(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.u45();
  }, function (receiver, value) {
    return receiver.sad(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.u45();
  }, function (receiver, value) {
    return receiver.sad(value);
  });
}
var Companion_instance_23;
function Companion_getInstance_44() {
  return Companion_instance_23;
}
function updateRenderColorTransform($this) {
  $this.d8l_1 = $this.i8l_1;
  $this.k8l_1 = true;
  var parent = $this.m1s();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.c8l_1.g44($this.b8l_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.c8l_1.h44($this.b8l_1, parent.m9a());
    } else {
      $this.c8l_1.g44($this.b8l_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.d8l_1 === $this.i8l_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.f8l_1 = $this.h8l_1;
  $this.j8l_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.h8k_1.equals(Companion_getInstance_13().i7h_1)) {
    var tmp353_safe_receiver = $this.m1s();
    var tmp0_elvis_lhs = tmp353_safe_receiver == null ? null : tmp353_safe_receiver.n9a();
    tmp_0 = tmp0_elvis_lhs == null ? Companion_getInstance_13().h7h_1 : tmp0_elvis_lhs;
  } else {
    tmp_0 = $this.h8k_1;
  }
  tmp.e8l_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.f8l_1 === $this.h8l_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function View$addRenderPhase$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
  var tmp = a.wad();
  // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
  var tmp$ret$1 = b.wad();
  return compareValues(tmp, tmp$ret$1);
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.b1o() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.m5q(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp380_safe_receiver = _this__u8e3s4.m1s();
    var tmp0_elvis_lhs = tmp380_safe_receiver == null ? null : hasAncestor(tmp380_safe_receiver, ancestor);
    tmp = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.v99(Scale.j29(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.j21(x, y));
}
function size(_this__u8e3s4, width, height) {
  return size_0(_this__u8e3s4, Size2D.t29(width, height));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.p1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.f(_this__u8e3s4);
    }
    if (_this__u8e3s4.v8j_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp337_safe_receiver = _this__u8e3s4.l98();
      var tmp_0;
      if (tmp337_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp337_safe_receiver.d1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp337_safe_receiver.c1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.m1s();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.m1s();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.m1s();
  }
  return count;
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.f4h(p);
  return _this__u8e3s4;
}
function size_0(_this__u8e3s4, size) {
  _this__u8e3s4.b9a(size);
  return _this__u8e3s4;
}
function xy_0(_this__u8e3s4, x, y) {
  _this__u8e3s4.n99(x, y);
  return _this__u8e3s4;
}
function alpha_1(_this__u8e3s4, alpha) {
  _this__u8e3s4.p8r(alpha);
  return _this__u8e3s4;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.k83_1, $this_addFastUpdater.m99())));
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.q99();
  }, function (value) {
    return $b0.p99(value);
  });
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.s7s_1;
  }, function (value) {
    $b0.s7s_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  var tmp = $this.bae_1.va6(ensureNotNull(get_views($this.cae_1)), VOID, $this.dae_1.la6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_19($this, $completion) {
  var tmp = $this.fae_1.gae($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.z8h_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().g7h();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.m8i_1;
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.c1(_unary__edvuaz).q1i($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.m8i_1.j3();
  cancel($this.e8h_1);
  $this.k8h_1.v81();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.p8g(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.m8h_1 == null) ? ensureNotNull(this$0.m8h_1) : StandardPaths_instance.c2s(this$0.hae());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.lx();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.d8i_1.q7o();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.d8i_1.p7t();
    return Unit_instance;
  };
}
var Companion_instance_24;
function Companion_getInstance_45() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_46() {
  return Companion_instance_25;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.v8h_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.k83_1 = delta;
  _this__u8e3s4.x5q(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.w8h_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.eaf_1 = delta;
  _this__u8e3s4.x5q(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_23().r2b() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_24().e21() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.s2m(reqVirtualSize_0);
  targetSize.s2m(scaleMode.s2b(virtualSize.t1(), actualSize_0));
  var ratioX = targetSize.t1().x2b_1 / reqVirtualSize_0.x2b_1;
  var ratioY = targetSize.t1().y2b_1 / reqVirtualSize_0.y2b_1;
  var actualVirtualWidth = toIntRound(actualSize_0.x2b_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.y2b_1 / ratioY);
  _this__u8e3s4.p7r(Companion_getInstance_29().a25_1.c26(ratioX, ratioY).k26(toIntRound((actualVirtualWidth - reqVirtualSize_0.x2b_1 | 0) * anchor.b21_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.y2b_1 | 0) * anchor.c21_1)));
  _this__u8e3s4.l7r(_this__u8e3s4.q7r().m26());
  _this__u8e3s4.r7r(_this__u8e3s4.q7r().n26());
  _this__u8e3s4.n7r(_this__u8e3s4.m7r().n26());
  var tl = _this__u8e3s4.b7s(Vector2D.l24(0, 0));
  var br = _this__u8e3s4.b7s(Vector2D.j21(actualSize_0.x2b_1, actualSize_0.y2b_1));
  _this__u8e3s4.t7r(Companion_getInstance_27().q29(tl.h21_1, tl.i21_1, br.h21_1, br.i21_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.z5n(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006($completion), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.e7t();
  }, function (value) {
    return $b0.p81(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.z81();
  }, function (value) {
    return $b0.y81(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.y7i_1;
  }, function (value) {
    $b0.y7i_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.z7i_1);
  }, function (value) {
    $b0.z7i_1 = value.l44_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.r7z_1;
  }, function (value) {
    $b0.r7z_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.i8p();
  }, function (receiver, value) {
    return receiver.o8p(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.i8p();
  }, function (receiver, value) {
    return receiver.o8p(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.mae();
  }, function (receiver, value) {
    return receiver.e8p(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.mae();
  }, function (receiver, value) {
    return receiver.e8p(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.nae());
  }, function (receiver, value) {
    return receiver.f8p(value.l44_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.nae());
  }, function (receiver, value) {
    return receiver.f8p(value.l44_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.z8i_1;
  }, function (value) {
    $b0.z8i_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.b8j_1;
  }, function (value) {
    $b0.b8j_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.tae();
  }, function (receiver, value) {
    return receiver.aaf(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.tae();
  }, function (receiver, value) {
    return receiver.aaf(value);
  });
}
function centerOnStage(_this__u8e3s4) {
  return centerYOnStage(centerXOnStage(_this__u8e3s4));
}
function centerYOnStage(_this__u8e3s4) {
  return centerYOn(_this__u8e3s4, _this__u8e3s4.g1s());
}
function centerXOnStage(_this__u8e3s4) {
  return centerXOn(_this__u8e3s4, _this__u8e3s4.g1s());
}
function centerYOn(_this__u8e3s4, other) {
  return alignY(_this__u8e3s4, other, 0.5, true);
}
function centerXOn(_this__u8e3s4, other) {
  return alignX(_this__u8e3s4, other, 0.5, true);
}
function alignY(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, false, padding);
}
function alignX(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, true, padding);
}
function alignXY(_this__u8e3s4, other, ratio, inside, doX, padding) {
  padding = padding === VOID ? 0.0 : padding;
  var bounds = other.k9b(_this__u8e3s4.m1s());
  var localBounds = _this__u8e3s4.p9b();
  var ratioM1_1 = ratio * 2 - 1;
  var rratioM1_1 = inside ? ratioM1_1 : -ratioM1_1;
  var iratio = inside ? ratio : 1.0 - ratio;
  if (doX) {
    _this__u8e3s4.m8r(bounds.d22_1 + bounds.f22_1 * ratio - localBounds.k22() - _this__u8e3s4.e9a() * iratio - padding * rratioM1_1);
  } else {
    _this__u8e3s4.n8r(bounds.e22_1 + bounds.g22_1 * ratio - localBounds.m22() - _this__u8e3s4.f9a() * iratio - padding * rratioM1_1);
  }
  return _this__u8e3s4;
}
var renderToTextureResultPool$delegate;
var Companion_instance_26;
function Companion_getInstance_47() {
  if (Companion_instance_26 === VOID)
    new Companion_11();
  return Companion_instance_26;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.k2a(getBorder(_this__u8e3s4, toIntCeil(inp.f22_1), toIntCeil(inp.g22_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.iaf(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.k2l(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.p11();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_27;
function Companion_getInstance_48() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
var Linear_instance;
function Linear_getInstance() {
  if (Linear_instance === VOID)
    new Linear();
  return Linear_instance;
}
var Nearest_instance;
function Nearest_getInstance() {
  if (Nearest_instance === VOID)
    new Nearest();
  return Nearest_instance;
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp357_safe_receiver = _this__u8e3s4.n8l_1;
  var tmp;
  if (tmp357_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp357_safe_receiver.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp452_safe_receiver = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp452_safe_receiver == null ? null : tmp452_safe_receiver.waf_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.zw_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.xw_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.xw_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.yw_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.xw_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.p9b(VOID, false);
  if (bounds.f22_1 <= 0.0 || bounds.g22_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_47();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.haf();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.gaf(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.f22_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.g22_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.f22_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.d22_1 + edgeSize;
  var addy = -bounds.e22_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.o7k();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.r7t(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.t7t(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.a7j_1;
      var this_1 = this_0.j7j_1;
      if (!(this_1.e7j_1 === this_0)) {
        this_1.e7j_1 = this_0;
        this_1.o7k();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.p69(0, 0, rb.s5y_1, rb.t5y_1);
        var temp = this_0.h7k_1;
        this_0.q7q();
        this_0.h7k_1 = scissor;
        try {
          if (true) {
            ctx.l7t(Colors_getInstance().p3n_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.l9a().g26(addx, addy).b26(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.a7j_1.j7j_1;
          this_2.o7k();
          var temp4 = this_2.p7i_1;
          var temp2d = this_2.q7i_1;
          this_2.q7i_1 = mat;
          this_2.p7i_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.b66(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.q67();
            this_3.x6t(_unary__edvuaz + 1 | 0);
            this_3.y6t(this_3.q67() + 1 | 0);
            var blockSize = this_3.u65_1;
            var index0 = imul(this_3.q67() - 1 | 0, blockSize);
            var index1 = imul(this_3.q67(), blockSize);
            var texBlockSize = this_3.r65_1.q6d().d1();
            var texIndex0 = imul(this_3.q67() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.q67(), texBlockSize);
            if (this_3.q67() > 0) {
              arraycopy(this_3.w65_1, index0, this_3.w65_1, index1, blockSize);
            } else {
              arrayfill(this_3.w65_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.r65_1;
            this_3.x65_1.h6u($this$push.p6d(), this_2.p7i_1);
            if (true && this_3.q67() >= 1) {
              var equals = arrayequal(this_3.w65_1, index0, this_3.w65_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.q67();
                this_3.x6t(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.u9a(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.v9a(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.o7k();
            this_2.p7i_1 = temp4;
            this_2.q7i_1 = temp2d;
            this_2.b66(ProjViewUB_getInstance()).z6t();
          }
          break $l$block_0;
        }finally {
          this_0.q7q();
          this_0.h7k_1 = temp;
        }
      }
    }finally {
      ctx.u7t();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).d3a(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.k9a().k26(-addx, -addy).d26(1.0 / realFilterScale);
    filter.jaf(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.o9a(), _this__u8e3s4.h8k_1, realFilterScale);
    ctx.o7k();
  }finally {
    ctx.s7t(rb);
  }
}
function set_filter(_this__u8e3s4, value) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var enabled = !(value == null);
  if (enabled) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase' call
      // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
      var tmp357_safe_receiver = _this__u8e3s4.n8l_1;
      var tmp;
      if (tmp357_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp357_safe_receiver.z();
          while (tmp0_iterator.a1()) {
            var element = tmp0_iterator.b1();
            // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
            if (element instanceof ViewRenderPhaseFilter) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp = tmp$ret$1;
      }
      var tmp_0 = tmp;
      var tmp360_safe_receiver = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
      if (tmp360_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp$ret$3 = tmp360_safe_receiver;
        break $l$block_0;
      }
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.filter.<set-filter>.<anonymous>' call
      var this_0 = new ViewRenderPhaseFilter(value);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase.<anonymous>' call
      _this__u8e3s4.t9a(this_0);
      tmp$ret$3 = this_0;
    }
    tmp$ret$3.xaf_1 = value;
  } else {
    // Inline function 'korlibs.korge.view.View.removeRenderPhaseOfType' call
    var tmp356_safe_receiver = _this__u8e3s4.n8l_1;
    if (tmp356_safe_receiver == null)
      null;
    else {
      removeAll(tmp356_safe_receiver, _set_filter_$lambda_rgmh04);
    }
  }
  _this__u8e3s4.m98();
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp357_safe_receiver = _this__u8e3s4.n8l_1;
  var tmp;
  if (tmp357_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp357_safe_receiver.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp456_safe_receiver = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp456_safe_receiver == null ? null : tmp456_safe_receiver.xaf_1;
}
var Companion_instance_28;
function Companion_getInstance_49() {
  return Companion_instance_28;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_47().gaf(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function _set_filter_$lambda_rgmh04(it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return it instanceof ViewRenderPhaseFilter;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.zw_1 = transform;
    filterScale$delegate = this_0;
  }
}
function transformIndex($this, flipX, flipY, rotate) {
  return insert(insert(insert(0, flipX, 0), flipY, 1), rotate, 2);
}
function computeIndices($this, flipX, flipY, rotate, indices) {
  indices[0] = 0;
  indices[1] = 1;
  indices[2] = 2;
  indices[3] = 3;
  if (rotate) {
    swap(indices, $this, 1, 3);
  }
  if (flipY) {
    swap(indices, $this, 0, 3);
    swap(indices, $this, 1, 2);
  }
  if (flipX) {
    swap(indices, $this, 0, 1);
    swap(indices, $this, 3, 2);
  }
  return indices;
}
function computeIndices$default($this, flipX, flipY, rotate, indices, $super) {
  indices = indices === VOID ? new Int32Array(4) : indices;
  return computeIndices($this, flipX, flipY, rotate, indices);
}
function swap(_this__u8e3s4, $this, a, b) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.tiles.Companion.swap.<anonymous>' call
  var t = _this__u8e3s4[a];
  _this__u8e3s4[a] = _this__u8e3s4[b];
  _this__u8e3s4[b] = t;
  return _this__u8e3s4;
}
var Companion_instance_29;
function Companion_getInstance_50() {
  if (Companion_instance_29 === VOID)
    new Companion_14();
  return Companion_instance_29;
}
function computeVertexIfRequired($this, ctx) {
  $this.sai_1 = new Rectangle(ctx.v7r(), ctx.w7r(), ctx.x7r(), ctx.y7r());
  if (!$this.sai_1.equals($this.rai_1)) {
    $this.g8l_1 = true;
    $this.rai_1 = $this.sai_1;
  }
  if (!$this.g8l_1 && $this.mai_1 === $this.eai_1.w2m() && $this.nai_1 === $this.lai_1)
    return Unit_instance;
  $this.mai_1 = $this.eai_1.w2m();
  $this.nai_1 = $this.lai_1;
  $this.g8l_1 = false;
  var m = $this.k9a();
  var renderTilesCounter = ctx.f7i_1.p7w('renderedTiles');
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var p = Companion_getInstance_26().v21_1;
    if (m.i22()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.j21(m.s25(p.h21_1, p.i21_1), m.v25(p.h21_1, p.i21_1));
  }
  var _destruct__k2r9zo = tmp$ret$0;
  var posX = _destruct__k2r9zo.rk();
  var posY = _destruct__k2r9zo.sk();
  var dUX = m.t25($this.hai_1, 0.0) - posX;
  var dUY = m.u25($this.hai_1, 0.0) - posY;
  var dVX = m.t25(0.0, $this.iai_1) - posX;
  var dVY = m.u25(0.0, $this.iai_1) - posY;
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
  var width = $this.gai_1.x2b_1;
  // Inline function 'kotlin.math.min' call
  var a = m.s25(width, 0.0) - posX;
  var b = m.v25(0.0, width) - posY;
  var nextTileX = Math.min(a, b);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
  var height = $this.gai_1.y2b_1;
  // Inline function 'kotlin.math.min' call
  var a_0 = m.s25(height, 0.0) - posX;
  var b_0 = m.v25(0.0, height) - posY;
  var nextTileY = Math.min(a_0, b_0);
  var colMul = $this.o9a();
  var pp0 = $this.aae(Vector2D.j21($this.sai_1.k22(), $this.sai_1.m22()));
  var pp1 = $this.aae(Vector2D.j21($this.sai_1.l22(), $this.sai_1.n22()));
  var pp2 = $this.aae(Vector2D.j21($this.sai_1.l22(), $this.sai_1.m22()));
  var pp3 = $this.aae(Vector2D.j21($this.sai_1.k22(), $this.sai_1.n22()));
  var mapTileWidth = $this.gai_1.x2b_1;
  var mapTileHeight = $this.gai_1.y2b_1;
  var mx0 = toIntCeil(pp0.h21_1 / mapTileWidth);
  var mx1 = toIntCeil(pp1.h21_1 / mapTileWidth);
  var mx2 = toIntCeil(pp2.h21_1 / mapTileWidth);
  var mx3 = toIntCeil(pp3.h21_1 / mapTileWidth);
  var my0 = toIntCeil(pp0.i21_1 / mapTileHeight);
  var my1 = toIntCeil(pp1.i21_1 / mapTileHeight);
  var my2 = toIntCeil(pp2.i21_1 / mapTileHeight);
  var my3 = toIntCeil(pp3.i21_1 / mapTileHeight);
  var ymin = min(my0, my1, my2, my3);
  var ymax = max(my0, my1, my2, my3);
  var xmin = min(mx0, mx1, mx2, mx3);
  var xmax = max(mx0, mx1, mx2, mx3);
  var doRepeatX = !$this.jai_1.equals(TileMapRepeat_NONE_getInstance());
  var doRepeatY = !$this.kai_1.equals(TileMapRepeat_NONE_getInstance());
  var doRepeatAny = doRepeatX || doRepeatY;
  var ymin2 = ((doRepeatAny ? ymin : clamp_1(ymin, $this.eai_1.y2m(), $this.eai_1.b2n())) - 1 | 0) - $this.vai_1 | 0;
  var ymax2 = ((doRepeatAny ? ymax : clamp_1(ymax, $this.eai_1.y2m(), $this.eai_1.b2n())) + 1 | 0) + $this.vai_1 | 0;
  var xmin2 = ((doRepeatAny ? xmin : clamp_1(xmin, $this.eai_1.x2m(), $this.eai_1.a2n())) - 1 | 0) - $this.vai_1 | 0;
  var xmax2 = ((doRepeatAny ? xmax : clamp_1(xmax, $this.eai_1.x2m(), $this.eai_1.a2n())) + 1 | 0) + $this.vai_1 | 0;
  var yheight = ymax2 - ymin2 | 0;
  var xwidth = xmax2 - xmin2 | 0;
  var ntiles = imul(imul(xwidth, yheight), $this.eai_1.z2m());
  var allocTiles = get_nextPowerOfTwo(ntiles);
  var MAX_TILES = 16368;
  // Inline function 'kotlin.math.min' call
  var allocTilesClamped = Math.min(allocTiles, MAX_TILES);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.pai_1;
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.c1(_unary__edvuaz);
    $this.qai_1.o2l(it);
  }
  $this.oai_1.j3();
  $this.pai_1.j3();
  var iterationCount = 0;
  var count = 0;
  var nblocks = 0;
  // Inline function 'korlibs.korge.render.Companion.quadIndices' call
  Companion_getInstance_14();
  var quadIndexData = TEXTURED_ARRAY_quadIndices(allocTilesClamped);
  var scaleOffsetX = 1.0 / $this.hai_1 * $this.eai_1.f5d_1;
  var scaleOffsetY = 1.0 / $this.iai_1 * $this.eai_1.f5d_1;
  var inductionVariable = ymin2;
  if (inductionVariable < ymax2)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = xmin2;
      if (inductionVariable_0 < xmax2)
        $l$loop_0: do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          iterationCount = iterationCount + 1 | 0;
          var rx = $this.jai_1.p5d_1(x, $this.eai_1.n2d());
          var ry = $this.kai_1.p5d_1(y, $this.eai_1.o2d());
          if (rx < $this.eai_1.x2m() || rx >= $this.eai_1.a2n())
            continue $l$loop_0;
          if (ry < $this.eai_1.y2m() || ry >= $this.eai_1.b2n())
            continue $l$loop_0;
          var inductionVariable_1 = 0;
          var last = $this.eai_1.c2n(rx, ry);
          if (inductionVariable_1 < last)
            $l$loop_2: do {
              var level = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var cell = $this.eai_1.l5d(rx, ry, level);
              if (_Tile___get_isInvalid__impl__yfg9ed(cell))
                continue $l$loop_2;
              var cellData = _Tile___get_tile__impl__nfq1aw(cell);
              var flipX = _Tile___get_flipX__impl__jobqpf(cell);
              var flipY = _Tile___get_flipY__impl__95aqcs(cell);
              var rotate = _Tile___get_rotate__impl__5kjdv9(cell);
              var offsetX = _Tile___get_offsetX__impl__qwhdsd(cell);
              var offsetY = _Tile___get_offsetY__impl__1x539u(cell);
              var rationalOffsetX = offsetX * scaleOffsetX;
              var rationalOffsetY = offsetY * scaleOffsetY;
              var tmp0_elvis_lhs = getOrNull_0($this.xai_1, cellData);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_2;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var tex = tmp;
              count = count + 1 | 0;
              var tmp$ret$9;
              $l$block_1: {
                // Inline function 'korlibs.datastructure.FastIdentityCacheMap.getOrPut' call
                var this_1 = $this.oai_1;
                var key = tex.t2g();
                if (key === this_1.p2i_1) {
                  tmp$ret$9 = ensureNotNull(this_1.q2i_1);
                  break $l$block_1;
                }
                if (key === this_1.r2i_1) {
                  tmp$ret$9 = ensureNotNull(this_1.s2i_1);
                  break $l$block_1;
                }
                var tmp$ret$10;
                $l$block_2: {
                  // Inline function 'korlibs.datastructure.getOrPut' call
                  var this_2 = this_1.t2i_1;
                  var res = get(this_2, key);
                  if (!(res == null)) {
                    tmp$ret$10 = res;
                    break $l$block_2;
                  }
                  // Inline function 'korlibs.datastructure.FastIdentityCacheMap.getOrPut.<anonymous>' call
                  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
                  // Inline function 'kotlin.also' call
                  var this_3 = $this.qai_1.n2l();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>.<anonymous>' call
                  this_3.zaf_1 = tex.t2g();
                  this_3.bag_1.j3();
                  this_3.cag(new ShrinkableTexturedVertexArray(new TexturedVertexArray(imul(allocTilesClamped, 4), quadIndexData)));
                  // Inline function 'kotlin.collections.plusAssign' call
                  $this.pai_1.f(this_3);
                  nblocks = nblocks + 1 | 0;
                  var out = this_3;
                  set(this_2, key, out);
                  tmp$ret$10 = out;
                }
                var value = tmp$ret$10;
                this_1.r2i_1 = this_1.p2i_1;
                this_1.s2i_1 = this_1.q2i_1;
                this_1.p2i_1 = key;
                this_1.q2i_1 = value;
                tmp$ret$9 = value;
              }
              var info = tmp$ret$9;
              // Inline function 'kotlin.run' call
              // Inline function 'kotlin.contracts.contract' call
              var px = x + rationalOffsetX;
              var py = y + rationalOffsetY;
              var p0X = posX + nextTileX * px + dVX * py;
              var p0Y = posY + dUY * px + nextTileY * py;
              var p1X = p0X + dUX;
              var p1Y = p0Y + dUY;
              var p2X = p0X + dUX + dVX;
              var p2Y = p0Y + dUY + dVY;
              var p3X = p0X + dVX;
              var p3Y = p0Y + dVY;
              $this.tai_1[0] = tex.g3a();
              $this.tai_1[1] = tex.i3a();
              $this.tai_1[2] = tex.k3a();
              $this.tai_1[3] = tex.m3a();
              $this.uai_1[0] = tex.h3a();
              $this.uai_1[1] = tex.j3a();
              $this.uai_1[2] = tex.l3a();
              $this.uai_1[3] = tex.n3a();
              var indices = Companion_getInstance_50().dag_1[transformIndex(Companion_getInstance_50(), flipX, flipY, rotate)];
              info.aag_1.y7v(p0X, p0Y, $this.tai_1[indices[0]], $this.uai_1[indices[0]], colMul);
              info.aag_1.y7v(p1X, p1Y, $this.tai_1[indices[1]], $this.uai_1[indices[1]], colMul);
              info.aag_1.y7v(p2X, p2Y, $this.tai_1[indices[2]], $this.uai_1[indices[2]], colMul);
              info.aag_1.y7v(p3X, p3Y, $this.tai_1[indices[3]], $this.uai_1[indices[3]], colMul);
              var _receiver__tnumb7 = info.aag_1;
              _receiver__tnumb7.x7v_1 = _receiver__tnumb7.x7v_1 + 6 | 0;
              if (info.aag_1.x7v_1 >= (MAX_TILES - 1 | 0)) {
                info.cag(new ShrinkableTexturedVertexArray(new TexturedVertexArray(imul(allocTilesClamped, 4), quadIndexData)));
                nblocks = nblocks + 1 | 0;
              }
            }
             while (inductionVariable_1 < last);
        }
         while (inductionVariable_0 < xmax2);
    }
     while (inductionVariable < ymax2);
  renderTilesCounter.h7w(count);
  $this.wai_1 = iterationCount;
}
function updatedTileSet($this) {
  var tmp = $this;
  var tmp_0 = 0;
  var tmp_1 = $this.aaj_1.f5e().length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = fillArrayVal(Array(tmp_1), null);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    tmp_2[tmp_3] = $this.aaj_1.f5e()[tmp_3];
    tmp_0 = tmp_0 + 1 | 0;
  }
  tmp.xai_1 = tmp_2;
  var tmp_4 = $this;
  var tmp_5 = 0;
  var tmp_6 = $this.aaj_1.f5e().length;
  var tmp_7 = new Int32Array(tmp_6);
  while (tmp_5 < tmp_6) {
    tmp_7[tmp_5] = 0;
    tmp_5 = tmp_5 + 1 | 0;
  }
  tmp_4.yai_1 = tmp_7;
  var tmp_8 = $this;
  var tmp_9 = 0;
  var tmp_10 = $this.aaj_1.f5e().length;
  var tmp_11 = new Float64Array(tmp_10);
  while (tmp_9 < tmp_10) {
    tmp_11[tmp_9] = 0.0;
    tmp_9 = tmp_9 + 1 | 0;
  }
  tmp_8.zai_1 = tmp_11;
  $this.gai_1 = $this.aaj_1.e5e();
  $this.hai_1 = $this.aaj_1.y5d_1;
  $this.iai_1 = $this.aaj_1.z5d_1;
}
function TileMap$infosPool$lambda(it) {
  it.e2h();
  return Unit_instance;
}
function TileMap$infosPool$lambda_0(it) {
  // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
  var tmp$ret$0 = get_Bitmaps_transparent();
  return new Info(get_bmp(tmp$ret$0), new ShrinkableTexturedVertexArray(Companion_getInstance_14().q7v_1));
}
function TileMap$lambda($tileset) {
  return function ($this$addFastUpdater, dt) {
    var this_0 = $tileset.f33();
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.view.tiles.TileMap.<anonymous>.<anonymous>' call
      var tileIndex = n;
      var info = this_0[n];
      var tmp;
      if (!(info == null)) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !info.v5d_1.f1();
      } else {
        tmp = false;
      }
      if (tmp) {
        var aindex = $this$addFastUpdater.yai_1[tileIndex];
        var currentFrame = info.v5d_1.c1(aindex);
        var _array__4zh2yp = $this$addFastUpdater.zai_1;
        _array__4zh2yp[tileIndex] = _array__4zh2yp[tileIndex] + _FastDuration___get_milliseconds__impl__ffr17u(dt.e1o_1);
        // Inline function 'korlibs.time.milliseconds' call
        var this_1 = $this$addFastUpdater.zai_1[tileIndex];
        var tmp$ret$1 = toDuration(this_1, DurationUnit_MILLISECONDS_getInstance());
        if (Duration__compareTo_impl_pchp0f(tmp$ret$1, currentFrame.caj_1) >= 0) {
          var nextIndex = (aindex + 1 | 0) % info.v5d_1.d1() | 0;
          var _array__4zh2yp_0 = $this$addFastUpdater.zai_1;
          _array__4zh2yp_0[tileIndex] = _array__4zh2yp_0[tileIndex] - get_milliseconds(currentFrame.caj_1);
          $this$addFastUpdater.yai_1[tileIndex] = nextIndex;
          $this$addFastUpdater.xai_1[tileIndex] = $tileset.f5e()[info.v5d_1.c1(nextIndex).baj_1];
          $this$addFastUpdater.lai_1 = $this$addFastUpdater.lai_1 + 1 | 0;
        }
      }
      n = n + 1 | 0;
    }
    return Unit_instance;
  };
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.wa2_1 ? $this.ha3_1 : $this.ga3_1;
  if (!valid) {
    if ($this.wa2_1)
      $this.ha3_1 = true;
    else
      $this.ga3_1 = true;
    var result = $this.ea3_1.o5i($this.wa2_1);
    if ($this.wa2_1)
      $this.ka3_1 = result;
    else
      $this.ja3_1 = result;
    return result;
  }
  return $this.wa2_1 ? $this.ka3_1 : $this.ja3_1;
}
function invalidateShape($this) {
  $this.ia3_1 = 0;
  $this.fa3_1 = false;
  $this.ga3_1 = false;
  $this.ha3_1 = false;
  $this.f8r();
}
function requireShape($this) {
  if ($this.fa3_1)
    return Unit_instance;
  $this.fa3_1 = true;
  $this.xa2_1.j3();
  $this.xa2_1.paj();
  $this.xa2_1.qaj(Companion_getInstance_12().l60_1);
  $this.la3_1 = true;
  renderShape($this, $this.ea3_1);
  $this.xa2_1.b5z();
  $this.na3_1 = $this.ma3_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.k9a().o25(get_immutable(ctx.d7i_1.q7r())) : $this.k9a();
  $this.oa3_1 = mat.i26(-$this.e99(), -$this.f99());
  requireShape($this);
  $this.xa2_1.raj(ctx, $this.oa3_1, $this.j9a(), $this.ba3_1, $this.o9a(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.b5j_1.z();
      while (_iterator__ex2g4s.a1()) {
        var v = _iterator__ex2g4s.b1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.u5j());
      } else {
        if (shape instanceof FillShape) {
          $this.ia3_1 = $this.ia3_1 + 1 | 0;
          if ($this.ia3_1 > $this.pa3_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.ia3_1 = $this.ia3_1 + 1 | 0;
            if ($this.ia3_1 > $this.pa3_1)
              return Unit_instance;
            renderStroke$default($this, shape.g5j_1, shape.d5j_1, shape.f5j_1, shape.i5j_1, shape.h5j_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.nd('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.xa2_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.qaj(Companion_getInstance_12().l60_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.d1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.c1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.saj();
    var vector = points.n31();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.d1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.a24(n_0, 0);
        var y = vector.a24(n_0, 1);
        var dx = vector.a24(n_0, 2);
        var dy = vector.a24(n_0, 3);
        var len = vector.a24(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.a24(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.taj(px, py, $this.da3_1 ? len : 0.0, $this.da3_1 ? maxLen : $this.ra3_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.uaj();
    var info = GpuShapeViewPrograms_getInstance().nak(stateTransform, paint, globalAlpha, strokeInfo.w30_1);
    var tmp466_drawType = Companion_getInstance_15().n68_1;
    var tmp467_blendMode = Companion_getInstance_13().h7h_1;
    gpuShapeViewCommands.oak(tmp466_drawType, info, VOID, stencilOpFunc, stencilRef, tmp467_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_16().z5z_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_17().x5z_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.d1() < 3)
    return null;
  var vertexStart = $this.xa2_1.saj();
  var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_28().t22(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.j21(xMid, yMid);
  var isStrip = type === Companion_getInstance_15().n68_1;
  var antialiased = $this.da3_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.xa2_1.taj(xMid, yMid, 0.0, $this.ra3_1);
  }
  var inductionVariable = 0;
  var last = points.d1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.c1(n % points.d1() | 0);
      var x = p.rk();
      var y = p.sk();
      var len = isStripAndAntialiased ? Companion_getInstance_26().f2c(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.ra3_1;
      if (isStrip) {
        $this.xa2_1.taj(xMid, yMid, 0.0, maxLen);
      }
      $this.xa2_1.taj(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.xa2_1.uaj();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.d1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.p1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.z();
  while (tmp0_iterator.a1()) {
    var element = tmp0_iterator.b1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().nak(shape.s5i_1, shape.r5i_1, shape.t5i_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.qa3_1;
  var drawAntialiasingBorder = $this.qa3_1 ? true : $this.da3_1;
  var shapeIsConvex = shape.z5i();
  var isSimpleDraw = shapeIsConvex && shape.q5i_1 == null && !$this.qa3_1;
  var pathDataList = getPointsForPathList($this, shape.p5i_1, isSimpleDraw ? Companion_getInstance_15().n68_1 : Companion_getInstance_15().o68_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_28().t22();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.d1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.c1(_unary__edvuaz);
    bb = plus(bb, it.pak_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.k2a(MarginInt.w24(2)));
  var clipDataStart = $this.xa2_1.saj();
  var tmp468_safe_receiver = shape.q5i_1;
  var tmp_0;
  if (tmp468_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp468_safe_receiver, Companion_getInstance_15().o68_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.xa2_1.uaj();
  var tmp1_elvis_lhs = clipData == null ? null : clipData.pak_1;
  var clipBounds = tmp1_elvis_lhs == null ? Companion_getInstance_12().l60_1 : tmp1_elvis_lhs;
  if (!isSimpleDraw || $this.la3_1) {
    $this.la3_1 = true;
    $this.xa2_1.qaj(isSimpleDraw ? Companion_getInstance_12().l60_1 : !clipBounds.equals(Companion_getInstance_12().l60_1) ? Companion_getInstance_12().u69(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.la3_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.d1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.c1(_unary__edvuaz_0);
      var tmp470_$this = $this.xa2_1;
      var tmp471_drawType = Companion_getInstance_15().n68_1;
      var tmp472_startIndex = pathData.rak_1;
      var tmp473_endIndex = pathData.sak_1;
      var tmp474_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp475_blendMode = $this.n9a();
      tmp470_$this.oak(tmp471_drawType, paintShader, tmp474_colorMask, VOID, VOID, tmp475_blendMode, VOID, tmp472_startIndex, tmp473_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.p5i_1.s36_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_18().o6a_1;
  if (drawFill) {
    switch (winding.m3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_18().o6a_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().z5z_1, true), Companion_getInstance_18().n6a_1), Companion_getInstance_19().z6a_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_17().x5z_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.d1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.c1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.rak_1, pathData_0.sak_1, stencilOpFunc, stencilRef, Companion_getInstance_20().n60_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_18().u6a_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().z5z_1, true), Companion_getInstance_18().n6a_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_17().x5z_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.d1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.c1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.rak_1, pathData_1.sak_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_19().y6a_1, Companion_getInstance_19().w6a_1), stencilRef_0, Companion_getInstance_20().n60_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().z5z_1, true), Companion_getInstance_18().u6a_1), Companion_getInstance_19().z6a_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_17().x5z_1, 0), 255), Companion_getInstance_20().o60_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().z5z_1, true), Companion_getInstance_18().n6a_1), Companion_getInstance_19().z6a_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_17().x5z_1, 2), Companion_getInstance_20().q60_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.q5i_1 == null) {
    renderStroke($this, shape.s5i_1, shape.p5i_1, shape.r5i_1, shape.t5i_1, new StrokeInfo(1.6 / $this.ma3_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_16().z5z_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().z5z_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_17().x5z_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.xa2_1.p6o(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp477_$this = $this.xa2_1;
  var tmp478_drawType = Companion_getInstance_15().o68_1;
  var tmp479_paintShader = GpuShapeViewPrograms_getInstance().mak_1;
  var tmp480_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp481_blendMode = Companion_getInstance_13().j7h_1;
  tmp477_$this.tak(tmp478_drawType, tmp479_paintShader, tmp480_colorMask, stencilOpFunc, stencilRef, tmp481_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.xa2_1.saj();
  var x0 = pathBounds.k22();
  var y0 = pathBounds.m22();
  var x1 = pathBounds.l22();
  var y1 = pathBounds.n22();
  $this.xa2_1.taj(x0, y0, 0.0, $this.ra3_1);
  $this.xa2_1.taj(x1, y0, 0.0, $this.ra3_1);
  $this.xa2_1.taj(x1, y1, 0.0, $this.ra3_1);
  $this.xa2_1.taj(x0, y1, 0.0, $this.ra3_1);
  var vend = $this.xa2_1.uaj();
  var tmp482_$this = $this.xa2_1;
  var tmp483_drawType = Companion_getInstance_15().o68_1;
  var tmp484_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp485_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().z5z_1, true), stencilCompare);
  var tmp486_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_17().x5z_1, stencilReferenceValue), 0);
  var tmp487_blendMode = $this.n9a();
  tmp482_$this.oak(tmp483_drawType, paintShader, tmp484_colorMask, tmp485_stencilOpFunc, tmp486_stencilRef, tmp487_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.c6g(), GpuShapeViewPrograms_getInstance().zal());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.c6g(), $this$IF_ELSE_LIST.k6g($$this$FragmentShaderDefault.j6g(), $this$IF_ELSE_LIST.p6h($this$IF_ELSE_LIST.r6h([$this$IF_ELSE_LIST.i6g($this$IF_ELSE_LIST.d6g(GpuShapeViewPrograms_getInstance().bam(), $this$IF_ELSE_LIST.g6g([$$this$FragmentShaderDefault.v6f(), $this$IF_ELSE_LIST.f6g(0.0), $this$IF_ELSE_LIST.f6g(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.c6g(), $this$IF_ELSE_LIST.k6g($$this$FragmentShaderDefault.j6g(), $this$IF_ELSE_LIST.i6g($this$IF_ELSE_LIST.d6g(GpuShapeViewPrograms_getInstance().bam(), $this$IF_ELSE_LIST.g6g([$this$IF_ELSE_LIST.s6h($$this$FragmentShaderDefault.v6f()), $this$IF_ELSE_LIST.t6h($$this$FragmentShaderDefault.v6f()), $this$IF_ELSE_LIST.f6g(0.0), $this$IF_ELSE_LIST.f6g(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.j6h(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.i6g(rpoint, 'xy'), $this$IF_ELSE_LIST.i6g($this$IF_ELSE_LIST.d6g(GpuShapeViewPrograms_getInstance().bam(), $this$IF_ELSE_LIST.g6g([$this$IF_ELSE_LIST.s6h($$this$FragmentShaderDefault.v6f()), $this$IF_ELSE_LIST.t6h($$this$FragmentShaderDefault.v6f()), $this$IF_ELSE_LIST.f6g(0.0), $this$IF_ELSE_LIST.f6g(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.s6h(rpoint);
        var y = $this$IF_ELSE_LIST.t6h(rpoint);
        var x0 = $this$IF_ELSE_LIST.s6h(GpuShapeViewPrograms_getInstance().cam());
        var y0 = $this$IF_ELSE_LIST.t6h(GpuShapeViewPrograms_getInstance().cam());
        var r0 = $this$IF_ELSE_LIST.u6h(GpuShapeViewPrograms_getInstance().cam());
        var x1 = $this$IF_ELSE_LIST.s6h(GpuShapeViewPrograms_getInstance().dam());
        var y1 = $this$IF_ELSE_LIST.t6h(GpuShapeViewPrograms_getInstance().dam());
        var r1 = $this$IF_ELSE_LIST.u6h(GpuShapeViewPrograms_getInstance().dam());
        var ratio = $this$IF_ELSE_LIST.s6h($$this$FragmentShaderDefault.n6g());
        var r0r1_2 = $this$IF_ELSE_LIST.t6h($$this$FragmentShaderDefault.n6g());
        var r0pow2 = $this$IF_ELSE_LIST.u6h($$this$FragmentShaderDefault.n6g());
        var r1pow2 = $this$IF_ELSE_LIST.v6h($$this$FragmentShaderDefault.n6g());
        var y0_y1 = $this$IF_ELSE_LIST.s6h($$this$FragmentShaderDefault.d6i());
        var x0_x1 = $this$IF_ELSE_LIST.t6h($$this$FragmentShaderDefault.d6i());
        var r0_r1 = $this$IF_ELSE_LIST.u6h($$this$FragmentShaderDefault.d6i());
        var radial_scale = $this$IF_ELSE_LIST.v6h($$this$FragmentShaderDefault.d6i());
        $this$IF_ELSE_LIST.z6f(r0r1_2, $this$IF_ELSE_LIST.d6g($this$IF_ELSE_LIST.d6g($this$IF_ELSE_LIST.f6g(2.0), r0), r1));
        $this$IF_ELSE_LIST.z6f(r0pow2, GpuShapeViewPrograms_getInstance().eam(r0));
        $this$IF_ELSE_LIST.z6f(r1pow2, GpuShapeViewPrograms_getInstance().eam(r1));
        $this$IF_ELSE_LIST.z6f(x0_x1, $this$IF_ELSE_LIST.x6h(x0, x1));
        $this$IF_ELSE_LIST.z6f(y0_y1, $this$IF_ELSE_LIST.x6h(y0, y1));
        $this$IF_ELSE_LIST.z6f(r0_r1, $this$IF_ELSE_LIST.x6h(r0, r1));
        $this$IF_ELSE_LIST.z6f(radial_scale, $this$IF_ELSE_LIST.o6g($this$IF_ELSE_LIST.f6g(1.0), $this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.x6h(GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(r0, r1)), GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(x0, x1))), GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(y0, y1)))));
        $this$IF_ELSE_LIST.z6f(ratio, $this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.f6g(1.0), $this$IF_ELSE_LIST.d6g($this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.y6h($this$IF_ELSE_LIST.y6h($this$IF_ELSE_LIST.d6g($this$IF_ELSE_LIST.w6h(r1), r0_r1), $this$IF_ELSE_LIST.d6g(x0_x1, $this$IF_ELSE_LIST.x6h(x1, x))), $this$IF_ELSE_LIST.d6g(y0_y1, $this$IF_ELSE_LIST.x6h(y1, y))), $this$IF_ELSE_LIST.n6h($this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.y6h($this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.d6g(r1pow2, $this$IF_ELSE_LIST.y6h(GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(x0, x)), GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(y0, y)))), $this$IF_ELSE_LIST.d6g(r0r1_2, $this$IF_ELSE_LIST.y6h($this$IF_ELSE_LIST.d6g($this$IF_ELSE_LIST.x6h(x0, x), $this$IF_ELSE_LIST.x6h(x1, x)), $this$IF_ELSE_LIST.d6g($this$IF_ELSE_LIST.x6h(y0, y), $this$IF_ELSE_LIST.x6h(y1, y))))), $this$IF_ELSE_LIST.d6g(r0pow2, $this$IF_ELSE_LIST.y6h(GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(x1, x)), GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h(y1, y))))), GpuShapeViewPrograms_getInstance().eam($this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.y6h($this$IF_ELSE_LIST.y6h($this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.x6h($this$IF_ELSE_LIST.d6g(x1, y0), $this$IF_ELSE_LIST.d6g(x, y0)), $this$IF_ELSE_LIST.d6g(x0, y1)), $this$IF_ELSE_LIST.d6g(x, y1)), $this$IF_ELSE_LIST.d6g(x0, y)), $this$IF_ELSE_LIST.d6g(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.c6g(), $this$IF_ELSE_LIST.k6g($$this$FragmentShaderDefault.j6g(), $this$IF_ELSE_LIST.r6h([ratio, $this$IF_ELSE_LIST.f6g(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.j6h(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.i6g(rpoint_0, 'xy'), $this$IF_ELSE_LIST.i6g($this$IF_ELSE_LIST.d6g(GpuShapeViewPrograms_getInstance().bam(), $this$IF_ELSE_LIST.g6g([$this$IF_ELSE_LIST.s6h($$this$FragmentShaderDefault.v6f()), $this$IF_ELSE_LIST.t6h($$this$FragmentShaderDefault.v6f()), $this$IF_ELSE_LIST.f6g(0.0), $this$IF_ELSE_LIST.f6g(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.s6h(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.t6h(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.s6h($$this$FragmentShaderDefault.n6g());
        var angle = $this$IF_ELSE_LIST.t6h($$this$FragmentShaderDefault.n6g());
        var x0_0 = $this$IF_ELSE_LIST.s6h(GpuShapeViewPrograms_getInstance().cam());
        var y0_0 = $this$IF_ELSE_LIST.t6h(GpuShapeViewPrograms_getInstance().cam());
        var PI2 = $this$IF_ELSE_LIST.f6g(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.z6f(angle, $this$IF_ELSE_LIST.l6h($this$IF_ELSE_LIST.x6h(y_0, y0_0), $this$IF_ELSE_LIST.x6h(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.a6i(angle, $this$IF_ELSE_LIST.f6g(0.0));
        var body = $this$IF_ELSE_LIST.q6g();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.z6f(angle, body.y6h(angle, PI2));
        var stmIf = new If(cond, body.s6g());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.y6f_1.f(stmIf);
        $this$IF_ELSE_LIST.z6f(ratio_0, $this$IF_ELSE_LIST.o6g(angle, PI2));
        $this$IF_ELSE_LIST.z6f($this$IF_ELSE_LIST.c6g(), $this$IF_ELSE_LIST.k6g($$this$FragmentShaderDefault.j6g(), $this$IF_ELSE_LIST.p6h($this$IF_ELSE_LIST.r6h([ratio_0, $this$IF_ELSE_LIST.f6g(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.yal();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.zal();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.xal();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.aam();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.wal();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.bam();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.cam();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.dam();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.yal();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.zal();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.xal();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.aam();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.wal();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.bam();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.cam();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.dam();
  }, null);
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(RootAnimationNode, 'RootAnimationNode');
initMetadataForClass(TweenNode, 'TweenNode');
initMetadataForClass(BlockNode, 'BlockNode');
initMetadataForClass(Animator, 'Animator', VOID, VOID, [CloseableCancellable], [1]);
initMetadataForLambda(KeysEvents$down$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$down$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(ScaledScene, 'ScaledScene', VOID, VOID, VOID, [0]);
initMetadataForClass(PixelatedScene, 'PixelatedScene', VOID, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.g9p);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.h8v);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.h9p);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.r9g);
initMetadataForClass(UIView, 'UIView', UIView.i95);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.j95);
protoOf(Transition$1).q9b = start;
protoOf(Transition$1).r9b = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TimerComponents, 'TimerComponents', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(TimerRef, 'TimerRef');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.xa6);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [Collection, MutableIterable, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.p9v);
initMetadataForClass(DummyView, 'DummyView', DummyView.r9x);
initMetadataForCompanion(Companion_4);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.t9x);
initMetadataForClass(SContainer, 'SContainer', SContainer.v8x);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.va3);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).va6 = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForCompanion(Companion_5);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_7);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_8);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).va6 = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_10);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_11);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult);
protoOf(IdentityFilter).haf = get_recommendedFilterScale;
protoOf(IdentityFilter).iaf = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_12);
initMetadataForObject(Linear, 'Linear');
initMetadataForObject(Nearest, 'Nearest');
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForCompanion(Companion_13);
protoOf(ViewRenderPhaseFilter).xad = beforeRender;
protoOf(ViewRenderPhaseFilter).yad = afterRender;
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', ViewRenderPhaseFilter, VOID, [ViewRenderPhase]);
initMetadataForClass(Info, 'Info');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TileMap, 'TileMap', TileMap.daj);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.sa3);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_19 = new Companion_4();
Companion_instance_20 = new Companion_5();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
Companion_instance_28 = new Companion_13();
//endregion
//region block: exports
export {
  delay as delay1gbwd28dgkhwf,
  tween as tween3jbh5j0ixzsj7,
  views as views17oaxjs1xed1j,
  Korge_0 as Korge11eut3mr7473l,
  Companion_getInstance_38 as Companion_getInstancezug9z9lglek,
  Companion_instance_22 as Companion_instancecqwbvq0sb4tp,
  Animator as Animator3ve4r56t61w8x,
  animator as animator38vbqz0qhvd6m,
  block as block1zs9asix98nq4,
  hide as hide1jf8h1e875esy,
  moveBy as moveBy2jlfhnymnp65t,
  show as show2aeumyubbk4hr,
  get_keys as get_keysmipauarvwdlb,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  PixelatedScene as PixelatedSceneoudxoze5iszc,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  interval as intervalfu9yhuucbcwn,
  centerOnStage as centerOnStage1tf2oda60yrak,
  TileMap as TileMapunot5gnjvpqy,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  SolidRect as SolidRect131p7hyzlx7j8,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addTo as addTo25e29vq105prw,
  alpha_1 as alphaher384qrj9q4,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  xy_0 as xy1gb51vhy014mx,
};
//endregion
